import { graphqlApi } from '@/graphql'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Date: { input: any; output: any }
  DateTime: { input: any; output: any }
  Decimal: { input: any; output: any }
  JSON: { input: any; output: any }
  Time: { input: any; output: any }
  UUID: { input: any; output: any }
  Upload: { input: any; output: any }
}

export type Address = {
  __typename?: 'Address'
  applicationprofileSet: Array<ApplicationProfile>
  associatedIds: Scalars['JSON']['output']
  city: Scalars['String']['output']
  county?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  externalId: Scalars['String']['output']
  fipsCode?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  latitude?: Maybe<Scalars['Float']['output']>
  longitude?: Maybe<Scalars['Float']['output']>
  modifiedAt: Scalars['DateTime']['output']
  normalizedStreet?: Maybe<Scalars['String']['output']>
  parcelNumber?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  profileSet: Array<Profile>
  properties: Array<Property>
  situs: Scalars['JSON']['output']
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  unitNumber?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
  zipCode?: Maybe<Scalars['String']['output']>
}

export type AddressApplicationprofileSetArgs = {
  filters?: InputMaybe<ApplicationProfileFilter>
  order?: InputMaybe<ApplicationProfileOrder>
}

export type AddressProfileSetArgs = {
  filters?: InputMaybe<ProfileFilter>
  order?: InputMaybe<ProfileOrder>
}

export type AddressPropertiesArgs = {
  filters?: InputMaybe<PropertyFilter>
  order?: InputMaybe<PropertyOrder>
}

export type AddressFilter = {
  AND?: InputMaybe<AddressFilter>
  NOT?: InputMaybe<AddressFilter>
  OR?: InputMaybe<AddressFilter>
  pk: Scalars['ID']['input']
}

export type AddressInput = {
  associatedIds?: InputMaybe<Scalars['JSON']['input']>
  city: Scalars['String']['input']
  county?: InputMaybe<Scalars['String']['input']>
  fipsCode?: InputMaybe<Scalars['String']['input']>
  latitude?: InputMaybe<Scalars['Float']['input']>
  longitude?: InputMaybe<Scalars['Float']['input']>
  normalizedStreet?: InputMaybe<Scalars['String']['input']>
  parcelNumber?: InputMaybe<Scalars['String']['input']>
  situs?: InputMaybe<Scalars['JSON']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  unitNumber?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type AddressInputPartial = {
  associatedIds?: InputMaybe<Scalars['JSON']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  fipsCode?: InputMaybe<Scalars['String']['input']>
  latitude?: InputMaybe<Scalars['Float']['input']>
  longitude?: InputMaybe<Scalars['Float']['input']>
  normalizedStreet?: InputMaybe<Scalars['String']['input']>
  parcelNumber?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  situs?: InputMaybe<Scalars['JSON']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  unitNumber?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type AddressOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type AddressUpdatePayload = Address | OperationInfo

export type Alert = {
  __typename?: 'Alert'
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  key?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  status: Scalars['String']['output']
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
  values: Scalars['JSON']['output']
}

export type AlertFilter = {
  AND?: InputMaybe<AlertFilter>
  NOT?: InputMaybe<AlertFilter>
  OR?: InputMaybe<AlertFilter>
  pk: Scalars['ID']['input']
}

export type AlertInput = {
  application: OneToManyInput
  key?: InputMaybe<Scalars['String']['input']>
  message: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
  values?: InputMaybe<Scalars['JSON']['input']>
}

export type AlertInputPartial = {
  application?: InputMaybe<OneToManyInput>
  key?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  values?: InputMaybe<Scalars['JSON']['input']>
}

export type AlertOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type AlertUpdatePayload = Alert | OperationInfo

export type Application = {
  __typename?: 'Application'
  agreementEffectiveOn?: Maybe<Scalars['Date']['output']>
  alerts: Array<Alert>
  annualizedCostLimitCalcVersion?: Maybe<Scalars['Int']['output']>
  applicationCalculations: ApplicationCalculationsType
  applicationExceptions: Array<ApplicationException>
  applicationFico?: Maybe<Scalars['Decimal']['output']>
  applicationProfiles: Array<ApplicationProfile>
  applicationState: Scalars['String']['output']
  applicationStateIndex: Scalars['Int']['output']
  applicationStateLabel?: Maybe<Scalars['String']['output']>
  applicationStateModifiedAt?: Maybe<Scalars['DateTime']['output']>
  applicationpartySet: Array<ApplicationParty>
  appraisalOrders: Array<AppraisalOrder>
  atypicalityCheck?: Maybe<AtypicalityCheck>
  atypicalityCheckVersion: Scalars['Float']['output']
  avmDecline?: Maybe<Scalars['String']['output']>
  buyoutOn?: Maybe<Scalars['Date']['output']>
  callCompleted?: Maybe<Scalars['Date']['output']>
  checklist: Array<ChecklistItem>
  checklistGroups: Array<ChecklistGroup>
  contractVersionClosingInst: Scalars['String']['output']
  contractVersionFsea: Scalars['String']['output']
  contractVersionSecInst: Scalars['String']['output']
  contractVersionUpl: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<DjangoModelType>
  creditReports: Array<CreditReport>
  cxVersion: Scalars['Float']['output']
  dealTeams: Array<DealTeam>
  declarationsVersion: Scalars['Int']['output']
  delayReasons?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  docRequestApplication: Array<MultiDocumentsRequest>
  docusignEnvelopeId: Scalars['String']['output']
  dscr: Dscr
  escalations: Array<Escalation>
  estimatedCloseOn?: Maybe<Scalars['Date']['output']>
  exchangeRateCalcVersion?: Maybe<Scalars['Int']['output']>
  expenses: Array<Expense>
  expensesCalculations: ExpensesCalculationsType
  expireAt?: Maybe<Scalars['Time']['output']>
  externalId: Scalars['String']['output']
  fedReferenceNumber?: Maybe<Scalars['String']['output']>
  finalDispositionOn?: Maybe<Scalars['Date']['output']>
  followUp?: Maybe<Scalars['Date']['output']>
  fundingDate?: Maybe<Scalars['Date']['output']>
  hasOfferError: Scalars['Boolean']['output']
  hasPoaDocument?: Maybe<Scalars['Boolean']['output']>
  hoiSet: Array<Hoi>
  hubspotContactId?: Maybe<Scalars['String']['output']>
  icsEffectiveDate?: Maybe<Scalars['Date']['output']>
  icsIssueDate?: Maybe<Scalars['Date']['output']>
  icsPreparedBy?: Maybe<Scalars['String']['output']>
  icsSignedOn?: Maybe<Scalars['Date']['output']>
  id: Scalars['Int']['output']
  ieClosingCostsPaidBeforeClosing?: Maybe<Scalars['Decimal']['output']>
  ieFeesExpensesAndCredits?: Maybe<Scalars['Decimal']['output']>
  ieInvestmentPayment?: Maybe<Scalars['Decimal']['output']>
  ieIssueDate?: Maybe<Scalars['Date']['output']>
  iePayoffAmount?: Maybe<Scalars['Decimal']['output']>
  iePreparedBy?: Maybe<Scalars['String']['output']>
  isLockedIe?: Maybe<Scalars['Boolean']['output']>
  kickBack: Array<KickBack>
  lossMeta?: Maybe<Scalars['JSON']['output']>
  lossReason?: Maybe<Scalars['String']['output']>
  lossType?: Maybe<Scalars['String']['output']>
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>
  maxOfferInvestment?: Maybe<Scalars['Decimal']['output']>
  messagesApplication: Array<Messages>
  modifiedAt: Scalars['DateTime']['output']
  name?: Maybe<Scalars['String']['output']>
  noMortgageDebt: Scalars['Boolean']['output']
  notes: Array<Notes>
  notificationsApplication: Array<Notifications>
  offerCalculations: OfferCalculationsType
  offerInvestment?: Maybe<Scalars['Decimal']['output']>
  offers: Array<Offer>
  opsDelayReasons?: Maybe<Scalars['String']['output']>
  orders: Array<TitleOrder>
  outreachOpportunityId?: Maybe<Scalars['Int']['output']>
  overrides?: Maybe<Overrides>
  parties: Array<Party>
  pendingRecordingOn?: Maybe<Scalars['DateTime']['output']>
  pk: Scalars['ID']['output']
  poaFlag?: Maybe<Scalars['Boolean']['output']>
  previousApplicationState?: Maybe<Scalars['String']['output']>
  pricingVersion?: Maybe<Scalars['Float']['output']>
  profiles: Array<Profile>
  property?: Maybe<Property>
  propertyFlags: Array<PropertyFlag>
  readOnlyRequestedInvestment: Scalars['Boolean']['output']
  recordingOn?: Maybe<Scalars['Date']['output']>
  referralSource?: Maybe<Scalars['String']['output']>
  referredDeal?: Maybe<Scalars['Boolean']['output']>
  refinanceOf?: Maybe<DjangoModelType>
  relatedApplicationsToAddress: Array<Application>
  relatedApplicationsToSsn: Array<Application>
  requestedInvestment?: Maybe<Scalars['Decimal']['output']>
  salesCommentary?: Maybe<Scalars['String']['output']>
  semanticCalcVersion?: Maybe<Scalars['String']['output']>
  servicingTasks: Array<ServicingTaskGroup>
  sharepointItemId?: Maybe<Scalars['String']['output']>
  signDate?: Maybe<Scalars['Date']['output']>
  snapshots: Array<Snapshot>
  stateChangeHistory: Scalars['String']['output']
  streamingNotes: Array<StreamingNote>
  subLossReasons: Array<Scalars['String']['output']>
  subscribers: Array<Subscriber>
  tasksVersion: Scalars['Float']['output']
  termYears?: Maybe<Scalars['Int']['output']>
  titleCalculations: TitleCalculationsType
  titleReport?: Maybe<TitleReport>
  tradelines: Array<Tradeline>
  tradelinesCalculations: TradelinesCalculationsType
  useOfProceeds?: Maybe<Scalars['String']['output']>
  useOfProceedsSet: Array<UseOfProceeds>
  uuid: Scalars['UUID']['output']
  uwSubmittedAt?: Maybe<Scalars['DateTime']['output']>
  valuations: Array<Valuation>
  valuationsCalculations: ValuationsCalculationsType
  wireToCustomerOn?: Maybe<Scalars['Date']['output']>
  wireToEscrowOn?: Maybe<Scalars['Date']['output']>
  workQueues?: Maybe<WorkQueues>
  zendeskTickets: Array<ZendeskTicket>
}

export type ApplicationAlertsArgs = {
  filters?: InputMaybe<AlertFilter>
  order?: InputMaybe<AlertOrder>
}

export type ApplicationApplicationExceptionsArgs = {
  filters?: InputMaybe<ApplicationExceptionFilter>
  order?: InputMaybe<ApplicationExceptionOrder>
}

export type ApplicationApplicationProfilesArgs = {
  filters?: InputMaybe<ApplicationProfileFilter>
  order?: InputMaybe<ApplicationProfileOrder>
}

export type ApplicationApplicationpartySetArgs = {
  filters?: InputMaybe<ApplicationPartyFilter>
  order?: InputMaybe<ApplicationPartyOrder>
}

export type ApplicationAppraisalOrdersArgs = {
  filters?: InputMaybe<AppraisalOrderFilter>
  order?: InputMaybe<AppraisalOrderOrder>
}

export type ApplicationChecklistArgs = {
  filters?: InputMaybe<ChecklistItemFilter>
  order?: InputMaybe<ChecklistItemOrder>
}

export type ApplicationChecklistGroupsArgs = {
  filters?: InputMaybe<ChecklistGroupFilter>
  order?: InputMaybe<ChecklistGroupOrder>
}

export type ApplicationCreditReportsArgs = {
  filters?: InputMaybe<CreditReportFilter>
  order?: InputMaybe<CreditReportOrder>
}

export type ApplicationDealTeamsArgs = {
  filters?: InputMaybe<DealTeamFilter>
  order?: InputMaybe<DealTeamOrder>
}

export type ApplicationDocRequestApplicationArgs = {
  filters?: InputMaybe<MultiDocumentsRequestFilter>
  order?: InputMaybe<MultiDocumentsRequestOrder>
}

export type ApplicationEscalationsArgs = {
  filters?: InputMaybe<EscalationFilter>
  order?: InputMaybe<EscalationOrder>
}

export type ApplicationExpensesArgs = {
  filters?: InputMaybe<ExpenseFilter>
  order?: InputMaybe<ExpenseOrder>
}

export type ApplicationHoiSetArgs = {
  filters?: InputMaybe<HoiFilter>
  order?: InputMaybe<HoiOrder>
}

export type ApplicationKickBackArgs = {
  filters?: InputMaybe<KickBackFilter>
  order?: InputMaybe<KickBackOrder>
}

export type ApplicationMessagesApplicationArgs = {
  filters?: InputMaybe<MessagesFilter>
  order?: InputMaybe<MessagesOrder>
}

export type ApplicationNotesArgs = {
  filters?: InputMaybe<NotesFilter>
  order?: InputMaybe<NotesOrder>
}

export type ApplicationNotificationsApplicationArgs = {
  filters?: InputMaybe<NotificationsFilter>
  order?: InputMaybe<NotificationsOrder>
}

export type ApplicationOffersArgs = {
  filters?: InputMaybe<OfferFilter>
  order?: InputMaybe<OfferOrder>
}

export type ApplicationOrdersArgs = {
  filters?: InputMaybe<TitleOrderFilter>
  order?: InputMaybe<TitleOrderOrder>
}

export type ApplicationPartiesArgs = {
  filters?: InputMaybe<PartyFilter>
  order?: InputMaybe<PartyOrder>
}

export type ApplicationProfilesArgs = {
  filters?: InputMaybe<ProfileFilter>
  order?: InputMaybe<ProfileOrder>
}

export type ApplicationPropertyFlagsArgs = {
  filters?: InputMaybe<PropertyFlagFilter>
  order?: InputMaybe<PropertyFlagOrder>
}

export type ApplicationRelatedApplicationsToAddressArgs = {
  filters?: InputMaybe<ApplicationFilter>
  order?: InputMaybe<ApplicationOrder>
}

export type ApplicationRelatedApplicationsToSsnArgs = {
  filters?: InputMaybe<ApplicationFilter>
  order?: InputMaybe<ApplicationOrder>
}

export type ApplicationServicingTasksArgs = {
  filters?: InputMaybe<ServicingTaskGroupFilter>
  order?: InputMaybe<ServicingTaskGroupOrder>
}

export type ApplicationSnapshotsArgs = {
  filters?: InputMaybe<SnapshotFilter>
  order?: InputMaybe<SnapshotOrder>
}

export type ApplicationStreamingNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type ApplicationSubscribersArgs = {
  filters?: InputMaybe<SubscriberFilter>
  order?: InputMaybe<SubscriberOrder>
}

export type ApplicationTradelinesArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
}

export type ApplicationUseOfProceedsSetArgs = {
  filters?: InputMaybe<UseOfProceedsFilter>
  order?: InputMaybe<UseOfProceedsOrder>
}

export type ApplicationValuationsArgs = {
  filters?: InputMaybe<ValuationFilter>
  order?: InputMaybe<ValuationOrder>
}

export type ApplicationZendeskTicketsArgs = {
  filters?: InputMaybe<ZendeskTicketFilter>
  order?: InputMaybe<ZendeskTicketOrder>
}

export type ApplicationCalculationsType = {
  __typename?: 'ApplicationCalculationsType'
  _cachedAt?: Maybe<Scalars['DateTime']['output']>
  bypass10Percent?: Maybe<Scalars['Boolean']['output']>
  calcApplicationFico?: Maybe<Scalars['Float']['output']>
  dti?: Maybe<Scalars['Float']['output']>
  dtiPrePayoffs?: Maybe<Scalars['Float']['output']>
  exceptionRequired?: Maybe<Scalars['Boolean']['output']>
  isDtiOverriden?: Maybe<Scalars['Boolean']['output']>
  isLockedIe?: Maybe<Scalars['Boolean']['output']>
  isRefinance?: Maybe<Scalars['Boolean']['output']>
  isServicing?: Maybe<Scalars['Boolean']['output']>
  last90Deliquency?: Maybe<Scalars['Date']['output']>
  last120Deliquency?: Maybe<Scalars['Date']['output']>
  lastBankruptcy?: Maybe<Scalars['Date']['output']>
  lastDeedInLieu?: Maybe<Scalars['Date']['output']>
  lastForeclosure?: Maybe<Scalars['Date']['output']>
  lastShortSale?: Maybe<Scalars['Date']['output']>
  referralPoints?: Maybe<Scalars['Float']['output']>
  referringAmount?: Maybe<Scalars['Float']['output']>
}

export type ApplicationException = {
  __typename?: 'ApplicationException'
  applicable?: Maybe<Scalars['Boolean']['output']>
  applicableAutomated?: Maybe<Scalars['Boolean']['output']>
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  exceptionType: Scalars['String']['output']
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  uuid: Scalars['UUID']['output']
}

export type ApplicationExceptionFilter = {
  AND?: InputMaybe<ApplicationExceptionFilter>
  NOT?: InputMaybe<ApplicationExceptionFilter>
  OR?: InputMaybe<ApplicationExceptionFilter>
  pk: Scalars['ID']['input']
}

export type ApplicationExceptionInput = {
  applicable?: InputMaybe<Scalars['Boolean']['input']>
  applicableAutomated?: InputMaybe<Scalars['Boolean']['input']>
  application: OneToManyInput
  exceptionType: Scalars['String']['input']
}

export type ApplicationExceptionInputPartial = {
  applicable?: InputMaybe<Scalars['Boolean']['input']>
  applicableAutomated?: InputMaybe<Scalars['Boolean']['input']>
  application?: InputMaybe<OneToManyInput>
  exceptionType?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
}

export type ApplicationExceptionOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ApplicationExceptionUpdatePayload = ApplicationException | OperationInfo

export type ApplicationFilter = {
  AND?: InputMaybe<ApplicationFilter>
  NOT?: InputMaybe<ApplicationFilter>
  OR?: InputMaybe<ApplicationFilter>
  id: Scalars['Int']['input']
  pk: Scalars['ID']['input']
}

export type ApplicationInput = {
  agreementEffectiveOn?: InputMaybe<Scalars['Date']['input']>
  annualizedCostLimitCalcVersion?: InputMaybe<Scalars['Int']['input']>
  applicationFico?: InputMaybe<Scalars['Decimal']['input']>
  applicationState?: InputMaybe<Scalars['String']['input']>
  applicationStateIndex?: InputMaybe<Scalars['Int']['input']>
  applicationStateModifiedAt?: InputMaybe<Scalars['DateTime']['input']>
  atypicalityCheckVersion?: InputMaybe<Scalars['Float']['input']>
  avmDecline?: InputMaybe<Scalars['String']['input']>
  buyoutOn?: InputMaybe<Scalars['Date']['input']>
  callCompleted?: InputMaybe<Scalars['Date']['input']>
  contractVersionClosingInst?: InputMaybe<Scalars['String']['input']>
  contractVersionFsea?: InputMaybe<Scalars['String']['input']>
  contractVersionSecInst?: InputMaybe<Scalars['String']['input']>
  contractVersionUpl?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<OneToManyInput>
  cxVersion?: InputMaybe<Scalars['Float']['input']>
  declarationsVersion?: InputMaybe<Scalars['Int']['input']>
  delayReasons?: InputMaybe<Scalars['String']['input']>
  docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>
  estimatedCloseOn?: InputMaybe<Scalars['Date']['input']>
  exchangeRateCalcVersion?: InputMaybe<Scalars['Int']['input']>
  expireAt?: InputMaybe<Scalars['Time']['input']>
  fedReferenceNumber?: InputMaybe<Scalars['String']['input']>
  finalDispositionOn?: InputMaybe<Scalars['Date']['input']>
  followUp?: InputMaybe<Scalars['Date']['input']>
  fundingDate?: InputMaybe<Scalars['Date']['input']>
  hasOfferError?: InputMaybe<Scalars['Boolean']['input']>
  hubspotContactId?: InputMaybe<Scalars['String']['input']>
  icsEffectiveDate?: InputMaybe<Scalars['Date']['input']>
  icsIssueDate?: InputMaybe<Scalars['Date']['input']>
  icsPreparedBy?: InputMaybe<Scalars['String']['input']>
  icsSignedOn?: InputMaybe<Scalars['Date']['input']>
  ieClosingCostsPaidBeforeClosing?: InputMaybe<Scalars['Decimal']['input']>
  ieFeesExpensesAndCredits?: InputMaybe<Scalars['Decimal']['input']>
  ieInvestmentPayment?: InputMaybe<Scalars['Decimal']['input']>
  ieIssueDate?: InputMaybe<Scalars['Date']['input']>
  iePayoffAmount?: InputMaybe<Scalars['Decimal']['input']>
  iePreparedBy?: InputMaybe<Scalars['String']['input']>
  lossMeta?: InputMaybe<Scalars['JSON']['input']>
  lossReason?: InputMaybe<Scalars['String']['input']>
  lossType?: InputMaybe<Scalars['String']['input']>
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>
  maxOfferInvestment?: InputMaybe<Scalars['Decimal']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  noMortgageDebt?: InputMaybe<Scalars['Boolean']['input']>
  offerInvestment?: InputMaybe<Scalars['Decimal']['input']>
  opsDelayReasons?: InputMaybe<Scalars['String']['input']>
  outreachOpportunityId?: InputMaybe<Scalars['Int']['input']>
  pendingRecordingOn?: InputMaybe<Scalars['DateTime']['input']>
  poaFlag?: InputMaybe<Scalars['Boolean']['input']>
  previousApplicationState?: InputMaybe<Scalars['String']['input']>
  pricingVersion?: InputMaybe<Scalars['Float']['input']>
  property?: InputMaybe<OneToManyInput>
  readOnlyRequestedInvestment?: InputMaybe<Scalars['Boolean']['input']>
  recordingOn?: InputMaybe<Scalars['Date']['input']>
  refinanceOf?: InputMaybe<OneToManyInput>
  requestedInvestment?: InputMaybe<Scalars['Decimal']['input']>
  salesCommentary?: InputMaybe<Scalars['String']['input']>
  semanticCalcVersion?: InputMaybe<Scalars['String']['input']>
  sharepointItemId?: InputMaybe<Scalars['String']['input']>
  signDate?: InputMaybe<Scalars['Date']['input']>
  stateChangeHistory?: InputMaybe<Scalars['String']['input']>
  tasksVersion?: InputMaybe<Scalars['Float']['input']>
  useOfProceeds?: InputMaybe<Scalars['String']['input']>
  uwSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>
  wireToCustomerOn?: InputMaybe<Scalars['Date']['input']>
  wireToEscrowOn?: InputMaybe<Scalars['Date']['input']>
}

export type ApplicationInputPartial = {
  agreementEffectiveOn?: InputMaybe<Scalars['Date']['input']>
  annualizedCostLimitCalcVersion?: InputMaybe<Scalars['Int']['input']>
  applicationFico?: InputMaybe<Scalars['Decimal']['input']>
  applicationState?: InputMaybe<Scalars['String']['input']>
  applicationStateIndex?: InputMaybe<Scalars['Int']['input']>
  applicationStateModifiedAt?: InputMaybe<Scalars['DateTime']['input']>
  atypicalityCheckVersion?: InputMaybe<Scalars['Float']['input']>
  avmDecline?: InputMaybe<Scalars['String']['input']>
  buyoutOn?: InputMaybe<Scalars['Date']['input']>
  callCompleted?: InputMaybe<Scalars['Date']['input']>
  contractVersionClosingInst?: InputMaybe<Scalars['String']['input']>
  contractVersionFsea?: InputMaybe<Scalars['String']['input']>
  contractVersionSecInst?: InputMaybe<Scalars['String']['input']>
  contractVersionUpl?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<OneToManyInput>
  cxVersion?: InputMaybe<Scalars['Float']['input']>
  declarationsVersion?: InputMaybe<Scalars['Int']['input']>
  delayReasons?: InputMaybe<Scalars['String']['input']>
  docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>
  estimatedCloseOn?: InputMaybe<Scalars['Date']['input']>
  exchangeRateCalcVersion?: InputMaybe<Scalars['Int']['input']>
  expireAt?: InputMaybe<Scalars['Time']['input']>
  fedReferenceNumber?: InputMaybe<Scalars['String']['input']>
  finalDispositionOn?: InputMaybe<Scalars['Date']['input']>
  followUp?: InputMaybe<Scalars['Date']['input']>
  fundingDate?: InputMaybe<Scalars['Date']['input']>
  hasOfferError?: InputMaybe<Scalars['Boolean']['input']>
  hubspotContactId?: InputMaybe<Scalars['String']['input']>
  icsEffectiveDate?: InputMaybe<Scalars['Date']['input']>
  icsIssueDate?: InputMaybe<Scalars['Date']['input']>
  icsPreparedBy?: InputMaybe<Scalars['String']['input']>
  icsSignedOn?: InputMaybe<Scalars['Date']['input']>
  ieClosingCostsPaidBeforeClosing?: InputMaybe<Scalars['Decimal']['input']>
  ieFeesExpensesAndCredits?: InputMaybe<Scalars['Decimal']['input']>
  ieInvestmentPayment?: InputMaybe<Scalars['Decimal']['input']>
  ieIssueDate?: InputMaybe<Scalars['Date']['input']>
  iePayoffAmount?: InputMaybe<Scalars['Decimal']['input']>
  iePreparedBy?: InputMaybe<Scalars['String']['input']>
  lossMeta?: InputMaybe<Scalars['JSON']['input']>
  lossReason?: InputMaybe<Scalars['String']['input']>
  lossType?: InputMaybe<Scalars['String']['input']>
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>
  maxOfferInvestment?: InputMaybe<Scalars['Decimal']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  noMortgageDebt?: InputMaybe<Scalars['Boolean']['input']>
  offerInvestment?: InputMaybe<Scalars['Decimal']['input']>
  opsDelayReasons?: InputMaybe<Scalars['String']['input']>
  outreachOpportunityId?: InputMaybe<Scalars['Int']['input']>
  pendingRecordingOn?: InputMaybe<Scalars['DateTime']['input']>
  pk: Scalars['ID']['input']
  poaFlag?: InputMaybe<Scalars['Boolean']['input']>
  previousApplicationState?: InputMaybe<Scalars['String']['input']>
  pricingVersion?: InputMaybe<Scalars['Float']['input']>
  property?: InputMaybe<OneToManyInput>
  readOnlyRequestedInvestment?: InputMaybe<Scalars['Boolean']['input']>
  recordingOn?: InputMaybe<Scalars['Date']['input']>
  refinanceOf?: InputMaybe<OneToManyInput>
  requestedInvestment?: InputMaybe<Scalars['Decimal']['input']>
  salesCommentary?: InputMaybe<Scalars['String']['input']>
  semanticCalcVersion?: InputMaybe<Scalars['String']['input']>
  sharepointItemId?: InputMaybe<Scalars['String']['input']>
  signDate?: InputMaybe<Scalars['Date']['input']>
  stateChangeHistory?: InputMaybe<Scalars['String']['input']>
  tasksVersion?: InputMaybe<Scalars['Float']['input']>
  useOfProceeds?: InputMaybe<Scalars['String']['input']>
  uwSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>
  wireToCustomerOn?: InputMaybe<Scalars['Date']['input']>
  wireToEscrowOn?: InputMaybe<Scalars['Date']['input']>
}

export type ApplicationOrder = {
  id?: InputMaybe<Scalars['Int']['input']>
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ApplicationParty = {
  __typename?: 'ApplicationParty'
  application: Application
  applicationPartyRelated?: Maybe<DjangoModelType>
  applicationPartyType: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  party: Party
  pk: Scalars['ID']['output']
  profileRelated?: Maybe<DjangoModelType>
  uuid: Scalars['UUID']['output']
}

export type ApplicationPartyFilter = {
  AND?: InputMaybe<ApplicationPartyFilter>
  NOT?: InputMaybe<ApplicationPartyFilter>
  OR?: InputMaybe<ApplicationPartyFilter>
  pk: Scalars['ID']['input']
}

export type ApplicationPartyInput = {
  application: OneToManyInput
  applicationPartyRelated?: InputMaybe<OneToOneInput>
  applicationPartyType?: InputMaybe<Scalars['String']['input']>
  party: OneToManyInput
  profileRelated?: InputMaybe<OneToOneInput>
}

export type ApplicationPartyInputPartial = {
  application?: InputMaybe<OneToManyInput>
  applicationPartyRelated?: InputMaybe<OneToOneInput>
  applicationPartyType?: InputMaybe<Scalars['String']['input']>
  party?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  profileRelated?: InputMaybe<OneToOneInput>
}

export type ApplicationPartyOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ApplicationPartyUpdatePayload = ApplicationParty | OperationInfo

export type ApplicationProfile = {
  __typename?: 'ApplicationProfile'
  application: Application
  appliedAt: Scalars['DateTime']['output']
  assets: Array<Asset>
  backgroundTasks: Array<BackgroundTask>
  coBorrower: Array<Tradeline>
  createdAt: Scalars['DateTime']['output']
  creditReportApplicants: Array<CreditReportApplicant>
  creditReports: Array<CreditReport>
  currentCreditReport?: Maybe<DjangoModelType>
  customerActions: Array<CustomerAction>
  declarations: Array<Declaration>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  documents: Array<Document>
  docusignEnvelopeSigner: Array<DocusignEnvelopeApplicationProfile>
  docusignEnvelopes: Array<DocusignEnvelope>
  excludedFromSignatures: Scalars['Boolean']['output']
  explanation?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  idExpirationDate?: Maybe<Scalars['Date']['output']>
  incomes: Array<Income>
  marriedToProfile?: Maybe<DjangoModelType>
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  position: Scalars['Int']['output']
  profile: Profile
  profileType?: Maybe<Scalars['String']['output']>
  servicingTasks: Array<ServicingTask>
  titleType?: Maybe<Scalars['String']['output']>
  tradelineSet: Array<Tradeline>
  userIncomes: Array<UserIncome>
  uuid: Scalars['UUID']['output']
  verifiedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ApplicationProfileAssetsArgs = {
  filters?: InputMaybe<AssetFilter>
  order?: InputMaybe<AssetOrder>
}

export type ApplicationProfileBackgroundTasksArgs = {
  filters?: InputMaybe<BackgroundTaskFilter>
  order?: InputMaybe<BackgroundTaskOrder>
}

export type ApplicationProfileCoBorrowerArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
}

export type ApplicationProfileCreditReportApplicantsArgs = {
  filters?: InputMaybe<CreditReportApplicantFilter>
  order?: InputMaybe<CreditReportApplicantOrder>
}

export type ApplicationProfileCreditReportsArgs = {
  filters?: InputMaybe<CreditReportFilter>
  order?: InputMaybe<CreditReportOrder>
}

export type ApplicationProfileCustomerActionsArgs = {
  filters?: InputMaybe<CustomerActionFilter>
  order?: InputMaybe<CustomerActionOrder>
}

export type ApplicationProfileDeclarationsArgs = {
  filters?: InputMaybe<DeclarationFilter>
  order?: InputMaybe<DeclarationOrder>
}

export type ApplicationProfileDocumentsArgs = {
  filters?: InputMaybe<DocumentFilter>
  order?: InputMaybe<DocumentOrder>
}

export type ApplicationProfileDocusignEnvelopeSignerArgs = {
  filters?: InputMaybe<DocusignEnvelopeApplicationProfileFilter>
  order?: InputMaybe<DocusignEnvelopeApplicationProfileOrder>
}

export type ApplicationProfileDocusignEnvelopesArgs = {
  filters?: InputMaybe<DocusignEnvelopeFilter>
  order?: InputMaybe<DocusignEnvelopeOrder>
}

export type ApplicationProfileIncomesArgs = {
  filters?: InputMaybe<IncomeFilter>
  order?: InputMaybe<IncomeOrder>
}

export type ApplicationProfileServicingTasksArgs = {
  filters?: InputMaybe<ServicingTaskFilter>
  order?: InputMaybe<ServicingTaskOrder>
}

export type ApplicationProfileTradelineSetArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
}

export type ApplicationProfileUserIncomesArgs = {
  filters?: InputMaybe<UserIncomeFilter>
  order?: InputMaybe<UserIncomeOrder>
}

export type ApplicationProfileFilter = {
  AND?: InputMaybe<ApplicationProfileFilter>
  NOT?: InputMaybe<ApplicationProfileFilter>
  OR?: InputMaybe<ApplicationProfileFilter>
  pk: Scalars['ID']['input']
}

export type ApplicationProfileInput = {
  application: OneToManyInput
  appliedAt?: InputMaybe<Scalars['DateTime']['input']>
  currentCreditReport?: InputMaybe<OneToManyInput>
  excludedFromSignatures?: InputMaybe<Scalars['Boolean']['input']>
  explanation?: InputMaybe<Scalars['String']['input']>
  idExpirationDate?: InputMaybe<Scalars['Date']['input']>
  marriedToProfile?: InputMaybe<OneToOneInput>
  position: Scalars['Int']['input']
  profile: OneToManyInput
  profileType?: InputMaybe<Scalars['String']['input']>
  titleType?: InputMaybe<Scalars['String']['input']>
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ApplicationProfileInputPartial = {
  application?: InputMaybe<OneToManyInput>
  appliedAt?: InputMaybe<Scalars['DateTime']['input']>
  currentCreditReport?: InputMaybe<OneToManyInput>
  excludedFromSignatures?: InputMaybe<Scalars['Boolean']['input']>
  explanation?: InputMaybe<Scalars['String']['input']>
  idExpirationDate?: InputMaybe<Scalars['Date']['input']>
  marriedToProfile?: InputMaybe<OneToOneInput>
  pk: Scalars['ID']['input']
  position?: InputMaybe<Scalars['Int']['input']>
  profile?: InputMaybe<OneToManyInput>
  profileType?: InputMaybe<Scalars['String']['input']>
  titleType?: InputMaybe<Scalars['String']['input']>
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ApplicationProfileOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ApplicationProfileUpdatePayload = ApplicationProfile | OperationInfo

export type ApplicationUpdatePayload = Application | OperationInfo

export type AppraisalOrder = {
  __typename?: 'AppraisalOrder'
  application: Application
  city?: Maybe<Scalars['String']['output']>
  condition?: Maybe<Scalars['String']['output']>
  county?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  datetime?: Maybe<Scalars['DateTime']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  estimatedValue?: Maybe<Scalars['Decimal']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isSuccess?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  loanOfficerEmail?: Maybe<Scalars['String']['output']>
  loanOfficerFirstName?: Maybe<Scalars['String']['output']>
  loanOfficerLastName?: Maybe<Scalars['String']['output']>
  middleName?: Maybe<Scalars['String']['output']>
  modifiedAt: Scalars['DateTime']['output']
  newLoanAmount?: Maybe<Scalars['Decimal']['output']>
  newLoanNumber?: Maybe<Scalars['String']['output']>
  orderNumber?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  propertyType?: Maybe<Scalars['String']['output']>
  reportType?: Maybe<Scalars['String']['output']>
  solarPath?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetName?: Maybe<Scalars['String']['output']>
  unitNumber?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
  vendorInstructions?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type AppraisalOrderFilter = {
  AND?: InputMaybe<AppraisalOrderFilter>
  NOT?: InputMaybe<AppraisalOrderFilter>
  OR?: InputMaybe<AppraisalOrderFilter>
  pk: Scalars['ID']['input']
}

export type AppraisalOrderInput = {
  application: OneToManyInput
  city?: InputMaybe<Scalars['String']['input']>
  condition?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  datetime?: InputMaybe<Scalars['DateTime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedValue?: InputMaybe<Scalars['Decimal']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  loanOfficerEmail?: InputMaybe<Scalars['String']['input']>
  loanOfficerFirstName?: InputMaybe<Scalars['String']['input']>
  loanOfficerLastName?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  newLoanAmount?: InputMaybe<Scalars['Decimal']['input']>
  newLoanNumber?: InputMaybe<Scalars['String']['input']>
  orderNumber?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  reportType?: InputMaybe<Scalars['String']['input']>
  solarPath?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName?: InputMaybe<Scalars['String']['input']>
  unitNumber?: InputMaybe<Scalars['String']['input']>
  vendorInstructions?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type AppraisalOrderInputPartial = {
  application?: InputMaybe<OneToManyInput>
  city?: InputMaybe<Scalars['String']['input']>
  condition?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  datetime?: InputMaybe<Scalars['DateTime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedValue?: InputMaybe<Scalars['Decimal']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  loanOfficerEmail?: InputMaybe<Scalars['String']['input']>
  loanOfficerFirstName?: InputMaybe<Scalars['String']['input']>
  loanOfficerLastName?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  newLoanAmount?: InputMaybe<Scalars['Decimal']['input']>
  newLoanNumber?: InputMaybe<Scalars['String']['input']>
  orderNumber?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  propertyType?: InputMaybe<Scalars['String']['input']>
  reportType?: InputMaybe<Scalars['String']['input']>
  solarPath?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName?: InputMaybe<Scalars['String']['input']>
  unitNumber?: InputMaybe<Scalars['String']['input']>
  vendorInstructions?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type AppraisalOrderOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type AppraisalOrderUpdatePayload = AppraisalOrder | OperationInfo

export type Asset = {
  __typename?: 'Asset'
  applicationProfile: ApplicationProfile
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
  value: Scalars['Int']['output']
}

export type AssetFilter = {
  AND?: InputMaybe<AssetFilter>
  NOT?: InputMaybe<AssetFilter>
  OR?: InputMaybe<AssetFilter>
  pk: Scalars['ID']['input']
}

export type AssetInput = {
  applicationProfile: OneToManyInput
  type: Scalars['String']['input']
  value?: InputMaybe<Scalars['Int']['input']>
}

export type AssetInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  type?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Int']['input']>
}

export type AssetOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type AssetUpdatePayload = Asset | OperationInfo

export type AtypicalityCheck = {
  __typename?: 'AtypicalityCheck'
  application: Application
  bkfsPopulationDensity?: Maybe<Scalars['Float']['output']>
  bkfsPropertyAddress?: Maybe<Scalars['String']['output']>
  bkfsPropertyAddressCounty?: Maybe<Scalars['String']['output']>
  bkfsPropertyBaths?: Maybe<Scalars['Int']['output']>
  bkfsPropertyBeds?: Maybe<Scalars['Decimal']['output']>
  bkfsPropertyLatitude?: Maybe<Scalars['Float']['output']>
  bkfsPropertyLivingSqft?: Maybe<Scalars['Int']['output']>
  bkfsPropertyLongitude?: Maybe<Scalars['Float']['output']>
  bkfsPropertyLotAcres?: Maybe<Scalars['Decimal']['output']>
  bkfsPropertyType?: Maybe<Scalars['String']['output']>
  bkfsYearBuilt?: Maybe<Scalars['Int']['output']>
  clIsManufacturedHome?: Maybe<Scalars['Boolean']['output']>
  clPropertyAddress?: Maybe<Scalars['String']['output']>
  clPropertyAddressCounty?: Maybe<Scalars['String']['output']>
  clPropertyBaths?: Maybe<Scalars['Int']['output']>
  clPropertyBeds?: Maybe<Scalars['Int']['output']>
  clPropertyLatitude?: Maybe<Scalars['Float']['output']>
  clPropertyLivingSqft?: Maybe<Scalars['Int']['output']>
  clPropertyLongitude?: Maybe<Scalars['Float']['output']>
  clPropertyLotAcres?: Maybe<Scalars['Decimal']['output']>
  clPropertyLotSizeSqft?: Maybe<Scalars['Int']['output']>
  clPropertyType?: Maybe<Scalars['String']['output']>
  clYearBuilt?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  hasHometapInquiry?: Maybe<Scalars['Boolean']['output']>
  hcCompsAvmPercentile?: Maybe<Scalars['Decimal']['output']>
  hcCompsFifthPercentile?: Maybe<Scalars['Decimal']['output']>
  hcCompsNinetyFifthPercentile?: Maybe<Scalars['Decimal']['output']>
  hcCompsNumber?: Maybe<Scalars['Decimal']['output']>
  hcNeighborhoodFifthPercentile?: Maybe<Scalars['Decimal']['output']>
  hcNeighborhoodNinetyFifthPercentile?: Maybe<Scalars['Decimal']['output']>
  hcPropertyLivingSqft?: Maybe<Scalars['Int']['output']>
  hcValuePerSqft?: Maybe<Scalars['Decimal']['output']>
  hpaForecastHcThirtySixMonth?: Maybe<Scalars['Decimal']['output']>
  hpaForecastHcTwelveMonth?: Maybe<Scalars['Decimal']['output']>
  hpaForecastHcTwelveMonthRisk?: Maybe<Scalars['Decimal']['output']>
  hpaForecastHcTwentyFourMonth?: Maybe<Scalars['Decimal']['output']>
  id: Scalars['ID']['output']
  is90DayMortgageLate?: Maybe<Scalars['Boolean']['output']>
  isBankruptcyLast5Years?: Maybe<Scalars['Boolean']['output']>
  isExoticMortgage?: Maybe<Scalars['Boolean']['output']>
  isMtgInquires?: Maybe<Scalars['Boolean']['output']>
  isUnlock3rdLien?: Maybe<Scalars['Boolean']['output']>
  last90Deliquency?: Maybe<Scalars['Date']['output']>
  last120Deliquency?: Maybe<Scalars['Date']['output']>
  lastBankruptcy?: Maybe<Scalars['Date']['output']>
  lastForbearance?: Maybe<Scalars['Date']['output']>
  lastForeclosure?: Maybe<Scalars['Date']['output']>
  lastMortageCollection?: Maybe<Scalars['Date']['output']>
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  salesCommentary?: Maybe<Scalars['String']['output']>
  uamContext?: Maybe<Scalars['String']['output']>
  uamExceptionReview?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
  yardDebrisCoverageSqft?: Maybe<Scalars['Float']['output']>
}

export type AtypicalityCheckFilter = {
  AND?: InputMaybe<AtypicalityCheckFilter>
  NOT?: InputMaybe<AtypicalityCheckFilter>
  OR?: InputMaybe<AtypicalityCheckFilter>
  pk: Scalars['ID']['input']
}

export type AtypicalityCheckInput = {
  application: OneToOneInput
  bkfsPopulationDensity?: InputMaybe<Scalars['Float']['input']>
  bkfsPropertyAddress?: InputMaybe<Scalars['String']['input']>
  bkfsPropertyAddressCounty?: InputMaybe<Scalars['String']['input']>
  bkfsPropertyBaths?: InputMaybe<Scalars['Int']['input']>
  bkfsPropertyBeds?: InputMaybe<Scalars['Decimal']['input']>
  bkfsPropertyLatitude?: InputMaybe<Scalars['Float']['input']>
  bkfsPropertyLivingSqft?: InputMaybe<Scalars['Int']['input']>
  bkfsPropertyLongitude?: InputMaybe<Scalars['Float']['input']>
  bkfsPropertyLotAcres?: InputMaybe<Scalars['Decimal']['input']>
  bkfsPropertyType?: InputMaybe<Scalars['String']['input']>
  bkfsYearBuilt?: InputMaybe<Scalars['Int']['input']>
  clIsManufacturedHome?: InputMaybe<Scalars['Boolean']['input']>
  clPropertyAddress?: InputMaybe<Scalars['String']['input']>
  clPropertyAddressCounty?: InputMaybe<Scalars['String']['input']>
  clPropertyBaths?: InputMaybe<Scalars['Int']['input']>
  clPropertyBeds?: InputMaybe<Scalars['Int']['input']>
  clPropertyLatitude?: InputMaybe<Scalars['Float']['input']>
  clPropertyLivingSqft?: InputMaybe<Scalars['Int']['input']>
  clPropertyLongitude?: InputMaybe<Scalars['Float']['input']>
  clPropertyLotAcres?: InputMaybe<Scalars['Decimal']['input']>
  clPropertyLotSizeSqft?: InputMaybe<Scalars['Int']['input']>
  clPropertyType?: InputMaybe<Scalars['String']['input']>
  clYearBuilt?: InputMaybe<Scalars['Int']['input']>
  hasHometapInquiry?: InputMaybe<Scalars['Boolean']['input']>
  hcCompsAvmPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcCompsFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcCompsNinetyFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcCompsNumber?: InputMaybe<Scalars['Decimal']['input']>
  hcNeighborhoodFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcNeighborhoodNinetyFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcPropertyLivingSqft?: InputMaybe<Scalars['Int']['input']>
  hcValuePerSqft?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcThirtySixMonth?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcTwelveMonth?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcTwelveMonthRisk?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcTwentyFourMonth?: InputMaybe<Scalars['Decimal']['input']>
  is90DayMortgageLate?: InputMaybe<Scalars['Boolean']['input']>
  isBankruptcyLast5Years?: InputMaybe<Scalars['Boolean']['input']>
  isExoticMortgage?: InputMaybe<Scalars['Boolean']['input']>
  isMtgInquires?: InputMaybe<Scalars['Boolean']['input']>
  isUnlock3rdLien?: InputMaybe<Scalars['Boolean']['input']>
  last90Deliquency?: InputMaybe<Scalars['Date']['input']>
  last120Deliquency?: InputMaybe<Scalars['Date']['input']>
  lastBankruptcy?: InputMaybe<Scalars['Date']['input']>
  lastForbearance?: InputMaybe<Scalars['Date']['input']>
  lastForeclosure?: InputMaybe<Scalars['Date']['input']>
  lastMortageCollection?: InputMaybe<Scalars['Date']['input']>
  salesCommentary?: InputMaybe<Scalars['String']['input']>
  uamContext?: InputMaybe<Scalars['String']['input']>
  uamExceptionReview?: InputMaybe<Scalars['String']['input']>
  yardDebrisCoverageSqft?: InputMaybe<Scalars['Float']['input']>
}

export type AtypicalityCheckInputPartial = {
  application?: InputMaybe<OneToOneInput>
  bkfsPopulationDensity?: InputMaybe<Scalars['Float']['input']>
  bkfsPropertyAddress?: InputMaybe<Scalars['String']['input']>
  bkfsPropertyAddressCounty?: InputMaybe<Scalars['String']['input']>
  bkfsPropertyBaths?: InputMaybe<Scalars['Int']['input']>
  bkfsPropertyBeds?: InputMaybe<Scalars['Decimal']['input']>
  bkfsPropertyLatitude?: InputMaybe<Scalars['Float']['input']>
  bkfsPropertyLivingSqft?: InputMaybe<Scalars['Int']['input']>
  bkfsPropertyLongitude?: InputMaybe<Scalars['Float']['input']>
  bkfsPropertyLotAcres?: InputMaybe<Scalars['Decimal']['input']>
  bkfsPropertyType?: InputMaybe<Scalars['String']['input']>
  bkfsYearBuilt?: InputMaybe<Scalars['Int']['input']>
  clIsManufacturedHome?: InputMaybe<Scalars['Boolean']['input']>
  clPropertyAddress?: InputMaybe<Scalars['String']['input']>
  clPropertyAddressCounty?: InputMaybe<Scalars['String']['input']>
  clPropertyBaths?: InputMaybe<Scalars['Int']['input']>
  clPropertyBeds?: InputMaybe<Scalars['Int']['input']>
  clPropertyLatitude?: InputMaybe<Scalars['Float']['input']>
  clPropertyLivingSqft?: InputMaybe<Scalars['Int']['input']>
  clPropertyLongitude?: InputMaybe<Scalars['Float']['input']>
  clPropertyLotAcres?: InputMaybe<Scalars['Decimal']['input']>
  clPropertyLotSizeSqft?: InputMaybe<Scalars['Int']['input']>
  clPropertyType?: InputMaybe<Scalars['String']['input']>
  clYearBuilt?: InputMaybe<Scalars['Int']['input']>
  hasHometapInquiry?: InputMaybe<Scalars['Boolean']['input']>
  hcCompsAvmPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcCompsFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcCompsNinetyFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcCompsNumber?: InputMaybe<Scalars['Decimal']['input']>
  hcNeighborhoodFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcNeighborhoodNinetyFifthPercentile?: InputMaybe<Scalars['Decimal']['input']>
  hcPropertyLivingSqft?: InputMaybe<Scalars['Int']['input']>
  hcValuePerSqft?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcThirtySixMonth?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcTwelveMonth?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcTwelveMonthRisk?: InputMaybe<Scalars['Decimal']['input']>
  hpaForecastHcTwentyFourMonth?: InputMaybe<Scalars['Decimal']['input']>
  is90DayMortgageLate?: InputMaybe<Scalars['Boolean']['input']>
  isBankruptcyLast5Years?: InputMaybe<Scalars['Boolean']['input']>
  isExoticMortgage?: InputMaybe<Scalars['Boolean']['input']>
  isMtgInquires?: InputMaybe<Scalars['Boolean']['input']>
  isUnlock3rdLien?: InputMaybe<Scalars['Boolean']['input']>
  last90Deliquency?: InputMaybe<Scalars['Date']['input']>
  last120Deliquency?: InputMaybe<Scalars['Date']['input']>
  lastBankruptcy?: InputMaybe<Scalars['Date']['input']>
  lastForbearance?: InputMaybe<Scalars['Date']['input']>
  lastForeclosure?: InputMaybe<Scalars['Date']['input']>
  lastMortageCollection?: InputMaybe<Scalars['Date']['input']>
  pk: Scalars['ID']['input']
  salesCommentary?: InputMaybe<Scalars['String']['input']>
  uamContext?: InputMaybe<Scalars['String']['input']>
  uamExceptionReview?: InputMaybe<Scalars['String']['input']>
  yardDebrisCoverageSqft?: InputMaybe<Scalars['Float']['input']>
}

export type AtypicalityCheckOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type AtypicalityCheckUpdatePayload = AtypicalityCheck | OperationInfo

export type BackgroundTask = {
  __typename?: 'BackgroundTask'
  action: Scalars['String']['output']
  applicationProfile: ApplicationProfile
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  failureReason?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  possibleFix?: Maybe<Scalars['String']['output']>
  state: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type BackgroundTaskFilter = {
  AND?: InputMaybe<BackgroundTaskFilter>
  NOT?: InputMaybe<BackgroundTaskFilter>
  OR?: InputMaybe<BackgroundTaskFilter>
  pk: Scalars['ID']['input']
}

export type BackgroundTaskInput = {
  action: Scalars['String']['input']
  applicationProfile: OneToManyInput
  failureReason?: InputMaybe<Scalars['String']['input']>
  possibleFix?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type BackgroundTaskInputPartial = {
  action?: InputMaybe<Scalars['String']['input']>
  applicationProfile?: InputMaybe<OneToManyInput>
  failureReason?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  possibleFix?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type BackgroundTaskOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type BackgroundTaskUpdatePayload = BackgroundTask | OperationInfo

export type CalculatedOffer = {
  __typename?: 'CalculatedOffer'
  aggregateInvestmentPayment?: Maybe<Scalars['Float']['output']>
  annualizedCostLimit?: Maybe<Scalars['Float']['output']>
  cltv?: Maybe<Scalars['Float']['output']>
  currentMinimumInvestmentSize?: Maybe<Scalars['Float']['output']>
  error?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  exchangeRate?: Maybe<Scalars['Float']['output']>
  ltv?: Maybe<Scalars['Float']['output']>
  minFico?: Maybe<Scalars['Float']['output']>
  minHomeValue?: Maybe<Scalars['Float']['output']>
  offers?: Maybe<Offers>
  thfLimit?: Maybe<Scalars['Float']['output']>
}

export type CalculatedRequestedOffer = {
  __typename?: 'CalculatedRequestedOffer'
  cltv?: Maybe<Scalars['Float']['output']>
  currentMinimumInvestmentSize?: Maybe<Scalars['Float']['output']>
  error?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  ltv?: Maybe<Scalars['Float']['output']>
  minFico?: Maybe<Scalars['Float']['output']>
  minHomeValue?: Maybe<Scalars['Float']['output']>
  thfLimit?: Maybe<Scalars['Float']['output']>
}

export type ChecklistGroup = {
  __typename?: 'ChecklistGroup'
  application: Application
  checklistItems: Array<ChecklistItem>
  createdAt: Scalars['DateTime']['output']
  delayReasons: Array<ChecklistGroupDelayReason>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  groupComments?: Maybe<Scalars['String']['output']>
  groupType: Scalars['String']['output']
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  userType: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type ChecklistGroupChecklistItemsArgs = {
  filters?: InputMaybe<ChecklistItemFilter>
  order?: InputMaybe<ChecklistItemOrder>
}

export type ChecklistGroupDelayReasonsArgs = {
  filters?: InputMaybe<ChecklistGroupDelayReasonFilter>
  order?: InputMaybe<ChecklistGroupDelayReasonOrder>
}

export type ChecklistGroupDelayReason = {
  __typename?: 'ChecklistGroupDelayReason'
  checklistGroup: ChecklistGroup
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  pk: Scalars['ID']['output']
  uuid: Scalars['UUID']['output']
}

export type ChecklistGroupDelayReasonFilter = {
  AND?: InputMaybe<ChecklistGroupDelayReasonFilter>
  NOT?: InputMaybe<ChecklistGroupDelayReasonFilter>
  OR?: InputMaybe<ChecklistGroupDelayReasonFilter>
  pk: Scalars['ID']['input']
}

export type ChecklistGroupDelayReasonOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ChecklistGroupFilter = {
  AND?: InputMaybe<ChecklistGroupFilter>
  NOT?: InputMaybe<ChecklistGroupFilter>
  OR?: InputMaybe<ChecklistGroupFilter>
  pk: Scalars['ID']['input']
}

export type ChecklistGroupOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ChecklistItem = {
  __typename?: 'ChecklistItem'
  application: Application
  auditDate?: Maybe<Scalars['Date']['output']>
  auditManager?: Maybe<DjangoModelType>
  checklistGroup: ChecklistGroup
  completedAt?: Maybe<Scalars['DateTime']['output']>
  completedBy: Profile
  condition?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isAuditPass?: Maybe<Scalars['Boolean']['output']>
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  sequenceNo?: Maybe<Scalars['Int']['output']>
  status?: Maybe<Scalars['String']['output']>
  userCreated: Scalars['Boolean']['output']
  uuid: Scalars['UUID']['output']
}

export type ChecklistItemFilter = {
  AND?: InputMaybe<ChecklistItemFilter>
  NOT?: InputMaybe<ChecklistItemFilter>
  OR?: InputMaybe<ChecklistItemFilter>
  pk: Scalars['ID']['input']
}

export type ChecklistItemOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type Company = {
  __typename?: 'Company'
  address?: Maybe<Scalars['String']['output']>
  borLicense?: Maybe<Scalars['String']['output']>
  borState?: Maybe<Scalars['String']['output']>
  contactName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  fax?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isDefault: Scalars['Boolean']['output']
  isDefaultPlaceholder: Scalars['Boolean']['output']
  mailingAddress?: Maybe<Scalars['String']['output']>
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  states: Array<State>
  trusteeState?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type CompanyStatesArgs = {
  filters?: InputMaybe<StateFilter>
  order?: InputMaybe<StateOrder>
}

export type CompanyFilter = {
  AND?: InputMaybe<CompanyFilter>
  NOT?: InputMaybe<CompanyFilter>
  OR?: InputMaybe<CompanyFilter>
  pk: Scalars['ID']['input']
}

export type CompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>
  borLicense?: InputMaybe<Scalars['String']['input']>
  borState?: InputMaybe<Scalars['String']['input']>
  contactName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  fax?: InputMaybe<Scalars['String']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  isDefaultPlaceholder?: InputMaybe<Scalars['Boolean']['input']>
  mailingAddress?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  trusteeState?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
}

export type CompanyInputPartial = {
  address?: InputMaybe<Scalars['String']['input']>
  borLicense?: InputMaybe<Scalars['String']['input']>
  borState?: InputMaybe<Scalars['String']['input']>
  contactName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  fax?: InputMaybe<Scalars['String']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  isDefaultPlaceholder?: InputMaybe<Scalars['Boolean']['input']>
  mailingAddress?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  trusteeState?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type CompanyOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type CompanyUpdatePayload = Company | OperationInfo

export type CreditReport = {
  __typename?: 'CreditReport'
  aanDenialReason?: Maybe<Array<Scalars['String']['output']>>
  applicants: Array<CreditReportApplicant>
  applicationProfiles: Array<ApplicationProfile>
  applications: Array<Application>
  confirmingSsn?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  creditFiles: Scalars['JSON']['output']
  creditRequest?: Maybe<DjangoModelType>
  creditScores: Scalars['JSON']['output']
  debtHighCredit?: Maybe<Scalars['Int']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  externalId: Scalars['String']['output']
  failReason?: Maybe<Scalars['String']['output']>
  fileNumber?: Maybe<Scalars['String']['output']>
  hasChapter11Bankruptcy?: Maybe<Scalars['Boolean']['output']>
  hasFrozenScores: Scalars['Boolean']['output']
  hasMortgageDelinquency?: Maybe<Scalars['Boolean']['output']>
  hasTimeshareTradeline?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  inquiryCount?: Maybe<Scalars['Int']['output']>
  inquiryLast90Days?: Maybe<Scalars['Boolean']['output']>
  isJoint?: Maybe<Scalars['Boolean']['output']>
  isReissue?: Maybe<Scalars['Boolean']['output']>
  isTriMerge: Scalars['Boolean']['output']
  isVantage: Scalars['Boolean']['output']
  last90Deliquency?: Maybe<Scalars['Date']['output']>
  last120Deliquency?: Maybe<Scalars['Date']['output']>
  lastBankruptcy?: Maybe<Scalars['Date']['output']>
  lastDeedInLieu?: Maybe<Scalars['Date']['output']>
  lastForeclosure?: Maybe<Scalars['Date']['output']>
  lastShortSale?: Maybe<Scalars['Date']['output']>
  modifiedAt: Scalars['DateTime']['output']
  name?: Maybe<Scalars['String']['output']>
  needsToBeDeclined?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  publicRecordsCount?: Maybe<Scalars['Int']['output']>
  reportGeneratedAt?: Maybe<Scalars['DateTime']['output']>
  reportOrderedAt?: Maybe<Scalars['Date']['output']>
  revolvingUtilization?: Maybe<Scalars['Int']['output']>
  tradelines: Array<Tradeline>
  tradelinesAutoBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesAutoCount?: Maybe<Scalars['Int']['output']>
  tradelinesAutoHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesAutoPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesAutoPaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesBalanceAmountSecured?: Maybe<Scalars['Int']['output']>
  tradelinesBalanceAmountUnsecured?: Maybe<Scalars['Int']['output']>
  tradelinesBankruptcyCount?: Maybe<Scalars['Int']['output']>
  tradelinesChargeOffCount?: Maybe<Scalars['Int']['output']>
  tradelinesClosedWoBalance?: Maybe<Scalars['Int']['output']>
  tradelinesCollectionCount?: Maybe<Scalars['Int']['output']>
  tradelinesCount?: Maybe<Scalars['Int']['output']>
  tradelinesCurrentlyDelinquent?: Maybe<Scalars['Int']['output']>
  tradelinesEducationBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesEducationCount?: Maybe<Scalars['Int']['output']>
  tradelinesEducationHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesEducationPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesEducationPaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentCount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentOtherBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentOtherCount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentOtherHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentOtherPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentOtherPaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesInstallmentPaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesMaxCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesMortgageBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesMortgageCount?: Maybe<Scalars['Int']['output']>
  tradelinesMortgageHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesMortgagePastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesMortgagePaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesNonMortgagePayments?: Maybe<Scalars['Int']['output']>
  tradelinesOldest?: Maybe<Scalars['Int']['output']>
  tradelinesOpenBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesOpenCount?: Maybe<Scalars['Int']['output']>
  tradelinesOpenHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesOpenPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesOpenPaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesOpenWBalance?: Maybe<Scalars['Int']['output']>
  tradelinesOpenWoBalance?: Maybe<Scalars['Int']['output']>
  tradelinesPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesPaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesPreviouslyDelinquient?: Maybe<Scalars['Int']['output']>
  tradelinesRevolvingBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesRevolvingCount?: Maybe<Scalars['Int']['output']>
  tradelinesRevolvingHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesRevolvingPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesRevolvingPaymentAmount?: Maybe<Scalars['Int']['output']>
  tradelinesSatisfactoryCount?: Maybe<Scalars['Int']['output']>
  tradelinesUnknownBalanceAmount?: Maybe<Scalars['Int']['output']>
  tradelinesUnknownCount?: Maybe<Scalars['Int']['output']>
  tradelinesUnknownHighCreditAmount?: Maybe<Scalars['Int']['output']>
  tradelinesUnknownPastDueAmount?: Maybe<Scalars['Int']['output']>
  tradelinesUnknownPaymentAmount?: Maybe<Scalars['Int']['output']>
  uuid: Scalars['UUID']['output']
  x30Day?: Maybe<Scalars['Int']['output']>
  x60Day?: Maybe<Scalars['Int']['output']>
  x90Day?: Maybe<Scalars['Int']['output']>
}

export type CreditReportApplicantsArgs = {
  filters?: InputMaybe<CreditReportApplicantFilter>
  order?: InputMaybe<CreditReportApplicantOrder>
}

export type CreditReportApplicationProfilesArgs = {
  filters?: InputMaybe<ApplicationProfileFilter>
  order?: InputMaybe<ApplicationProfileOrder>
}

export type CreditReportApplicationsArgs = {
  filters?: InputMaybe<ApplicationFilter>
  order?: InputMaybe<ApplicationOrder>
}

export type CreditReportTradelinesArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
}

export type CreditReportApplicant = {
  __typename?: 'CreditReportApplicant'
  applicationProfile: ApplicationProfile
  classification?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  creditReport: CreditReport
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  scores: Array<CreditReportScore>
  uuid: Scalars['UUID']['output']
}

export type CreditReportApplicantScoresArgs = {
  filters?: InputMaybe<CreditReportScoreFilter>
  order?: InputMaybe<CreditReportScoreOrder>
}

export type CreditReportApplicantFilter = {
  AND?: InputMaybe<CreditReportApplicantFilter>
  NOT?: InputMaybe<CreditReportApplicantFilter>
  OR?: InputMaybe<CreditReportApplicantFilter>
  pk: Scalars['ID']['input']
}

export type CreditReportApplicantInput = {
  applicationProfile: OneToManyInput
  classification?: InputMaybe<Scalars['String']['input']>
  creditReport: OneToManyInput
}

export type CreditReportApplicantInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  classification?: InputMaybe<Scalars['String']['input']>
  creditReport?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
}

export type CreditReportApplicantOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type CreditReportApplicantUpdatePayload = CreditReportApplicant | OperationInfo

export type CreditReportFilter = {
  AND?: InputMaybe<CreditReportFilter>
  NOT?: InputMaybe<CreditReportFilter>
  OR?: InputMaybe<CreditReportFilter>
  pk: Scalars['ID']['input']
}

export type CreditReportInput = {
  aanDenialReason?: InputMaybe<Scalars['String']['input']>
  confirmingSsn?: InputMaybe<Scalars['String']['input']>
  creditFiles?: InputMaybe<Scalars['JSON']['input']>
  creditRequest?: InputMaybe<OneToOneInput>
  creditScores?: InputMaybe<Scalars['JSON']['input']>
  debtHighCredit?: InputMaybe<Scalars['Int']['input']>
  failReason?: InputMaybe<Scalars['String']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  hasChapter11Bankruptcy?: InputMaybe<Scalars['Boolean']['input']>
  hasMortgageDelinquency?: InputMaybe<Scalars['Boolean']['input']>
  hasTimeshareTradeline?: InputMaybe<Scalars['Boolean']['input']>
  inquiryCount?: InputMaybe<Scalars['Int']['input']>
  inquiryLast90Days?: InputMaybe<Scalars['Boolean']['input']>
  isJoint?: InputMaybe<Scalars['Boolean']['input']>
  isReissue?: InputMaybe<Scalars['Boolean']['input']>
  isVantage?: InputMaybe<Scalars['Boolean']['input']>
  last90Deliquency?: InputMaybe<Scalars['Date']['input']>
  last120Deliquency?: InputMaybe<Scalars['Date']['input']>
  lastBankruptcy?: InputMaybe<Scalars['Date']['input']>
  lastDeedInLieu?: InputMaybe<Scalars['Date']['input']>
  lastForeclosure?: InputMaybe<Scalars['Date']['input']>
  lastShortSale?: InputMaybe<Scalars['Date']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  needsToBeDeclined?: InputMaybe<Scalars['String']['input']>
  publicRecordsCount?: InputMaybe<Scalars['Int']['input']>
  reportGeneratedAt?: InputMaybe<Scalars['DateTime']['input']>
  reportOrderedAt?: InputMaybe<Scalars['Date']['input']>
  revolvingUtilization?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesBalanceAmountSecured?: InputMaybe<Scalars['Int']['input']>
  tradelinesBalanceAmountUnsecured?: InputMaybe<Scalars['Int']['input']>
  tradelinesBankruptcyCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesChargeOffCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesClosedWoBalance?: InputMaybe<Scalars['Int']['input']>
  tradelinesCollectionCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesCurrentlyDelinquent?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMaxCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgageBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgageCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgageHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgagePastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgagePaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesNonMortgagePayments?: InputMaybe<Scalars['Int']['input']>
  tradelinesOldest?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenWBalance?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenWoBalance?: InputMaybe<Scalars['Int']['input']>
  tradelinesPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesPreviouslyDelinquient?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesSatisfactoryCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  x30Day?: InputMaybe<Scalars['Int']['input']>
  x60Day?: InputMaybe<Scalars['Int']['input']>
  x90Day?: InputMaybe<Scalars['Int']['input']>
}

export type CreditReportInputPartial = {
  aanDenialReason?: InputMaybe<Scalars['String']['input']>
  confirmingSsn?: InputMaybe<Scalars['String']['input']>
  creditFiles?: InputMaybe<Scalars['JSON']['input']>
  creditRequest?: InputMaybe<OneToOneInput>
  creditScores?: InputMaybe<Scalars['JSON']['input']>
  debtHighCredit?: InputMaybe<Scalars['Int']['input']>
  failReason?: InputMaybe<Scalars['String']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  hasChapter11Bankruptcy?: InputMaybe<Scalars['Boolean']['input']>
  hasMortgageDelinquency?: InputMaybe<Scalars['Boolean']['input']>
  hasTimeshareTradeline?: InputMaybe<Scalars['Boolean']['input']>
  inquiryCount?: InputMaybe<Scalars['Int']['input']>
  inquiryLast90Days?: InputMaybe<Scalars['Boolean']['input']>
  isJoint?: InputMaybe<Scalars['Boolean']['input']>
  isReissue?: InputMaybe<Scalars['Boolean']['input']>
  isVantage?: InputMaybe<Scalars['Boolean']['input']>
  last90Deliquency?: InputMaybe<Scalars['Date']['input']>
  last120Deliquency?: InputMaybe<Scalars['Date']['input']>
  lastBankruptcy?: InputMaybe<Scalars['Date']['input']>
  lastDeedInLieu?: InputMaybe<Scalars['Date']['input']>
  lastForeclosure?: InputMaybe<Scalars['Date']['input']>
  lastShortSale?: InputMaybe<Scalars['Date']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  needsToBeDeclined?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  publicRecordsCount?: InputMaybe<Scalars['Int']['input']>
  reportGeneratedAt?: InputMaybe<Scalars['DateTime']['input']>
  reportOrderedAt?: InputMaybe<Scalars['Date']['input']>
  revolvingUtilization?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesAutoPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesBalanceAmountSecured?: InputMaybe<Scalars['Int']['input']>
  tradelinesBalanceAmountUnsecured?: InputMaybe<Scalars['Int']['input']>
  tradelinesBankruptcyCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesChargeOffCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesClosedWoBalance?: InputMaybe<Scalars['Int']['input']>
  tradelinesCollectionCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesCurrentlyDelinquent?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesEducationPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentOtherPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesInstallmentPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMaxCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgageBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgageCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgageHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgagePastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesMortgagePaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesNonMortgagePayments?: InputMaybe<Scalars['Int']['input']>
  tradelinesOldest?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenWBalance?: InputMaybe<Scalars['Int']['input']>
  tradelinesOpenWoBalance?: InputMaybe<Scalars['Int']['input']>
  tradelinesPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesPreviouslyDelinquient?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesRevolvingPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesSatisfactoryCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownBalanceAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownCount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownHighCreditAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownPastDueAmount?: InputMaybe<Scalars['Int']['input']>
  tradelinesUnknownPaymentAmount?: InputMaybe<Scalars['Int']['input']>
  x30Day?: InputMaybe<Scalars['Int']['input']>
  x60Day?: InputMaybe<Scalars['Int']['input']>
  x90Day?: InputMaybe<Scalars['Int']['input']>
}

export type CreditReportOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type CreditReportScore = {
  __typename?: 'CreditReportScore'
  applicant: CreditReportApplicant
  company: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  factors: Array<Factor>
  fileStatus: Scalars['String']['output']
  id: Scalars['ID']['output']
  modelName: Scalars['String']['output']
  modifiedAt: Scalars['DateTime']['output']
  otherDescription?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  uuid: Scalars['UUID']['output']
  value?: Maybe<Scalars['Int']['output']>
}

export type CreditReportScoreFactorsArgs = {
  filters?: InputMaybe<FactorFilter>
  order?: InputMaybe<FactorOrder>
}

export type CreditReportScoreFilter = {
  AND?: InputMaybe<CreditReportScoreFilter>
  NOT?: InputMaybe<CreditReportScoreFilter>
  OR?: InputMaybe<CreditReportScoreFilter>
  pk: Scalars['ID']['input']
}

export type CreditReportScoreInput = {
  applicant: OneToManyInput
  company: Scalars['String']['input']
  fileStatus: Scalars['String']['input']
  modelName: Scalars['String']['input']
  otherDescription?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Int']['input']>
}

export type CreditReportScoreInputPartial = {
  applicant?: InputMaybe<OneToManyInput>
  company?: InputMaybe<Scalars['String']['input']>
  fileStatus?: InputMaybe<Scalars['String']['input']>
  modelName?: InputMaybe<Scalars['String']['input']>
  otherDescription?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  value?: InputMaybe<Scalars['Int']['input']>
}

export type CreditReportScoreOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type CreditReportScoreUpdatePayload = CreditReportScore | OperationInfo

export type CreditReportUpdatePayload = CreditReport | OperationInfo

export type CustomToken = {
  __typename?: 'CustomToken'
  created: Scalars['DateTime']['output']
  key: Scalars['String']['output']
  mode: Scalars['String']['output']
  pk: Scalars['ID']['output']
  user: DjangoModelType
}

export type CustomTokenFilter = {
  AND?: InputMaybe<CustomTokenFilter>
  NOT?: InputMaybe<CustomTokenFilter>
  OR?: InputMaybe<CustomTokenFilter>
  pk: Scalars['ID']['input']
}

export type CustomTokenInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>
  key: Scalars['String']['input']
  mode: Scalars['String']['input']
  user: OneToManyInput
}

export type CustomTokenInputPartial = {
  created?: InputMaybe<Scalars['DateTime']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  user?: InputMaybe<OneToManyInput>
}

export type CustomTokenOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type CustomTokenUpdatePayload = CustomToken | OperationInfo

export type CustomerAction = {
  __typename?: 'CustomerAction'
  action: Scalars['String']['output']
  applicationProfile: ApplicationProfile
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  pk: Scalars['ID']['output']
  resource: Scalars['String']['output']
}

export type CustomerActionFilter = {
  AND?: InputMaybe<CustomerActionFilter>
  NOT?: InputMaybe<CustomerActionFilter>
  OR?: InputMaybe<CustomerActionFilter>
  pk: Scalars['ID']['input']
}

export type CustomerActionInput = {
  action: Scalars['String']['input']
  applicationProfile: OneToManyInput
  resource: Scalars['String']['input']
}

export type CustomerActionInputPartial = {
  action?: InputMaybe<Scalars['String']['input']>
  applicationProfile?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  resource?: InputMaybe<Scalars['String']['input']>
}

export type CustomerActionOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type CustomerActionUpdatePayload = CustomerAction | OperationInfo

export type DealTeam = {
  __typename?: 'DealTeam'
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  subscriber: Subscriber
  type: Scalars['String']['output']
  user: DjangoModelType
  uuid: Scalars['UUID']['output']
}

export type DealTeamFilter = {
  AND?: InputMaybe<DealTeamFilter>
  NOT?: InputMaybe<DealTeamFilter>
  OR?: InputMaybe<DealTeamFilter>
  pk: Scalars['ID']['input']
}

export type DealTeamInput = {
  application: OneToManyInput
  subscriber?: InputMaybe<OneToManyInput>
  type: Scalars['String']['input']
  user: OneToManyInput
}

export type DealTeamInputPartial = {
  application?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  subscriber?: InputMaybe<OneToManyInput>
  type?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<OneToManyInput>
}

export type DealTeamOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DealTeamUpdatePayload = DealTeam | OperationInfo

export type Declaration = {
  __typename?: 'Declaration'
  applicationProfile: ApplicationProfile
  createdAt: Scalars['DateTime']['output']
  declarationType: Scalars['String']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  explanation?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  uuid: Scalars['UUID']['output']
  value?: Maybe<Scalars['Boolean']['output']>
}

export type DeclarationFilter = {
  AND?: InputMaybe<DeclarationFilter>
  NOT?: InputMaybe<DeclarationFilter>
  OR?: InputMaybe<DeclarationFilter>
  pk: Scalars['ID']['input']
}

export type DeclarationInput = {
  applicationProfile: OneToManyInput
  declarationType: Scalars['String']['input']
  explanation?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Boolean']['input']>
}

export type DeclarationInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  declarationType?: InputMaybe<Scalars['String']['input']>
  explanation?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  value?: InputMaybe<Scalars['Boolean']['input']>
}

export type DeclarationOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DeclarationUpdatePayload = Declaration | OperationInfo

export type DjangoFileType = {
  __typename?: 'DjangoFileType'
  name: Scalars['String']['output']
  path: Scalars['String']['output']
  size: Scalars['Int']['output']
  url: Scalars['String']['output']
}

export type DjangoModelType = {
  __typename?: 'DjangoModelType'
  pk: Scalars['ID']['output']
}

export type Document = {
  __typename?: 'Document'
  applicationProfile: ApplicationProfile
  category?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  customerLastSeenAt?: Maybe<Scalars['DateTime']['output']>
  customerVisible: Scalars['Boolean']['output']
  data?: Maybe<Scalars['JSON']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  document?: Maybe<Scalars['String']['output']>
  documentTemplate: DocumentTemplate
  documentTradeline: DocumentTradeline
  files: Array<DocumentFile>
  id: Scalars['ID']['output']
  identifier?: Maybe<Scalars['String']['output']>
  kind?: Maybe<Scalars['String']['output']>
  messages: Array<Messages>
  modifiedAt: Scalars['DateTime']['output']
  notes: Array<StreamingNote>
  originalFilename?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  servicingTask: ServicingTask
  servicingpayoffrequestSet: Array<ServicingPayoffRequest>
  singleFile: DjangoFileType
  size?: Maybe<Scalars['Int']['output']>
  snapshot: Snapshot
  source?: Maybe<Scalars['String']['output']>
  streamingNotes: Array<StreamingNote>
  tag?: Maybe<Scalars['String']['output']>
  templatedocumentSet: TemplateDocument
  type?: Maybe<Scalars['String']['output']>
  uploadFinishedAt?: Maybe<Scalars['DateTime']['output']>
  uuid: Scalars['UUID']['output']
}

export type DocumentFilesArgs = {
  filters?: InputMaybe<DocumentFileFilter>
  order?: InputMaybe<DocumentFileOrder>
}

export type DocumentMessagesArgs = {
  filters?: InputMaybe<MessagesFilter>
  order?: InputMaybe<MessagesOrder>
}

export type DocumentNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type DocumentServicingpayoffrequestSetArgs = {
  filters?: InputMaybe<ServicingPayoffRequestFilter>
  order?: InputMaybe<ServicingPayoffRequestOrder>
}

export type DocumentStreamingNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type DocumentFile = {
  __typename?: 'DocumentFile'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  document: Document
  file?: Maybe<DjangoFileType>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  originalFilename: Scalars['String']['output']
  pk: Scalars['ID']['output']
  uuid: Scalars['UUID']['output']
}

export type DocumentFileFilter = {
  AND?: InputMaybe<DocumentFileFilter>
  NOT?: InputMaybe<DocumentFileFilter>
  OR?: InputMaybe<DocumentFileFilter>
  pk: Scalars['ID']['input']
}

export type DocumentFileInput = {
  document: OneToManyInput
  file?: InputMaybe<Scalars['Upload']['input']>
  originalFilename: Scalars['String']['input']
}

export type DocumentFileInputPartial = {
  document?: InputMaybe<OneToManyInput>
  file?: InputMaybe<Scalars['Upload']['input']>
  originalFilename?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
}

export type DocumentFileOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DocumentFileUpdatePayload = DocumentFile | OperationInfo

export type DocumentFilter = {
  AND?: InputMaybe<DocumentFilter>
  NOT?: InputMaybe<DocumentFilter>
  OR?: InputMaybe<DocumentFilter>
  pk: Scalars['ID']['input']
}

export type DocumentInput = {
  applicationProfile?: InputMaybe<OneToManyInput>
  category?: InputMaybe<Scalars['String']['input']>
  customerLastSeenAt?: InputMaybe<Scalars['DateTime']['input']>
  customerVisible?: InputMaybe<Scalars['Boolean']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  document?: InputMaybe<Scalars['String']['input']>
  documentTemplate?: InputMaybe<OneToManyInput>
  identifier?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  originalFilename?: InputMaybe<Scalars['String']['input']>
  servicingTask?: InputMaybe<OneToManyInput>
  singleFile: Scalars['Upload']['input']
  size?: InputMaybe<Scalars['Int']['input']>
  snapshot?: InputMaybe<OneToManyInput>
  source?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  uploadFinishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type DocumentInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  category?: InputMaybe<Scalars['String']['input']>
  customerLastSeenAt?: InputMaybe<Scalars['DateTime']['input']>
  customerVisible?: InputMaybe<Scalars['Boolean']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  document?: InputMaybe<Scalars['String']['input']>
  documentTemplate?: InputMaybe<OneToManyInput>
  identifier?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  originalFilename?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  servicingTask?: InputMaybe<OneToManyInput>
  singleFile?: InputMaybe<Scalars['Upload']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  snapshot?: InputMaybe<OneToManyInput>
  source?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  uploadFinishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type DocumentOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate'
  aliases?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  cxName?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  documents: Array<Document>
  expiresIn?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  isRequestedDocument?: Maybe<Scalars['Boolean']['output']>
  kind?: Maybe<Scalars['String']['output']>
  messages: Array<Messages>
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  pk: Scalars['ID']['output']
  requestTemplateMessage?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  systemTemplate: Scalars['Boolean']['output']
  tag?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
}

export type DocumentTemplateDocumentsArgs = {
  filters?: InputMaybe<DocumentFilter>
  order?: InputMaybe<DocumentOrder>
}

export type DocumentTemplateMessagesArgs = {
  filters?: InputMaybe<MessagesFilter>
  order?: InputMaybe<MessagesOrder>
}

export type DocumentTemplateFilter = {
  AND?: InputMaybe<DocumentTemplateFilter>
  NOT?: InputMaybe<DocumentTemplateFilter>
  OR?: InputMaybe<DocumentTemplateFilter>
  pk: Scalars['ID']['input']
}

export type DocumentTemplateInput = {
  aliases?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  cxName?: InputMaybe<Scalars['String']['input']>
  expiresIn?: InputMaybe<Scalars['Int']['input']>
  isRequestedDocument?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  requestTemplateMessage?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  systemTemplate?: InputMaybe<Scalars['Boolean']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type DocumentTemplateInputPartial = {
  aliases?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  cxName?: InputMaybe<Scalars['String']['input']>
  expiresIn?: InputMaybe<Scalars['Int']['input']>
  isRequestedDocument?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  requestTemplateMessage?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  systemTemplate?: InputMaybe<Scalars['Boolean']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type DocumentTemplateOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DocumentTemplateUpdatePayload = DocumentTemplate | OperationInfo

export type DocumentTradeline = {
  __typename?: 'DocumentTradeline'
  document: Document
  pk: Scalars['ID']['output']
  tradeline: Tradeline
}

export type DocumentTradelineFilter = {
  AND?: InputMaybe<DocumentTradelineFilter>
  NOT?: InputMaybe<DocumentTradelineFilter>
  OR?: InputMaybe<DocumentTradelineFilter>
  pk: Scalars['ID']['input']
}

export type DocumentTradelineInput = {
  document: OneToOneInput
  tradeline: OneToManyInput
}

export type DocumentTradelineInputPartial = {
  document?: InputMaybe<OneToOneInput>
  pk: Scalars['ID']['input']
  tradeline?: InputMaybe<OneToManyInput>
}

export type DocumentTradelineOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DocumentTradelineUpdatePayload = DocumentTradeline | OperationInfo

export type DocumentUpdatePayload = Document | OperationInfo

export type DocusignEnvelope = {
  __typename?: 'DocusignEnvelope'
  applicantsData?: Maybe<Scalars['JSON']['output']>
  applicationProfiles: Array<ApplicationProfile>
  createdAt: Scalars['DateTime']['output']
  customerVisible: Scalars['Boolean']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  docusignEnvelopeSigner: Array<DocusignEnvelopeApplicationProfile>
  envelopeId: Scalars['String']['output']
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  recipientsData?: Maybe<Scalars['JSON']['output']>
  recipientsType?: Maybe<Scalars['String']['output']>
  templateId: Scalars['String']['output']
  templateName: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type DocusignEnvelopeApplicationProfilesArgs = {
  filters?: InputMaybe<ApplicationProfileFilter>
  order?: InputMaybe<ApplicationProfileOrder>
}

export type DocusignEnvelopeDocusignEnvelopeSignerArgs = {
  filters?: InputMaybe<DocusignEnvelopeApplicationProfileFilter>
  order?: InputMaybe<DocusignEnvelopeApplicationProfileOrder>
}

export type DocusignEnvelopeApplicationProfile = {
  __typename?: 'DocusignEnvelopeApplicationProfile'
  applicationProfile: ApplicationProfile
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  docusignEnvelope: DocusignEnvelope
  id: Scalars['ID']['output']
  isCompleted: Scalars['Boolean']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  signUrlCreated: Scalars['Boolean']['output']
  uuid: Scalars['UUID']['output']
}

export type DocusignEnvelopeApplicationProfileFilter = {
  AND?: InputMaybe<DocusignEnvelopeApplicationProfileFilter>
  NOT?: InputMaybe<DocusignEnvelopeApplicationProfileFilter>
  OR?: InputMaybe<DocusignEnvelopeApplicationProfileFilter>
  pk: Scalars['ID']['input']
}

export type DocusignEnvelopeApplicationProfileInput = {
  applicationProfile: OneToManyInput
  docusignEnvelope: OneToManyInput
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>
  signUrlCreated?: InputMaybe<Scalars['Boolean']['input']>
}

export type DocusignEnvelopeApplicationProfileInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  docusignEnvelope?: InputMaybe<OneToManyInput>
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>
  pk: Scalars['ID']['input']
  signUrlCreated?: InputMaybe<Scalars['Boolean']['input']>
}

export type DocusignEnvelopeApplicationProfileOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DocusignEnvelopeApplicationProfileUpdatePayload =
  | DocusignEnvelopeApplicationProfile
  | OperationInfo

export type DocusignEnvelopeFilter = {
  AND?: InputMaybe<DocusignEnvelopeFilter>
  NOT?: InputMaybe<DocusignEnvelopeFilter>
  OR?: InputMaybe<DocusignEnvelopeFilter>
  pk: Scalars['ID']['input']
}

export type DocusignEnvelopeInput = {
  applicantsData?: InputMaybe<Scalars['JSON']['input']>
  customerVisible?: InputMaybe<Scalars['Boolean']['input']>
  envelopeId: Scalars['String']['input']
  recipientsData?: InputMaybe<Scalars['JSON']['input']>
  recipientsType?: InputMaybe<Scalars['String']['input']>
  templateId: Scalars['String']['input']
  templateName: Scalars['String']['input']
}

export type DocusignEnvelopeInputPartial = {
  applicantsData?: InputMaybe<Scalars['JSON']['input']>
  customerVisible?: InputMaybe<Scalars['Boolean']['input']>
  envelopeId?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  recipientsData?: InputMaybe<Scalars['JSON']['input']>
  recipientsType?: InputMaybe<Scalars['String']['input']>
  templateId?: InputMaybe<Scalars['String']['input']>
  templateName?: InputMaybe<Scalars['String']['input']>
}

export type DocusignEnvelopeOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DocusignEnvelopeUpdatePayload = DocusignEnvelope | OperationInfo

export type Dscr = {
  __typename?: 'Dscr'
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  hoaDebt?: Maybe<Scalars['Decimal']['output']>
  id: Scalars['ID']['output']
  insuranceDebt?: Maybe<Scalars['Decimal']['output']>
  leasedUnit1: Scalars['Boolean']['output']
  leasedUnit2: Scalars['Boolean']['output']
  leasedUnit3: Scalars['Boolean']['output']
  leasedUnit4: Scalars['Boolean']['output']
  modifiedAt: Scalars['DateTime']['output']
  monthlyUnit1?: Maybe<Scalars['Decimal']['output']>
  monthlyUnit2?: Maybe<Scalars['Decimal']['output']>
  monthlyUnit3?: Maybe<Scalars['Decimal']['output']>
  monthlyUnit4?: Maybe<Scalars['Decimal']['output']>
  mortgageDebt?: Maybe<Scalars['Decimal']['output']>
  overridesApplied: Scalars['Boolean']['output']
  pk: Scalars['ID']['output']
  taxesDebt?: Maybe<Scalars['Decimal']['output']>
  taxesInsIncluded: Scalars['Boolean']['output']
  uuid: Scalars['UUID']['output']
}

export type DscrFilter = {
  AND?: InputMaybe<DscrFilter>
  NOT?: InputMaybe<DscrFilter>
  OR?: InputMaybe<DscrFilter>
  pk: Scalars['ID']['input']
}

export type DscrInput = {
  application: OneToOneInput
  hoaDebt?: InputMaybe<Scalars['Decimal']['input']>
  insuranceDebt?: InputMaybe<Scalars['Decimal']['input']>
  leasedUnit1?: InputMaybe<Scalars['Boolean']['input']>
  leasedUnit2?: InputMaybe<Scalars['Boolean']['input']>
  leasedUnit3?: InputMaybe<Scalars['Boolean']['input']>
  leasedUnit4?: InputMaybe<Scalars['Boolean']['input']>
  monthlyUnit1?: InputMaybe<Scalars['Decimal']['input']>
  monthlyUnit2?: InputMaybe<Scalars['Decimal']['input']>
  monthlyUnit3?: InputMaybe<Scalars['Decimal']['input']>
  monthlyUnit4?: InputMaybe<Scalars['Decimal']['input']>
  mortgageDebt?: InputMaybe<Scalars['Decimal']['input']>
  overridesApplied?: InputMaybe<Scalars['Boolean']['input']>
  taxesDebt?: InputMaybe<Scalars['Decimal']['input']>
  taxesInsIncluded?: InputMaybe<Scalars['Boolean']['input']>
}

export type DscrInputPartial = {
  application?: InputMaybe<OneToOneInput>
  hoaDebt?: InputMaybe<Scalars['Decimal']['input']>
  insuranceDebt?: InputMaybe<Scalars['Decimal']['input']>
  leasedUnit1?: InputMaybe<Scalars['Boolean']['input']>
  leasedUnit2?: InputMaybe<Scalars['Boolean']['input']>
  leasedUnit3?: InputMaybe<Scalars['Boolean']['input']>
  leasedUnit4?: InputMaybe<Scalars['Boolean']['input']>
  monthlyUnit1?: InputMaybe<Scalars['Decimal']['input']>
  monthlyUnit2?: InputMaybe<Scalars['Decimal']['input']>
  monthlyUnit3?: InputMaybe<Scalars['Decimal']['input']>
  monthlyUnit4?: InputMaybe<Scalars['Decimal']['input']>
  mortgageDebt?: InputMaybe<Scalars['Decimal']['input']>
  overridesApplied?: InputMaybe<Scalars['Boolean']['input']>
  pk: Scalars['ID']['input']
  taxesDebt?: InputMaybe<Scalars['Decimal']['input']>
  taxesInsIncluded?: InputMaybe<Scalars['Boolean']['input']>
}

export type DscrOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type DscrUpdatePayload = Dscr | OperationInfo

export type Escalation = {
  __typename?: 'Escalation'
  application: Application
  approved?: Maybe<Scalars['Boolean']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pathSolarPanel?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  requestComment?: Maybe<Scalars['String']['output']>
  requestDate?: Maybe<Scalars['DateTime']['output']>
  requestUser: UserData
  responseComment?: Maybe<Scalars['String']['output']>
  responseDate?: Maybe<Scalars['DateTime']['output']>
  responseUser: UserData
  seen: Scalars['Boolean']['output']
  submitted?: Maybe<Scalars['DateTime']['output']>
  tab: Scalars['String']['output']
  taggedUsers: Array<UserData>
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  uamCommentary?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
}

export type EscalationTaggedUsersArgs = {
  filters?: InputMaybe<UserDataFilter>
  order?: InputMaybe<UserDataOrder>
}

export type EscalationFilter = {
  AND?: InputMaybe<EscalationFilter>
  NOT?: InputMaybe<EscalationFilter>
  OR?: InputMaybe<EscalationFilter>
  pk: Scalars['ID']['input']
}

export type EscalationInput = {
  application: OneToManyInput
  approved?: InputMaybe<Scalars['Boolean']['input']>
  pathSolarPanel?: InputMaybe<Scalars['String']['input']>
  requestComment?: InputMaybe<Scalars['String']['input']>
  requestDate?: InputMaybe<Scalars['DateTime']['input']>
  requestUser?: InputMaybe<OneToManyInput>
  responseComment?: InputMaybe<Scalars['String']['input']>
  responseDate?: InputMaybe<Scalars['DateTime']['input']>
  responseUser?: InputMaybe<OneToManyInput>
  seen?: InputMaybe<Scalars['Boolean']['input']>
  submitted?: InputMaybe<Scalars['DateTime']['input']>
  tab: Scalars['String']['input']
  title: Scalars['String']['input']
  type: Scalars['String']['input']
  uamCommentary?: InputMaybe<Scalars['String']['input']>
}

export type EscalationInputPartial = {
  application?: InputMaybe<OneToManyInput>
  approved?: InputMaybe<Scalars['Boolean']['input']>
  pathSolarPanel?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  requestComment?: InputMaybe<Scalars['String']['input']>
  requestDate?: InputMaybe<Scalars['DateTime']['input']>
  requestUser?: InputMaybe<OneToManyInput>
  responseComment?: InputMaybe<Scalars['String']['input']>
  responseDate?: InputMaybe<Scalars['DateTime']['input']>
  responseUser?: InputMaybe<OneToManyInput>
  seen?: InputMaybe<Scalars['Boolean']['input']>
  submitted?: InputMaybe<Scalars['DateTime']['input']>
  tab?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  uamCommentary?: InputMaybe<Scalars['String']['input']>
}

export type EscalationOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type EscalationUpdatePayload = Escalation | OperationInfo

export type Expense = {
  __typename?: 'Expense'
  amount?: Maybe<Scalars['Decimal']['output']>
  application: Application
  asPercentage?: Maybe<Scalars['Decimal']['output']>
  calcType: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  externalId: Scalars['String']['output']
  feeType?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  paidTo?: Maybe<Scalars['String']['output']>
  paidWhen: Scalars['String']['output']
  pk: Scalars['ID']['output']
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type ExpenseFilter = {
  AND?: InputMaybe<ExpenseFilter>
  NOT?: InputMaybe<ExpenseFilter>
  OR?: InputMaybe<ExpenseFilter>
  name?: InputMaybe<Scalars['String']['input']>
  pk?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type ExpenseInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>
  application: OneToManyInput
  asPercentage?: InputMaybe<Scalars['Decimal']['input']>
  calcType?: InputMaybe<Scalars['String']['input']>
  feeType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  paidTo?: InputMaybe<Scalars['String']['input']>
  paidWhen?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
}

export type ExpenseInputPartial = {
  amount?: InputMaybe<Scalars['Decimal']['input']>
  application?: InputMaybe<OneToManyInput>
  asPercentage?: InputMaybe<Scalars['Decimal']['input']>
  calcType?: InputMaybe<Scalars['String']['input']>
  feeType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  paidTo?: InputMaybe<Scalars['String']['input']>
  paidWhen?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  type?: InputMaybe<Scalars['String']['input']>
}

export type ExpenseOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ExpenseUpdatePayload = Expense | OperationInfo

export type ExpensesCalculationsType = {
  __typename?: 'ExpensesCalculationsType'
  _cachedAt?: Maybe<Scalars['DateTime']['output']>
  creditsTotal?: Maybe<Scalars['Float']['output']>
  fundingWireAmount?: Maybe<Scalars['Float']['output']>
  originationChargeAmount?: Maybe<Scalars['Float']['output']>
  otherExpensesTotal?: Maybe<Scalars['Float']['output']>
  taxesAndOtherGovernmentFeesTotal?: Maybe<Scalars['Float']['output']>
  taxesAndOtherGovernmentFeesTotalAtClosing?: Maybe<Scalars['Float']['output']>
  taxesAndOtherGovernmentFeesTotalBeforeClosing?: Maybe<Scalars['Float']['output']>
  totalFeesExpensesAndCredits?: Maybe<Scalars['Float']['output']>
  totalInvestmentCosts?: Maybe<Scalars['Float']['output']>
  totalInvestmentCostsAtClosing?: Maybe<Scalars['Float']['output']>
  totalInvestmentCostsBeforeClosing?: Maybe<Scalars['Float']['output']>
  totalOtherExpenses?: Maybe<Scalars['Float']['output']>
  totalOtherExpensesAtClosing?: Maybe<Scalars['Float']['output']>
  totalOtherExpensesBeforeClosing?: Maybe<Scalars['Float']['output']>
}

export type Factor = {
  __typename?: 'Factor'
  code?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  reportScore: CreditReportScore
  text?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
}

export type FactorFilter = {
  AND?: InputMaybe<FactorFilter>
  NOT?: InputMaybe<FactorFilter>
  OR?: InputMaybe<FactorFilter>
  pk: Scalars['ID']['input']
}

export type FactorInput = {
  code?: InputMaybe<Scalars['String']['input']>
  reportScore: OneToManyInput
  text?: InputMaybe<Scalars['String']['input']>
}

export type FactorInputPartial = {
  code?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  reportScore?: InputMaybe<OneToManyInput>
  text?: InputMaybe<Scalars['String']['input']>
}

export type FactorOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type FactorUpdatePayload = Factor | OperationInfo

export type Hoi = {
  __typename?: 'HOI'
  annualPremium: Scalars['Decimal']['output']
  application: Application
  coverageAmount: Scalars['Decimal']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  effectiveDate?: Maybe<Scalars['Date']['output']>
  expirationDate?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  insuranceCompany: Scalars['String']['output']
  insuranceType: Scalars['String']['output']
  isUnlockInsured?: Maybe<Scalars['Boolean']['output']>
  masterHoaPolicy?: Maybe<Scalars['Boolean']['output']>
  modifiedAt: Scalars['DateTime']['output']
  ordered?: Maybe<Scalars['Date']['output']>
  pk: Scalars['ID']['output']
  policyNumber: Scalars['String']['output']
  received?: Maybe<Scalars['Date']['output']>
  replacementCost?: Maybe<Scalars['Boolean']['output']>
  replacementCostNotes?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
}

export type HoiFilter = {
  AND?: InputMaybe<HoiFilter>
  NOT?: InputMaybe<HoiFilter>
  OR?: InputMaybe<HoiFilter>
  pk: Scalars['ID']['input']
}

export type HoiInput = {
  annualPremium: Scalars['Decimal']['input']
  application: OneToManyInput
  coverageAmount: Scalars['Decimal']['input']
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  expirationDate?: InputMaybe<Scalars['Date']['input']>
  insuranceCompany: Scalars['String']['input']
  insuranceType: Scalars['String']['input']
  isUnlockInsured?: InputMaybe<Scalars['Boolean']['input']>
  masterHoaPolicy?: InputMaybe<Scalars['Boolean']['input']>
  ordered?: InputMaybe<Scalars['Date']['input']>
  policyNumber: Scalars['String']['input']
  received?: InputMaybe<Scalars['Date']['input']>
  replacementCost?: InputMaybe<Scalars['Boolean']['input']>
  replacementCostNotes?: InputMaybe<Scalars['String']['input']>
}

export type HoiInputPartial = {
  annualPremium?: InputMaybe<Scalars['Decimal']['input']>
  application?: InputMaybe<OneToManyInput>
  coverageAmount?: InputMaybe<Scalars['Decimal']['input']>
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  expirationDate?: InputMaybe<Scalars['Date']['input']>
  insuranceCompany?: InputMaybe<Scalars['String']['input']>
  insuranceType?: InputMaybe<Scalars['String']['input']>
  isUnlockInsured?: InputMaybe<Scalars['Boolean']['input']>
  masterHoaPolicy?: InputMaybe<Scalars['Boolean']['input']>
  ordered?: InputMaybe<Scalars['Date']['input']>
  pk: Scalars['ID']['input']
  policyNumber?: InputMaybe<Scalars['String']['input']>
  received?: InputMaybe<Scalars['Date']['input']>
  replacementCost?: InputMaybe<Scalars['Boolean']['input']>
  replacementCostNotes?: InputMaybe<Scalars['String']['input']>
}

export type HoiOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type Hoa = {
  __typename?: 'Hoa'
  accountNumber?: Maybe<Scalars['String']['output']>
  balanceDue?: Maybe<Scalars['Decimal']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  dueDate?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name?: Maybe<Scalars['String']['output']>
  paymentFrequency?: Maybe<Scalars['String']['output']>
  paymentStatus?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  property: Property
  uuid: Scalars['UUID']['output']
  yearlyAmount?: Maybe<Scalars['Decimal']['output']>
}

export type HoaFilter = {
  AND?: InputMaybe<HoaFilter>
  NOT?: InputMaybe<HoaFilter>
  OR?: InputMaybe<HoaFilter>
  pk: Scalars['ID']['input']
}

export type HoaOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type HoiUpdatePayload = Hoi | OperationInfo

export type Income = {
  __typename?: 'Income'
  applicationProfile: ApplicationProfile
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
  value?: Maybe<Scalars['Decimal']['output']>
}

export type IncomeFilter = {
  AND?: InputMaybe<IncomeFilter>
  NOT?: InputMaybe<IncomeFilter>
  OR?: InputMaybe<IncomeFilter>
  pk: Scalars['ID']['input']
}

export type IncomeInput = {
  applicationProfile: OneToManyInput
  description?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
  value?: InputMaybe<Scalars['Decimal']['input']>
}

export type IncomeInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  description?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  type?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Decimal']['input']>
}

export type IncomeOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type IncomeUpdatePayload = Income | OperationInfo

export type KickBack = {
  __typename?: 'KickBack'
  application: Application
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<DjangoModelType>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  previousSubstage: Scalars['String']['output']
  qualityCode: Scalars['String']['output']
  reason: Scalars['String']['output']
  reasonDescription?: Maybe<Scalars['String']['output']>
  toSubstage: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type KickBackFilter = {
  AND?: InputMaybe<KickBackFilter>
  NOT?: InputMaybe<KickBackFilter>
  OR?: InputMaybe<KickBackFilter>
  pk: Scalars['ID']['input']
}

export type KickBackInput = {
  application: OneToManyInput
  createdBy?: InputMaybe<OneToManyInput>
  previousSubstage: Scalars['String']['input']
  qualityCode: Scalars['String']['input']
  reason: Scalars['String']['input']
  reasonDescription?: InputMaybe<Scalars['String']['input']>
  toSubstage: Scalars['String']['input']
}

export type KickBackInputPartial = {
  application?: InputMaybe<OneToManyInput>
  createdBy?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  previousSubstage?: InputMaybe<Scalars['String']['input']>
  qualityCode?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  reasonDescription?: InputMaybe<Scalars['String']['input']>
  toSubstage?: InputMaybe<Scalars['String']['input']>
}

export type KickBackOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type KickBackUpdatePayload = KickBack | OperationInfo

export type MessageTemplate = {
  __typename?: 'MessageTemplate'
  body?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  pk: Scalars['ID']['output']
  uuid: Scalars['UUID']['output']
}

export type MessageTemplateFilter = {
  AND?: InputMaybe<MessageTemplateFilter>
  NOT?: InputMaybe<MessageTemplateFilter>
  OR?: InputMaybe<MessageTemplateFilter>
  body?: InputMaybe<StrFilterLookup>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<StrFilterLookup>
}

export type MessageTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
}

export type MessageTemplateInputPartial = {
  body?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
}

export type MessageTemplateOrder = {
  name?: InputMaybe<Ordering>
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type MessageTemplateUpdatePayload = MessageTemplate | OperationInfo

export type Messages = {
  __typename?: 'Messages'
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>
  application: Application
  body: Scalars['String']['output']
  childMessages: Array<Messages>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  document: Document
  esignaturePackage?: Maybe<DjangoModelType>
  fromProfile?: Maybe<DjangoModelType>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  parentDocumentsRequest: MultiDocumentsRequest
  parentMessage: Messages
  pk: Scalars['ID']['output']
  readAt?: Maybe<Scalars['DateTime']['output']>
  requestedDocument?: Maybe<Scalars['String']['output']>
  requestedDocumentTemplate: DocumentTemplate
  templateType?: Maybe<Scalars['String']['output']>
  toProfile?: Maybe<DjangoModelType>
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type MessagesChildMessagesArgs = {
  filters?: InputMaybe<MessagesFilter>
  order?: InputMaybe<MessagesOrder>
}

export type MessagesFilter = {
  AND?: InputMaybe<MessagesFilter>
  NOT?: InputMaybe<MessagesFilter>
  OR?: InputMaybe<MessagesFilter>
  pk: Scalars['ID']['input']
}

export type MessagesInput = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>
  application: OneToManyInput
  body: Scalars['String']['input']
  document?: InputMaybe<OneToManyInput>
  esignaturePackage?: InputMaybe<OneToManyInput>
  fromProfile?: InputMaybe<OneToManyInput>
  parentDocumentsRequest?: InputMaybe<OneToManyInput>
  parentMessage?: InputMaybe<OneToManyInput>
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  requestedDocument?: InputMaybe<Scalars['String']['input']>
  requestedDocumentTemplate?: InputMaybe<OneToManyInput>
  templateType?: InputMaybe<Scalars['String']['input']>
  toProfile?: InputMaybe<OneToManyInput>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MessagesInputPartial = {
  acknowledgedAt?: InputMaybe<Scalars['DateTime']['input']>
  application?: InputMaybe<OneToManyInput>
  body?: InputMaybe<Scalars['String']['input']>
  document?: InputMaybe<OneToManyInput>
  esignaturePackage?: InputMaybe<OneToManyInput>
  fromProfile?: InputMaybe<OneToManyInput>
  parentDocumentsRequest?: InputMaybe<OneToManyInput>
  parentMessage?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  requestedDocument?: InputMaybe<Scalars['String']['input']>
  requestedDocumentTemplate?: InputMaybe<OneToManyInput>
  templateType?: InputMaybe<Scalars['String']['input']>
  toProfile?: InputMaybe<OneToManyInput>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MessagesOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type MessagesUpdatePayload = Messages | OperationInfo

export type MultiDocumentsRequest = {
  __typename?: 'MultiDocumentsRequest'
  application: Application
  createdAt: Scalars['DateTime']['output']
  createdBy: DjangoModelType
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  messages: Array<Messages>
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  to: DjangoModelType
  uuid: Scalars['UUID']['output']
}

export type MultiDocumentsRequestMessagesArgs = {
  filters?: InputMaybe<MessagesFilter>
  order?: InputMaybe<MessagesOrder>
}

export type MultiDocumentsRequestFilter = {
  AND?: InputMaybe<MultiDocumentsRequestFilter>
  NOT?: InputMaybe<MultiDocumentsRequestFilter>
  OR?: InputMaybe<MultiDocumentsRequestFilter>
  pk: Scalars['ID']['input']
}

export type MultiDocumentsRequestInput = {
  application: OneToManyInput
  createdBy: OneToManyInput
  to: OneToManyInput
}

export type MultiDocumentsRequestInputPartial = {
  application?: InputMaybe<OneToManyInput>
  createdBy?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  to?: InputMaybe<OneToManyInput>
}

export type MultiDocumentsRequestOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type MultiDocumentsRequestUpdatePayload = MultiDocumentsRequest | OperationInfo

export type Mutation = {
  __typename?: 'Mutation'
  addressCreate: Address
  addressUpdate: AddressUpdatePayload
  alertCreate: Alert
  alertUpdate: AlertUpdatePayload
  applicationCreate: Application
  applicationExceptionCreate: ApplicationException
  applicationExceptionUpdate: ApplicationExceptionUpdatePayload
  applicationPartyCreate: ApplicationParty
  applicationPartyUpdate: ApplicationPartyUpdatePayload
  applicationProfileCreate: ApplicationProfile
  applicationProfileUpdate: ApplicationProfileUpdatePayload
  applicationUpdate: ApplicationUpdatePayload
  appraisalOrderCreate: AppraisalOrder
  appraisalOrderUpdate: AppraisalOrderUpdatePayload
  assetCreate: Asset
  assetUpdate: AssetUpdatePayload
  atypicalityCheckCreate: AtypicalityCheck
  atypicalityCheckUpdate: AtypicalityCheckUpdatePayload
  backgroundTaskCreate: BackgroundTask
  backgroundTaskUpdate: BackgroundTaskUpdatePayload
  companyCreate: Company
  companyUpdate: CompanyUpdatePayload
  creditReportApplicantCreate: CreditReportApplicant
  creditReportApplicantUpdate: CreditReportApplicantUpdatePayload
  creditReportCreate: CreditReport
  creditReportScoreCreate: CreditReportScore
  creditReportScoreUpdate: CreditReportScoreUpdatePayload
  creditReportUpdate: CreditReportUpdatePayload
  customTokenCreate: CustomToken
  customTokenUpdate: CustomTokenUpdatePayload
  customerActionCreate: CustomerAction
  customerActionUpdate: CustomerActionUpdatePayload
  dealTeamCreate: DealTeam
  dealTeamUpdate: DealTeamUpdatePayload
  declarationCreate: Declaration
  declarationUpdate: DeclarationUpdatePayload
  documentCreate: Document
  documentFileCreate: DocumentFile
  documentFileUpdate: DocumentFileUpdatePayload
  documentTemplateCreate: DocumentTemplate
  documentTemplateUpdate: DocumentTemplateUpdatePayload
  documentTradelineCreate: DocumentTradeline
  documentTradelineUpdate: DocumentTradelineUpdatePayload
  documentUpdate: DocumentUpdatePayload
  docusignEnvelopeApplicationProfileCreate: DocusignEnvelopeApplicationProfile
  docusignEnvelopeApplicationProfileUpdate: DocusignEnvelopeApplicationProfileUpdatePayload
  docusignEnvelopeCreate: DocusignEnvelope
  docusignEnvelopeUpdate: DocusignEnvelopeUpdatePayload
  dscrCreate: Dscr
  dscrUpdate: DscrUpdatePayload
  escalationCreate: Escalation
  escalationUpdate: EscalationUpdatePayload
  expenseCreate: Expense
  expenseUpdate: ExpenseUpdatePayload
  factorCreate: Factor
  factorUpdate: FactorUpdatePayload
  hoiCreate: Hoi
  hoiUpdate: HoiUpdatePayload
  incomeCreate: Income
  incomeUpdate: IncomeUpdatePayload
  kickBackCreate: KickBack
  kickBackUpdate: KickBackUpdatePayload
  messageTemplateCreate: MessageTemplate
  messageTemplateDelete: MessageTemplate
  messageTemplateUpdate: MessageTemplateUpdatePayload
  messagesCreate: Messages
  messagesUpdate: MessagesUpdatePayload
  multiDocumentsRequestCreate: MultiDocumentsRequest
  multiDocumentsRequestUpdate: MultiDocumentsRequestUpdatePayload
  notesCreate: Notes
  notesUpdate: NotesUpdatePayload
  notificationsCreate: Notifications
  notificationsUpdate: NotificationsUpdatePayload
  offerCreate: Offer
  offerUpdate: OfferUpdatePayload
  overridesCreate: Overrides
  overridesUpdate: OverridesUpdatePayload
  partyCreate: Party
  partyUpdate: PartyUpdatePayload
  priceAclCreate: PriceAcl
  priceAclUpdate: PriceAclUpdatePayload
  priceConfigCreate: PriceConfig
  priceConfigUpdate: PriceConfigUpdatePayload
  priceCreate: Price
  priceExchangeRateCreate: PriceExchangeRate
  priceExchangeRateUpdate: PriceExchangeRateUpdatePayload
  priceExchangeRateValueCreate: PriceExchangeRateValue
  priceExchangeRateValueUpdate: PriceExchangeRateValueUpdatePayload
  priceThflBracketCreate: PriceThflBracket
  priceThflBracketUpdate: PriceThflBracketUpdatePayload
  priceUpdate: PriceUpdatePayload
  profileCreate: Profile
  profilePropertyCreate: ProfileProperty
  profilePropertyUpdate: ProfilePropertyUpdatePayload
  profileUpdate: ProfileUpdatePayload
  propertyCreate: Property
  propertyFlagCreate: PropertyFlag
  propertyFlagUpdate: PropertyFlagUpdatePayload
  propertyUpdate: PropertyUpdatePayload
  servicingPayoffRequestCreate: ServicingPayoffRequest
  servicingPayoffRequestUpdate: ServicingPayoffRequestUpdatePayload
  servicingTaskCreate: ServicingTask
  servicingTaskGroupCreate: ServicingTaskGroup
  servicingTaskGroupUpdate: ServicingTaskGroupUpdatePayload
  servicingTaskUpdate: ServicingTaskUpdatePayload
  snapshotCreate: Snapshot
  snapshotUpdate: SnapshotUpdatePayload
  stateCreate: State
  stateUpdate: StateUpdatePayload
  streamingNoteCreate: StreamingNote
  streamingNoteReactionCreate: StreamingNoteReaction
  streamingNoteReactionUpdate: StreamingNoteReactionUpdatePayload
  streamingNoteUpdate: StreamingNoteUpdatePayload
  subscriberCreate: Subscriber
  subscriberUpdate: SubscriberUpdatePayload
  templateDocumentCreate: TemplateDocument
  templateDocumentUpdate: TemplateDocumentUpdatePayload
  titleOrderCreate: TitleOrder
  titleOrderUpdate: TitleOrderUpdatePayload
  titleReportCreate: TitleReport
  titleReportUpdate: TitleReportUpdatePayload
  tradelineCreate: Tradeline
  tradelineUpdate: TradelineUpdatePayload
  useOfProceedsCreate: UseOfProceeds
  useOfProceedsUpdate: UseOfProceedsUpdatePayload
  userDataCreate: UserData
  userDataUpdate: UserDataUpdatePayload
  userIncomeCreate: UserIncome
  userIncomeUpdate: UserIncomeUpdatePayload
  valuationCreate: Valuation
  valuationUpdate: ValuationUpdatePayload
  workQueuesCreate: WorkQueues
  workQueuesPresetCreate: WorkQueuesPreset
  workQueuesPresetUpdate: WorkQueuesPresetUpdatePayload
  workQueuesUpdate: WorkQueuesUpdatePayload
  zendeskTicketCreate: ZendeskTicket
  zendeskTicketUpdate: ZendeskTicketUpdatePayload
}

export type MutationAddressCreateArgs = {
  data: AddressInput
}

export type MutationAddressUpdateArgs = {
  data: AddressInputPartial
}

export type MutationAlertCreateArgs = {
  data: AlertInput
}

export type MutationAlertUpdateArgs = {
  data: AlertInputPartial
}

export type MutationApplicationCreateArgs = {
  data: ApplicationInput
}

export type MutationApplicationExceptionCreateArgs = {
  data: ApplicationExceptionInput
}

export type MutationApplicationExceptionUpdateArgs = {
  data: ApplicationExceptionInputPartial
}

export type MutationApplicationPartyCreateArgs = {
  data: ApplicationPartyInput
}

export type MutationApplicationPartyUpdateArgs = {
  data: ApplicationPartyInputPartial
}

export type MutationApplicationProfileCreateArgs = {
  data: ApplicationProfileInput
}

export type MutationApplicationProfileUpdateArgs = {
  data: ApplicationProfileInputPartial
}

export type MutationApplicationUpdateArgs = {
  data: ApplicationInputPartial
}

export type MutationAppraisalOrderCreateArgs = {
  data: AppraisalOrderInput
}

export type MutationAppraisalOrderUpdateArgs = {
  data: AppraisalOrderInputPartial
}

export type MutationAssetCreateArgs = {
  data: AssetInput
}

export type MutationAssetUpdateArgs = {
  data: AssetInputPartial
}

export type MutationAtypicalityCheckCreateArgs = {
  data: AtypicalityCheckInput
}

export type MutationAtypicalityCheckUpdateArgs = {
  data: AtypicalityCheckInputPartial
}

export type MutationBackgroundTaskCreateArgs = {
  data: BackgroundTaskInput
}

export type MutationBackgroundTaskUpdateArgs = {
  data: BackgroundTaskInputPartial
}

export type MutationCompanyCreateArgs = {
  data: CompanyInput
}

export type MutationCompanyUpdateArgs = {
  data: CompanyInputPartial
}

export type MutationCreditReportApplicantCreateArgs = {
  data: CreditReportApplicantInput
}

export type MutationCreditReportApplicantUpdateArgs = {
  data: CreditReportApplicantInputPartial
}

export type MutationCreditReportCreateArgs = {
  data: CreditReportInput
}

export type MutationCreditReportScoreCreateArgs = {
  data: CreditReportScoreInput
}

export type MutationCreditReportScoreUpdateArgs = {
  data: CreditReportScoreInputPartial
}

export type MutationCreditReportUpdateArgs = {
  data: CreditReportInputPartial
}

export type MutationCustomTokenCreateArgs = {
  data: CustomTokenInput
}

export type MutationCustomTokenUpdateArgs = {
  data: CustomTokenInputPartial
}

export type MutationCustomerActionCreateArgs = {
  data: CustomerActionInput
}

export type MutationCustomerActionUpdateArgs = {
  data: CustomerActionInputPartial
}

export type MutationDealTeamCreateArgs = {
  data: DealTeamInput
}

export type MutationDealTeamUpdateArgs = {
  data: DealTeamInputPartial
}

export type MutationDeclarationCreateArgs = {
  data: DeclarationInput
}

export type MutationDeclarationUpdateArgs = {
  data: DeclarationInputPartial
}

export type MutationDocumentCreateArgs = {
  data: DocumentInput
}

export type MutationDocumentFileCreateArgs = {
  data: DocumentFileInput
}

export type MutationDocumentFileUpdateArgs = {
  data: DocumentFileInputPartial
}

export type MutationDocumentTemplateCreateArgs = {
  data: DocumentTemplateInput
}

export type MutationDocumentTemplateUpdateArgs = {
  data: DocumentTemplateInputPartial
}

export type MutationDocumentTradelineCreateArgs = {
  data: DocumentTradelineInput
}

export type MutationDocumentTradelineUpdateArgs = {
  data: DocumentTradelineInputPartial
}

export type MutationDocumentUpdateArgs = {
  data: DocumentInputPartial
}

export type MutationDocusignEnvelopeApplicationProfileCreateArgs = {
  data: DocusignEnvelopeApplicationProfileInput
}

export type MutationDocusignEnvelopeApplicationProfileUpdateArgs = {
  data: DocusignEnvelopeApplicationProfileInputPartial
}

export type MutationDocusignEnvelopeCreateArgs = {
  data: DocusignEnvelopeInput
}

export type MutationDocusignEnvelopeUpdateArgs = {
  data: DocusignEnvelopeInputPartial
}

export type MutationDscrCreateArgs = {
  data: DscrInput
}

export type MutationDscrUpdateArgs = {
  data: DscrInputPartial
}

export type MutationEscalationCreateArgs = {
  data: EscalationInput
}

export type MutationEscalationUpdateArgs = {
  data: EscalationInputPartial
}

export type MutationExpenseCreateArgs = {
  data: ExpenseInput
}

export type MutationExpenseUpdateArgs = {
  data: ExpenseInputPartial
}

export type MutationFactorCreateArgs = {
  data: FactorInput
}

export type MutationFactorUpdateArgs = {
  data: FactorInputPartial
}

export type MutationHoiCreateArgs = {
  data: HoiInput
}

export type MutationHoiUpdateArgs = {
  data: HoiInputPartial
}

export type MutationIncomeCreateArgs = {
  data: IncomeInput
}

export type MutationIncomeUpdateArgs = {
  data: IncomeInputPartial
}

export type MutationKickBackCreateArgs = {
  data: KickBackInput
}

export type MutationKickBackUpdateArgs = {
  data: KickBackInputPartial
}

export type MutationMessageTemplateCreateArgs = {
  data: MessageTemplateInput
}

export type MutationMessageTemplateDeleteArgs = {
  data: MessageTemplateInputPartial
}

export type MutationMessageTemplateUpdateArgs = {
  data: MessageTemplateInputPartial
}

export type MutationMessagesCreateArgs = {
  data: MessagesInput
}

export type MutationMessagesUpdateArgs = {
  data: MessagesInputPartial
}

export type MutationMultiDocumentsRequestCreateArgs = {
  data: MultiDocumentsRequestInput
}

export type MutationMultiDocumentsRequestUpdateArgs = {
  data: MultiDocumentsRequestInputPartial
}

export type MutationNotesCreateArgs = {
  data: NotesInput
}

export type MutationNotesUpdateArgs = {
  data: NotesInputPartial
}

export type MutationNotificationsCreateArgs = {
  data: NotificationsInput
}

export type MutationNotificationsUpdateArgs = {
  data: NotificationsInputPartial
}

export type MutationOfferCreateArgs = {
  data: OfferInput
}

export type MutationOfferUpdateArgs = {
  data: OfferInputPartial
}

export type MutationOverridesCreateArgs = {
  data: OverridesInput
}

export type MutationOverridesUpdateArgs = {
  data: OverridesInputPartial
}

export type MutationPartyCreateArgs = {
  data: PartyInput
}

export type MutationPartyUpdateArgs = {
  data: PartyInputPartial
}

export type MutationPriceAclCreateArgs = {
  data: PriceAclInput
}

export type MutationPriceAclUpdateArgs = {
  data: PriceAclInputPartial
}

export type MutationPriceConfigCreateArgs = {
  data: PriceConfigInput
}

export type MutationPriceConfigUpdateArgs = {
  data: PriceConfigInputPartial
}

export type MutationPriceCreateArgs = {
  data: PriceInput
}

export type MutationPriceExchangeRateCreateArgs = {
  data: PriceExchangeRateInput
}

export type MutationPriceExchangeRateUpdateArgs = {
  data: PriceExchangeRateInputPartial
}

export type MutationPriceExchangeRateValueCreateArgs = {
  data: PriceExchangeRateValueInput
}

export type MutationPriceExchangeRateValueUpdateArgs = {
  data: PriceExchangeRateValueInputPartial
}

export type MutationPriceThflBracketCreateArgs = {
  data: PriceThflBracketInput
}

export type MutationPriceThflBracketUpdateArgs = {
  data: PriceThflBracketInputPartial
}

export type MutationPriceUpdateArgs = {
  data: PriceInputPartial
}

export type MutationProfileCreateArgs = {
  data: ProfileInput
}

export type MutationProfilePropertyCreateArgs = {
  data: ProfilePropertyInput
}

export type MutationProfilePropertyUpdateArgs = {
  data: ProfilePropertyInputPartial
}

export type MutationProfileUpdateArgs = {
  data: ProfileInputPartial
}

export type MutationPropertyCreateArgs = {
  data: PropertyInput
}

export type MutationPropertyFlagCreateArgs = {
  data: PropertyFlagInput
}

export type MutationPropertyFlagUpdateArgs = {
  data: PropertyFlagInputPartial
}

export type MutationPropertyUpdateArgs = {
  data: PropertyInputPartial
}

export type MutationServicingPayoffRequestCreateArgs = {
  data: ServicingPayoffRequestInput
}

export type MutationServicingPayoffRequestUpdateArgs = {
  data: ServicingPayoffRequestInputPartial
}

export type MutationServicingTaskCreateArgs = {
  data: ServicingTaskInput
}

export type MutationServicingTaskGroupCreateArgs = {
  data: ServicingTaskGroupInput
}

export type MutationServicingTaskGroupUpdateArgs = {
  data: ServicingTaskGroupInputPartial
}

export type MutationServicingTaskUpdateArgs = {
  data: ServicingTaskInputPartial
}

export type MutationSnapshotCreateArgs = {
  data: SnapshotInput
}

export type MutationSnapshotUpdateArgs = {
  data: SnapshotInputPartial
}

export type MutationStateCreateArgs = {
  data: StateInput
}

export type MutationStateUpdateArgs = {
  data: StateInputPartial
}

export type MutationStreamingNoteCreateArgs = {
  data: StreamingNoteInput
}

export type MutationStreamingNoteReactionCreateArgs = {
  data: StreamingNoteReactionInput
}

export type MutationStreamingNoteReactionUpdateArgs = {
  data: StreamingNoteReactionInputPartial
}

export type MutationStreamingNoteUpdateArgs = {
  data: StreamingNoteInputPartial
}

export type MutationSubscriberCreateArgs = {
  data: SubscriberInput
}

export type MutationSubscriberUpdateArgs = {
  data: SubscriberInputPartial
}

export type MutationTemplateDocumentCreateArgs = {
  data: TemplateDocumentInput
}

export type MutationTemplateDocumentUpdateArgs = {
  data: TemplateDocumentInputPartial
}

export type MutationTitleOrderCreateArgs = {
  data: TitleOrderInput
}

export type MutationTitleOrderUpdateArgs = {
  data: TitleOrderInputPartial
}

export type MutationTitleReportCreateArgs = {
  data: TitleReportInput
}

export type MutationTitleReportUpdateArgs = {
  data: TitleReportInputPartial
}

export type MutationTradelineCreateArgs = {
  data: TradelineInput
}

export type MutationTradelineUpdateArgs = {
  data: TradelineInputPartial
}

export type MutationUseOfProceedsCreateArgs = {
  data: UseOfProceedsInput
}

export type MutationUseOfProceedsUpdateArgs = {
  data: UseOfProceedsInputPartial
}

export type MutationUserDataCreateArgs = {
  data: UserDataInput
}

export type MutationUserDataUpdateArgs = {
  data: UserDataInputPartial
}

export type MutationUserIncomeCreateArgs = {
  data: UserIncomeInput
}

export type MutationUserIncomeUpdateArgs = {
  data: UserIncomeInputPartial
}

export type MutationValuationCreateArgs = {
  data: ValuationInput
}

export type MutationValuationUpdateArgs = {
  data: ValuationInputPartial
}

export type MutationWorkQueuesCreateArgs = {
  data: WorkQueuesInput
}

export type MutationWorkQueuesPresetCreateArgs = {
  data: WorkQueuesPresetInput
}

export type MutationWorkQueuesPresetUpdateArgs = {
  data: WorkQueuesPresetInputPartial
}

export type MutationWorkQueuesUpdateArgs = {
  data: WorkQueuesInputPartial
}

export type MutationZendeskTicketCreateArgs = {
  data: ZendeskTicketInput
}

export type MutationZendeskTicketUpdateArgs = {
  data: ZendeskTicketInputPartial
}

export type Notes = {
  __typename?: 'Notes'
  application: Application
  author?: Maybe<DjangoModelType>
  content: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type NotesFilter = {
  AND?: InputMaybe<NotesFilter>
  NOT?: InputMaybe<NotesFilter>
  OR?: InputMaybe<NotesFilter>
  pk: Scalars['ID']['input']
}

export type NotesInput = {
  application: OneToManyInput
  author?: InputMaybe<OneToManyInput>
  content: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type NotesInputPartial = {
  application?: InputMaybe<OneToManyInput>
  author?: InputMaybe<OneToManyInput>
  content?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  type?: InputMaybe<Scalars['String']['input']>
}

export type NotesOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type NotesUpdatePayload = Notes | OperationInfo

export type Notifications = {
  __typename?: 'Notifications'
  application: Application
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<DjangoModelType>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  readAt?: Maybe<Scalars['DateTime']['output']>
  seen: Scalars['Boolean']['output']
  text?: Maybe<Scalars['String']['output']>
  to?: Maybe<DjangoModelType>
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type NotificationsFilter = {
  AND?: InputMaybe<NotificationsFilter>
  NOT?: InputMaybe<NotificationsFilter>
  OR?: InputMaybe<NotificationsFilter>
  pk: Scalars['ID']['input']
}

export type NotificationsInput = {
  application: OneToManyInput
  createdBy?: InputMaybe<OneToManyInput>
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  seen?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<OneToManyInput>
  type: Scalars['String']['input']
}

export type NotificationsInputPartial = {
  application?: InputMaybe<OneToManyInput>
  createdBy?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  seen?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<OneToManyInput>
  type?: InputMaybe<Scalars['String']['input']>
}

export type NotificationsOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type NotificationsUpdatePayload = Notifications | OperationInfo

export type Offer = {
  __typename?: 'Offer'
  annualizedCostLimit?: Maybe<Scalars['Decimal']['output']>
  application: Application
  combinedLoanToValue?: Maybe<Scalars['Decimal']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  exchangeRate?: Maybe<Scalars['Decimal']['output']>
  id: Scalars['ID']['output']
  inputDebt?: Maybe<Scalars['Decimal']['output']>
  inputFico?: Maybe<Scalars['Decimal']['output']>
  inputHomeValue?: Maybe<Scalars['Decimal']['output']>
  inputPropertyUsage: Scalars['String']['output']
  inputRequestedOffer?: Maybe<Scalars['Decimal']['output']>
  investmentAmount?: Maybe<Scalars['Int']['output']>
  investmentPercentage?: Maybe<Scalars['Decimal']['output']>
  loanToValue?: Maybe<Scalars['Decimal']['output']>
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  termInYears?: Maybe<Scalars['Int']['output']>
  thfLimit?: Maybe<Scalars['Decimal']['output']>
  totalHomeFinance?: Maybe<Scalars['Decimal']['output']>
  triggeringProfile: Profile
  unlockShare?: Maybe<Scalars['Decimal']['output']>
  uuid: Scalars['UUID']['output']
}

export type OfferCalculationsType = {
  __typename?: 'OfferCalculationsType'
  _cachedAt?: Maybe<Scalars['DateTime']['output']>
  aggregateInvestmentPayment?: Maybe<Scalars['Float']['output']>
  annualizedCostLimit?: Maybe<Scalars['Float']['output']>
  annualizedCostLimitGuideline?: Maybe<Scalars['Float']['output']>
  estimatedClosingCost?: Maybe<Scalars['Float']['output']>
  exchangeRate?: Maybe<Scalars['Float']['output']>
  exchangeRateGuideline?: Maybe<Scalars['Float']['output']>
  investmentPropertyPremium?: Maybe<Scalars['Float']['output']>
  maxCostBenefitRatio?: Maybe<Scalars['Float']['output']>
  maxEstimatedClosingCost?: Maybe<Scalars['Float']['output']>
  maxInvestmentGuideline?: Maybe<Scalars['Float']['output']>
  maxNetCashProceeds?: Maybe<Scalars['Float']['output']>
  maxOffer?: Maybe<CalculatedOffer>
  maxOfferPayoff?: Maybe<Scalars['Float']['output']>
  minHomeValue?: Maybe<Scalars['Float']['output']>
  netCashProceeds?: Maybe<Scalars['Float']['output']>
  netCashProceedsPrePayoffs?: Maybe<Scalars['Float']['output']>
  offerCostBenefitRatio?: Maybe<Scalars['Float']['output']>
  offerGuidelines?: Maybe<CalculatedOffer>
  requestedOffer?: Maybe<CalculatedRequestedOffer>
  requestedThf?: Maybe<Scalars['Float']['output']>
  selectedOffer?: Maybe<CalculatedOffer>
  selectedOfferPayoff?: Maybe<Scalars['Float']['output']>
}

export type OfferFilter = {
  AND?: InputMaybe<OfferFilter>
  NOT?: InputMaybe<OfferFilter>
  OR?: InputMaybe<OfferFilter>
  pk: Scalars['ID']['input']
}

export type OfferInput = {
  annualizedCostLimit?: InputMaybe<Scalars['Decimal']['input']>
  application?: InputMaybe<OneToManyInput>
  combinedLoanToValue?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRate?: InputMaybe<Scalars['Decimal']['input']>
  inputDebt?: InputMaybe<Scalars['Decimal']['input']>
  inputFico?: InputMaybe<Scalars['Decimal']['input']>
  inputHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  inputPropertyUsage?: InputMaybe<Scalars['String']['input']>
  inputRequestedOffer?: InputMaybe<Scalars['Decimal']['input']>
  investmentAmount?: InputMaybe<Scalars['Int']['input']>
  investmentPercentage?: InputMaybe<Scalars['Decimal']['input']>
  loanToValue?: InputMaybe<Scalars['Decimal']['input']>
  termInYears?: InputMaybe<Scalars['Int']['input']>
  thfLimit?: InputMaybe<Scalars['Decimal']['input']>
  totalHomeFinance?: InputMaybe<Scalars['Decimal']['input']>
  triggeringProfile?: InputMaybe<OneToManyInput>
  unlockShare?: InputMaybe<Scalars['Decimal']['input']>
}

export type OfferInputPartial = {
  annualizedCostLimit?: InputMaybe<Scalars['Decimal']['input']>
  application?: InputMaybe<OneToManyInput>
  combinedLoanToValue?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRate?: InputMaybe<Scalars['Decimal']['input']>
  inputDebt?: InputMaybe<Scalars['Decimal']['input']>
  inputFico?: InputMaybe<Scalars['Decimal']['input']>
  inputHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  inputPropertyUsage?: InputMaybe<Scalars['String']['input']>
  inputRequestedOffer?: InputMaybe<Scalars['Decimal']['input']>
  investmentAmount?: InputMaybe<Scalars['Int']['input']>
  investmentPercentage?: InputMaybe<Scalars['Decimal']['input']>
  loanToValue?: InputMaybe<Scalars['Decimal']['input']>
  pk: Scalars['ID']['input']
  termInYears?: InputMaybe<Scalars['Int']['input']>
  thfLimit?: InputMaybe<Scalars['Decimal']['input']>
  totalHomeFinance?: InputMaybe<Scalars['Decimal']['input']>
  triggeringProfile?: InputMaybe<OneToManyInput>
  unlockShare?: InputMaybe<Scalars['Decimal']['input']>
}

export type OfferOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type OfferUpdatePayload = Offer | OperationInfo

export type Offers = {
  __typename?: 'Offers'
  baseExchangeRate?: Maybe<Scalars['Float']['output']>
  ctv?: Maybe<Scalars['Float']['output']>
  exchangeRate?: Maybe<Scalars['Float']['output']>
  offerInvestment?: Maybe<Scalars['Float']['output']>
  offerInvestmentPercentage?: Maybe<Scalars['Float']['output']>
  totalHomeFinance?: Maybe<Scalars['Float']['output']>
  totalHomeFinanceCap?: Maybe<Scalars['Float']['output']>
  unlockShare?: Maybe<Scalars['Float']['output']>
}

export type OffsetPaginationInput = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
}

export type OneToManyInput = {
  set?: InputMaybe<Scalars['ID']['input']>
}

export type OneToOneInput = {
  set?: InputMaybe<Scalars['ID']['input']>
}

export type OperationInfo = {
  __typename?: 'OperationInfo'
  /** List of messages returned by the operation. */
  messages: Array<OperationMessage>
}

export type OperationMessage = {
  __typename?: 'OperationMessage'
  /** The error code, or `null` if no error code was set. */
  code?: Maybe<Scalars['String']['output']>
  /** The field that caused the error, or `null` if it isn't associated with any particular field. */
  field?: Maybe<Scalars['String']['output']>
  /** The kind of this message. */
  kind: OperationMessageKind
  /** The error message. */
  message: Scalars['String']['output']
}

export enum OperationMessageKind {
  Error = 'ERROR',
  Info = 'INFO',
  Permission = 'PERMISSION',
  Validation = 'VALIDATION',
  Warning = 'WARNING',
}

export enum Ordering {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Overrides = {
  __typename?: 'Overrides'
  annualizedCostLimit?: Maybe<Scalars['Decimal']['output']>
  application: Application
  assetManagementCommentary?: Maybe<Scalars['String']['output']>
  cltvLimit?: Maybe<Scalars['Decimal']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  dscr?: Maybe<Scalars['Decimal']['output']>
  dti?: Maybe<Scalars['Decimal']['output']>
  exceptionApproved?: Maybe<Scalars['Boolean']['output']>
  exchangeRate?: Maybe<Scalars['Decimal']['output']>
  exchangeRateAdjustment?: Maybe<Scalars['Decimal']['output']>
  exchangeRateAdjustmentType?: Maybe<Scalars['String']['output']>
  exchangeRateMaxOffer?: Maybe<Scalars['Decimal']['output']>
  fico?: Maybe<Scalars['Int']['output']>
  homeValue?: Maybe<Scalars['Decimal']['output']>
  homeValueOverrideType?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  maxInvestment?: Maybe<Scalars['Int']['output']>
  minInvestment?: Maybe<Scalars['Int']['output']>
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  term?: Maybe<Scalars['Int']['output']>
  totalHomeFinancingLimit?: Maybe<Scalars['Decimal']['output']>
  uuid: Scalars['UUID']['output']
}

export type OverridesFilter = {
  AND?: InputMaybe<OverridesFilter>
  NOT?: InputMaybe<OverridesFilter>
  OR?: InputMaybe<OverridesFilter>
  pk: Scalars['ID']['input']
}

export type OverridesInput = {
  annualizedCostLimit?: InputMaybe<Scalars['Decimal']['input']>
  application: OneToOneInput
  assetManagementCommentary?: InputMaybe<Scalars['String']['input']>
  cltvLimit?: InputMaybe<Scalars['Decimal']['input']>
  dscr?: InputMaybe<Scalars['Decimal']['input']>
  dti?: InputMaybe<Scalars['Decimal']['input']>
  exceptionApproved?: InputMaybe<Scalars['Boolean']['input']>
  exchangeRate?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRateAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRateAdjustmentType?: InputMaybe<Scalars['String']['input']>
  exchangeRateMaxOffer?: InputMaybe<Scalars['Decimal']['input']>
  fico?: InputMaybe<Scalars['Int']['input']>
  homeValue?: InputMaybe<Scalars['Decimal']['input']>
  homeValueOverrideType?: InputMaybe<Scalars['String']['input']>
  maxInvestment?: InputMaybe<Scalars['Int']['input']>
  minInvestment?: InputMaybe<Scalars['Int']['input']>
  term?: InputMaybe<Scalars['Int']['input']>
  totalHomeFinancingLimit?: InputMaybe<Scalars['Decimal']['input']>
}

export type OverridesInputPartial = {
  annualizedCostLimit?: InputMaybe<Scalars['Decimal']['input']>
  application?: InputMaybe<OneToOneInput>
  assetManagementCommentary?: InputMaybe<Scalars['String']['input']>
  cltvLimit?: InputMaybe<Scalars['Decimal']['input']>
  dscr?: InputMaybe<Scalars['Decimal']['input']>
  dti?: InputMaybe<Scalars['Decimal']['input']>
  exceptionApproved?: InputMaybe<Scalars['Boolean']['input']>
  exchangeRate?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRateAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRateAdjustmentType?: InputMaybe<Scalars['String']['input']>
  exchangeRateMaxOffer?: InputMaybe<Scalars['Decimal']['input']>
  fico?: InputMaybe<Scalars['Int']['input']>
  homeValue?: InputMaybe<Scalars['Decimal']['input']>
  homeValueOverrideType?: InputMaybe<Scalars['String']['input']>
  maxInvestment?: InputMaybe<Scalars['Int']['input']>
  minInvestment?: InputMaybe<Scalars['Int']['input']>
  pk: Scalars['ID']['input']
  term?: InputMaybe<Scalars['Int']['input']>
  totalHomeFinancingLimit?: InputMaybe<Scalars['Decimal']['input']>
}

export type OverridesOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type OverridesUpdatePayload = OperationInfo | Overrides

export type Party = {
  __typename?: 'Party'
  address?: Maybe<Scalars['String']['output']>
  applicationpartySet: Array<ApplicationParty>
  applications: Array<Application>
  borLicense?: Maybe<Scalars['String']['output']>
  borState?: Maybe<Scalars['String']['output']>
  bornOn?: Maybe<Scalars['Date']['output']>
  contactName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  heoNmlsDisplayName?: Maybe<Scalars['String']['output']>
  heoNmlsId?: Maybe<Scalars['String']['output']>
  heoStateNmlsNumber?: Maybe<Scalars['String']['output']>
  hoaSubdivisionName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  idExpirationDate?: Maybe<Scalars['Date']['output']>
  isUsCitizenOrGreenCardHolder?: Maybe<Scalars['Boolean']['output']>
  modifiedAt: Scalars['DateTime']['output']
  name?: Maybe<Scalars['String']['output']>
  nmlsBranchLicenseNumber?: Maybe<Scalars['String']['output']>
  nmlsOriginatorLicenseNumber?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  referringPoints?: Maybe<Scalars['Decimal']['output']>
  socialSecurityNumber?: Maybe<Scalars['String']['output']>
  socialSecurityNumberHash?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
}

export type PartyApplicationpartySetArgs = {
  filters?: InputMaybe<ApplicationPartyFilter>
  order?: InputMaybe<ApplicationPartyOrder>
}

export type PartyApplicationsArgs = {
  filters?: InputMaybe<ApplicationFilter>
  order?: InputMaybe<ApplicationOrder>
}

export type PartyFilter = {
  AND?: InputMaybe<PartyFilter>
  NOT?: InputMaybe<PartyFilter>
  OR?: InputMaybe<PartyFilter>
  pk: Scalars['ID']['input']
}

export type PartyInput = {
  address?: InputMaybe<Scalars['String']['input']>
  borLicense?: InputMaybe<Scalars['String']['input']>
  borState?: InputMaybe<Scalars['String']['input']>
  bornOn?: InputMaybe<Scalars['Date']['input']>
  contactName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  heoNmlsDisplayName?: InputMaybe<Scalars['String']['input']>
  heoNmlsId?: InputMaybe<Scalars['String']['input']>
  heoStateNmlsNumber?: InputMaybe<Scalars['String']['input']>
  hoaSubdivisionName?: InputMaybe<Scalars['String']['input']>
  idExpirationDate?: InputMaybe<Scalars['Date']['input']>
  isUsCitizenOrGreenCardHolder?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nmlsBranchLicenseNumber?: InputMaybe<Scalars['String']['input']>
  nmlsOriginatorLicenseNumber?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  referringPoints?: InputMaybe<Scalars['Decimal']['input']>
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumberHash?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type PartyInputPartial = {
  address?: InputMaybe<Scalars['String']['input']>
  borLicense?: InputMaybe<Scalars['String']['input']>
  borState?: InputMaybe<Scalars['String']['input']>
  bornOn?: InputMaybe<Scalars['Date']['input']>
  contactName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  heoNmlsDisplayName?: InputMaybe<Scalars['String']['input']>
  heoNmlsId?: InputMaybe<Scalars['String']['input']>
  heoStateNmlsNumber?: InputMaybe<Scalars['String']['input']>
  hoaSubdivisionName?: InputMaybe<Scalars['String']['input']>
  idExpirationDate?: InputMaybe<Scalars['Date']['input']>
  isUsCitizenOrGreenCardHolder?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nmlsBranchLicenseNumber?: InputMaybe<Scalars['String']['input']>
  nmlsOriginatorLicenseNumber?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  referringPoints?: InputMaybe<Scalars['Decimal']['input']>
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumberHash?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type PartyOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PartyUpdatePayload = OperationInfo | Party

export type Price = {
  __typename?: 'Price'
  acl: PriceAcl
  config: PriceConfig
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<DjangoModelType>
  dateToPublish?: Maybe<Scalars['DateTime']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  draft?: Maybe<Scalars['Boolean']['output']>
  exchangeRate: PriceExchangeRate
  id: Scalars['ID']['output']
  isDefault?: Maybe<Scalars['Boolean']['output']>
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  published?: Maybe<Scalars['Boolean']['output']>
  semanticVersion?: Maybe<Scalars['String']['output']>
  thfl: DjangoModelType
  uuid: Scalars['UUID']['output']
  valid?: Maybe<Scalars['Boolean']['output']>
  version?: Maybe<Scalars['Decimal']['output']>
}

export type PriceAcl = {
  __typename?: 'PriceACL'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  overLimitValue: Scalars['Decimal']['output']
  pk: Scalars['ID']['output']
  priceSet: Array<Price>
  thfLimit: Scalars['Decimal']['output']
  underOrEqualLimitValue: Scalars['Decimal']['output']
  uuid: Scalars['UUID']['output']
}

export type PriceAclPriceSetArgs = {
  filters?: InputMaybe<PriceFilter>
  order?: InputMaybe<PriceOrder>
}

export type PriceAclFilter = {
  AND?: InputMaybe<PriceAclFilter>
  NOT?: InputMaybe<PriceAclFilter>
  OR?: InputMaybe<PriceAclFilter>
  pk: Scalars['ID']['input']
}

export type PriceAclInput = {
  overLimitValue: Scalars['Decimal']['input']
  thfLimit: Scalars['Decimal']['input']
  underOrEqualLimitValue: Scalars['Decimal']['input']
}

export type PriceAclInputPartial = {
  overLimitValue?: InputMaybe<Scalars['Decimal']['input']>
  pk: Scalars['ID']['input']
  thfLimit?: InputMaybe<Scalars['Decimal']['input']>
  underOrEqualLimitValue?: InputMaybe<Scalars['Decimal']['input']>
}

export type PriceAclOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PriceAclUpdatePayload = OperationInfo | PriceAcl

export type PriceConfig = {
  __typename?: 'PriceConfig'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  maxHomeValue: Scalars['Decimal']['output']
  maxInvestment: Scalars['Decimal']['output']
  minFico: Scalars['Int']['output']
  minHomeValue: Scalars['Decimal']['output']
  minInvestment: Scalars['Decimal']['output']
  minInvestmentFico: Scalars['Int']['output']
  modifiedAt: Scalars['DateTime']['output']
  name?: Maybe<Scalars['String']['output']>
  originationFeePercentage: Scalars['Decimal']['output']
  pk: Scalars['ID']['output']
  priceSet: Array<Price>
  pricingThreshold: Scalars['Decimal']['output']
  shareGuideline: Scalars['Decimal']['output']
  unlock1stLien: Scalars['Decimal']['output']
  uuid: Scalars['UUID']['output']
  versionNotes: Scalars['String']['output']
}

export type PriceConfigPriceSetArgs = {
  filters?: InputMaybe<PriceFilter>
  order?: InputMaybe<PriceOrder>
}

export type PriceConfigFilter = {
  AND?: InputMaybe<PriceConfigFilter>
  NOT?: InputMaybe<PriceConfigFilter>
  OR?: InputMaybe<PriceConfigFilter>
  pk: Scalars['ID']['input']
}

export type PriceConfigInput = {
  maxHomeValue: Scalars['Decimal']['input']
  maxInvestment: Scalars['Decimal']['input']
  minFico?: InputMaybe<Scalars['Int']['input']>
  minHomeValue: Scalars['Decimal']['input']
  minInvestment: Scalars['Decimal']['input']
  minInvestmentFico?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  originationFeePercentage: Scalars['Decimal']['input']
  pricingThreshold?: InputMaybe<Scalars['Decimal']['input']>
  shareGuideline: Scalars['Decimal']['input']
  unlock1stLien: Scalars['Decimal']['input']
  versionNotes: Scalars['String']['input']
}

export type PriceConfigInputPartial = {
  maxHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  maxInvestment?: InputMaybe<Scalars['Decimal']['input']>
  minFico?: InputMaybe<Scalars['Int']['input']>
  minHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  minInvestment?: InputMaybe<Scalars['Decimal']['input']>
  minInvestmentFico?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  originationFeePercentage?: InputMaybe<Scalars['Decimal']['input']>
  pk: Scalars['ID']['input']
  pricingThreshold?: InputMaybe<Scalars['Decimal']['input']>
  shareGuideline?: InputMaybe<Scalars['Decimal']['input']>
  unlock1stLien?: InputMaybe<Scalars['Decimal']['input']>
  versionNotes?: InputMaybe<Scalars['String']['input']>
}

export type PriceConfigOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PriceConfigUpdatePayload = OperationInfo | PriceConfig

export type PriceExchangeRate = {
  __typename?: 'PriceExchangeRate'
  adjustment: Scalars['Decimal']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  priceSet: Array<Price>
  priceexchangeratevalueSet: Array<PriceExchangeRateValue>
  uuid: Scalars['UUID']['output']
}

export type PriceExchangeRatePriceSetArgs = {
  filters?: InputMaybe<PriceFilter>
  order?: InputMaybe<PriceOrder>
}

export type PriceExchangeRatePriceexchangeratevalueSetArgs = {
  filters?: InputMaybe<PriceExchangeRateValueFilter>
  order?: InputMaybe<PriceExchangeRateValueOrder>
}

export type PriceExchangeRateFilter = {
  AND?: InputMaybe<PriceExchangeRateFilter>
  NOT?: InputMaybe<PriceExchangeRateFilter>
  OR?: InputMaybe<PriceExchangeRateFilter>
  pk: Scalars['ID']['input']
}

export type PriceExchangeRateInput = {
  adjustment: Scalars['Decimal']['input']
}

export type PriceExchangeRateInputPartial = {
  adjustment?: InputMaybe<Scalars['Decimal']['input']>
  pk: Scalars['ID']['input']
}

export type PriceExchangeRateOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PriceExchangeRateUpdatePayload = OperationInfo | PriceExchangeRate

export type PriceExchangeRateValue = {
  __typename?: 'PriceExchangeRateValue'
  best: Scalars['Decimal']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  priceExchangeRate: PriceExchangeRate
  propertyUsage: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
  worst: Scalars['Decimal']['output']
}

export type PriceExchangeRateValueFilter = {
  AND?: InputMaybe<PriceExchangeRateValueFilter>
  NOT?: InputMaybe<PriceExchangeRateValueFilter>
  OR?: InputMaybe<PriceExchangeRateValueFilter>
  pk: Scalars['ID']['input']
}

export type PriceExchangeRateValueInput = {
  best: Scalars['Decimal']['input']
  priceExchangeRate: OneToManyInput
  propertyUsage: Scalars['String']['input']
  worst: Scalars['Decimal']['input']
}

export type PriceExchangeRateValueInputPartial = {
  best?: InputMaybe<Scalars['Decimal']['input']>
  pk: Scalars['ID']['input']
  priceExchangeRate?: InputMaybe<OneToManyInput>
  propertyUsage?: InputMaybe<Scalars['String']['input']>
  worst?: InputMaybe<Scalars['Decimal']['input']>
}

export type PriceExchangeRateValueOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PriceExchangeRateValueUpdatePayload = OperationInfo | PriceExchangeRateValue

export type PriceFilter = {
  AND?: InputMaybe<PriceFilter>
  NOT?: InputMaybe<PriceFilter>
  OR?: InputMaybe<PriceFilter>
  pk: Scalars['ID']['input']
}

export type PriceInput = {
  acl: OneToManyInput
  config: OneToManyInput
  createdBy?: InputMaybe<OneToManyInput>
  dateToPublish?: InputMaybe<Scalars['DateTime']['input']>
  draft?: InputMaybe<Scalars['Boolean']['input']>
  exchangeRate: OneToManyInput
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  semanticVersion?: InputMaybe<Scalars['String']['input']>
  thfl: OneToManyInput
  valid?: InputMaybe<Scalars['Boolean']['input']>
  version?: InputMaybe<Scalars['Decimal']['input']>
}

export type PriceInputPartial = {
  acl?: InputMaybe<OneToManyInput>
  config?: InputMaybe<OneToManyInput>
  createdBy?: InputMaybe<OneToManyInput>
  dateToPublish?: InputMaybe<Scalars['DateTime']['input']>
  draft?: InputMaybe<Scalars['Boolean']['input']>
  exchangeRate?: InputMaybe<OneToManyInput>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  pk: Scalars['ID']['input']
  published?: InputMaybe<Scalars['Boolean']['input']>
  semanticVersion?: InputMaybe<Scalars['String']['input']>
  thfl?: InputMaybe<OneToManyInput>
  valid?: InputMaybe<Scalars['Boolean']['input']>
  version?: InputMaybe<Scalars['Decimal']['input']>
}

export type PriceOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PriceThflBracket = {
  __typename?: 'PriceTHFLBracket'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  investment: Scalars['Decimal']['output']
  lowerLimit: Scalars['Int']['output']
  lowerLimitHomeValue?: Maybe<Scalars['Decimal']['output']>
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  priceThfl: DjangoModelType
  principalResidence: Scalars['Decimal']['output']
  secondHome: Scalars['Decimal']['output']
  topLimit: Scalars['Int']['output']
  topLimitHomeValue?: Maybe<Scalars['Decimal']['output']>
  uuid: Scalars['UUID']['output']
}

export type PriceThflBracketFilter = {
  AND?: InputMaybe<PriceThflBracketFilter>
  NOT?: InputMaybe<PriceThflBracketFilter>
  OR?: InputMaybe<PriceThflBracketFilter>
  pk: Scalars['ID']['input']
}

export type PriceThflBracketInput = {
  investment: Scalars['Decimal']['input']
  lowerLimit: Scalars['Int']['input']
  lowerLimitHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  priceThfl: OneToManyInput
  principalResidence: Scalars['Decimal']['input']
  secondHome: Scalars['Decimal']['input']
  topLimit: Scalars['Int']['input']
  topLimitHomeValue?: InputMaybe<Scalars['Decimal']['input']>
}

export type PriceThflBracketInputPartial = {
  investment?: InputMaybe<Scalars['Decimal']['input']>
  lowerLimit?: InputMaybe<Scalars['Int']['input']>
  lowerLimitHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  pk: Scalars['ID']['input']
  priceThfl?: InputMaybe<OneToManyInput>
  principalResidence?: InputMaybe<Scalars['Decimal']['input']>
  secondHome?: InputMaybe<Scalars['Decimal']['input']>
  topLimit?: InputMaybe<Scalars['Int']['input']>
  topLimitHomeValue?: InputMaybe<Scalars['Decimal']['input']>
}

export type PriceThflBracketOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PriceThflBracketUpdatePayload = OperationInfo | PriceThflBracket

export type PriceUpdatePayload = OperationInfo | Price

export type Profile = {
  __typename?: 'Profile'
  anonymousId?: Maybe<Scalars['String']['output']>
  applicationProfiles: Array<ApplicationProfile>
  applications: Array<Application>
  bornOn?: Maybe<Scalars['Date']['output']>
  checklistitemSet: Array<ChecklistItem>
  consentedToCreditAt?: Maybe<Scalars['DateTime']['output']>
  consentedToPrivacyAt?: Maybe<Scalars['DateTime']['output']>
  consentedToSpouseImpersonationAt?: Maybe<Scalars['DateTime']['output']>
  consentedToTermsAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  denialReason?: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  estimatedFico?: Maybe<Scalars['Int']['output']>
  externalId: Scalars['String']['output']
  firstName: Scalars['String']['output']
  fullName?: Maybe<Scalars['String']['output']>
  highestEducation?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isManuallyCreated: Scalars['Boolean']['output']
  isRetired?: Maybe<Scalars['Boolean']['output']>
  isSelfEmployed?: Maybe<Scalars['Boolean']['output']>
  isUsCitizenOrGreenCardHolder?: Maybe<Scalars['Boolean']['output']>
  jiraAccountId?: Maybe<Scalars['String']['output']>
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName: Scalars['String']['output']
  lastSeen?: Maybe<Scalars['DateTime']['output']>
  loginMethod: Scalars['String']['output']
  loginMethodChosen?: Maybe<Scalars['Boolean']['output']>
  mailingAddress: Address
  maritalStatus?: Maybe<Scalars['String']['output']>
  maritalStatusOption?: Maybe<Scalars['String']['output']>
  marriageDate?: Maybe<Scalars['Date']['output']>
  methodEntityId?: Maybe<Scalars['String']['output']>
  middleName?: Maybe<Scalars['String']['output']>
  modifiedAt: Scalars['DateTime']['output']
  offerSet: Array<Offer>
  onTitle?: Maybe<Scalars['Boolean']['output']>
  outreachLegacyUnlockId?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  photoIdExpire?: Maybe<Scalars['Date']['output']>
  pk: Scalars['ID']['output']
  profileSet: Array<Profile>
  profilepropertySet: Array<ProfileProperty>
  properties: Array<Property>
  role: Scalars['String']['output']
  school?: Maybe<Scalars['String']['output']>
  socialSecurityNumber?: Maybe<Scalars['String']['output']>
  socialSecurityNumberHash?: Maybe<Scalars['String']['output']>
  spouseFullName?: Maybe<Scalars['String']['output']>
  spouseProfile: Profile
  suffix?: Maybe<Scalars['String']['output']>
  syncMailingAddress: Scalars['Boolean']['output']
  thirdPartySource?: Maybe<Scalars['String']['output']>
  titleMaritalStatus?: Maybe<Scalars['String']['output']>
  tradelineSet: Array<Tradeline>
  user?: Maybe<DjangoModelType>
  username?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
  yearsInProfession?: Maybe<Scalars['Int']['output']>
  yearsOfSchool?: Maybe<Scalars['Int']['output']>
  yearsOnJob?: Maybe<Scalars['Int']['output']>
}

export type ProfileApplicationProfilesArgs = {
  filters?: InputMaybe<ApplicationProfileFilter>
  order?: InputMaybe<ApplicationProfileOrder>
}

export type ProfileApplicationsArgs = {
  filters?: InputMaybe<ApplicationFilter>
  order?: InputMaybe<ApplicationOrder>
}

export type ProfileChecklistitemSetArgs = {
  filters?: InputMaybe<ChecklistItemFilter>
  order?: InputMaybe<ChecklistItemOrder>
}

export type ProfileOfferSetArgs = {
  filters?: InputMaybe<OfferFilter>
  order?: InputMaybe<OfferOrder>
}

export type ProfileProfileSetArgs = {
  filters?: InputMaybe<ProfileFilter>
  order?: InputMaybe<ProfileOrder>
}

export type ProfileProfilepropertySetArgs = {
  filters?: InputMaybe<ProfilePropertyFilter>
  order?: InputMaybe<ProfilePropertyOrder>
}

export type ProfilePropertiesArgs = {
  filters?: InputMaybe<PropertyFilter>
  order?: InputMaybe<PropertyOrder>
}

export type ProfileTradelineSetArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
}

export type ProfileFilter = {
  AND?: InputMaybe<ProfileFilter>
  NOT?: InputMaybe<ProfileFilter>
  OR?: InputMaybe<ProfileFilter>
  pk: Scalars['ID']['input']
}

export type ProfileInput = {
  anonymousId?: InputMaybe<Scalars['String']['input']>
  bornOn?: InputMaybe<Scalars['Date']['input']>
  consentedToCreditAt?: InputMaybe<Scalars['DateTime']['input']>
  consentedToPrivacyAt?: InputMaybe<Scalars['DateTime']['input']>
  consentedToSpouseImpersonationAt?: InputMaybe<Scalars['DateTime']['input']>
  consentedToTermsAt?: InputMaybe<Scalars['DateTime']['input']>
  denialReason?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedFico?: InputMaybe<Scalars['Int']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  highestEducation?: InputMaybe<Scalars['String']['input']>
  isManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>
  isRetired?: InputMaybe<Scalars['Boolean']['input']>
  isSelfEmployed?: InputMaybe<Scalars['Boolean']['input']>
  isUsCitizenOrGreenCardHolder?: InputMaybe<Scalars['Boolean']['input']>
  jiraAccountId?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lastSeen?: InputMaybe<Scalars['DateTime']['input']>
  loginMethod?: InputMaybe<Scalars['String']['input']>
  loginMethodChosen?: InputMaybe<Scalars['Boolean']['input']>
  mailingAddress?: InputMaybe<OneToManyInput>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  maritalStatusOption?: InputMaybe<Scalars['String']['input']>
  marriageDate?: InputMaybe<Scalars['Date']['input']>
  methodEntityId?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  onTitle?: InputMaybe<Scalars['Boolean']['input']>
  outreachLegacyUnlockId?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  photoIdExpire?: InputMaybe<Scalars['Date']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  school?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumberHash?: InputMaybe<Scalars['String']['input']>
  spouseFullName?: InputMaybe<Scalars['String']['input']>
  spouseProfile?: InputMaybe<OneToManyInput>
  suffix?: InputMaybe<Scalars['String']['input']>
  syncMailingAddress?: InputMaybe<Scalars['Boolean']['input']>
  thirdPartySource?: InputMaybe<Scalars['String']['input']>
  titleMaritalStatus?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<OneToManyInput>
  username?: InputMaybe<Scalars['String']['input']>
  yearsInProfession?: InputMaybe<Scalars['Int']['input']>
  yearsOfSchool?: InputMaybe<Scalars['Int']['input']>
  yearsOnJob?: InputMaybe<Scalars['Int']['input']>
}

export type ProfileInputPartial = {
  anonymousId?: InputMaybe<Scalars['String']['input']>
  bornOn?: InputMaybe<Scalars['Date']['input']>
  consentedToCreditAt?: InputMaybe<Scalars['DateTime']['input']>
  consentedToPrivacyAt?: InputMaybe<Scalars['DateTime']['input']>
  consentedToSpouseImpersonationAt?: InputMaybe<Scalars['DateTime']['input']>
  consentedToTermsAt?: InputMaybe<Scalars['DateTime']['input']>
  denialReason?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedFico?: InputMaybe<Scalars['Int']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  highestEducation?: InputMaybe<Scalars['String']['input']>
  isManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>
  isRetired?: InputMaybe<Scalars['Boolean']['input']>
  isSelfEmployed?: InputMaybe<Scalars['Boolean']['input']>
  isUsCitizenOrGreenCardHolder?: InputMaybe<Scalars['Boolean']['input']>
  jiraAccountId?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lastSeen?: InputMaybe<Scalars['DateTime']['input']>
  loginMethod?: InputMaybe<Scalars['String']['input']>
  loginMethodChosen?: InputMaybe<Scalars['Boolean']['input']>
  mailingAddress?: InputMaybe<OneToManyInput>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  maritalStatusOption?: InputMaybe<Scalars['String']['input']>
  marriageDate?: InputMaybe<Scalars['Date']['input']>
  methodEntityId?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  onTitle?: InputMaybe<Scalars['Boolean']['input']>
  outreachLegacyUnlockId?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  photoIdExpire?: InputMaybe<Scalars['Date']['input']>
  pk: Scalars['ID']['input']
  role?: InputMaybe<Scalars['String']['input']>
  school?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumberHash?: InputMaybe<Scalars['String']['input']>
  spouseFullName?: InputMaybe<Scalars['String']['input']>
  spouseProfile?: InputMaybe<OneToManyInput>
  suffix?: InputMaybe<Scalars['String']['input']>
  syncMailingAddress?: InputMaybe<Scalars['Boolean']['input']>
  thirdPartySource?: InputMaybe<Scalars['String']['input']>
  titleMaritalStatus?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<OneToManyInput>
  username?: InputMaybe<Scalars['String']['input']>
  yearsInProfession?: InputMaybe<Scalars['Int']['input']>
  yearsOfSchool?: InputMaybe<Scalars['Int']['input']>
  yearsOnJob?: InputMaybe<Scalars['Int']['input']>
}

export type ProfileOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ProfileProperty = {
  __typename?: 'ProfileProperty'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  profile: Profile
  property: Property
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type ProfilePropertyFilter = {
  AND?: InputMaybe<ProfilePropertyFilter>
  NOT?: InputMaybe<ProfilePropertyFilter>
  OR?: InputMaybe<ProfilePropertyFilter>
  pk: Scalars['ID']['input']
}

export type ProfilePropertyInput = {
  profile: OneToManyInput
  property: OneToManyInput
  type: Scalars['String']['input']
}

export type ProfilePropertyInputPartial = {
  pk: Scalars['ID']['input']
  profile?: InputMaybe<OneToManyInput>
  property?: InputMaybe<OneToManyInput>
  type?: InputMaybe<Scalars['String']['input']>
}

export type ProfilePropertyOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ProfilePropertyUpdatePayload = OperationInfo | ProfileProperty

export type ProfileUpdatePayload = OperationInfo | Profile

export type Property = {
  __typename?: 'Property'
  address: Address
  applications: Array<Application>
  aquiredOn?: Maybe<Scalars['Date']['output']>
  aquiredPrice?: Maybe<Scalars['Decimal']['output']>
  baths?: Maybe<Scalars['Int']['output']>
  beds?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  dtiEscrowStatus: Scalars['String']['output']
  estimatedDebt: Scalars['Decimal']['output']
  estimatedUnpaidPrinciple?: Maybe<Scalars['Decimal']['output']>
  estimatedValue: Scalars['Decimal']['output']
  externalId: Scalars['String']['output']
  grossLivingArea?: Maybe<Scalars['Int']['output']>
  hoas: Array<Hoa>
  id: Scalars['Int']['output']
  imageInformation?: Maybe<Scalars['JSON']['output']>
  insuranceOrdered?: Maybe<Scalars['Date']['output']>
  insuranceReceived?: Maybe<Scalars['Date']['output']>
  isHoa?: Maybe<Scalars['Boolean']['output']>
  isLeaseAgreementRequired: Scalars['Boolean']['output']
  lotSize?: Maybe<Scalars['Float']['output']>
  modifiedAt: Scalars['DateTime']['output']
  monthlyCostFlood?: Maybe<Scalars['Decimal']['output']>
  monthlyCostHoa?: Maybe<Scalars['Decimal']['output']>
  monthlyCostInsuranceHazard?: Maybe<Scalars['Decimal']['output']>
  monthlyCostInsuranceMortgage?: Maybe<Scalars['Decimal']['output']>
  monthlyCostOther?: Maybe<Scalars['Decimal']['output']>
  monthlyCostPrincipleInterest?: Maybe<Scalars['Decimal']['output']>
  monthlyCostTaxes?: Maybe<Scalars['Decimal']['output']>
  monthlyGrossRent?: Maybe<Scalars['Decimal']['output']>
  name?: Maybe<Scalars['String']['output']>
  occupancy?: Maybe<Scalars['String']['output']>
  offerErrors?: Maybe<Scalars['String']['output']>
  ownerVestingType?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  profilepropertySet: Array<ProfileProperty>
  profiles: Array<Profile>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyUsage?: Maybe<Scalars['String']['output']>
  roofSolarPanel?: Maybe<Scalars['Boolean']['output']>
  titleHeld?: Maybe<Scalars['String']['output']>
  titleOwnership?: Maybe<Scalars['String']['output']>
  titleVesting?: Maybe<Scalars['String']['output']>
  tradelineSet: Array<Tradeline>
  trusteeType?: Maybe<Scalars['String']['output']>
  units?: Maybe<Scalars['Int']['output']>
  uuid: Scalars['UUID']['output']
  vestingNames?: Maybe<Scalars['String']['output']>
  yearBuilt?: Maybe<Scalars['Int']['output']>
}

export type PropertyApplicationsArgs = {
  filters?: InputMaybe<ApplicationFilter>
  order?: InputMaybe<ApplicationOrder>
}

export type PropertyHoasArgs = {
  filters?: InputMaybe<HoaFilter>
  order?: InputMaybe<HoaOrder>
}

export type PropertyProfilepropertySetArgs = {
  filters?: InputMaybe<ProfilePropertyFilter>
  order?: InputMaybe<ProfilePropertyOrder>
}

export type PropertyProfilesArgs = {
  filters?: InputMaybe<ProfileFilter>
  order?: InputMaybe<ProfileOrder>
}

export type PropertyTradelineSetArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
}

export type PropertyFilter = {
  AND?: InputMaybe<PropertyFilter>
  NOT?: InputMaybe<PropertyFilter>
  OR?: InputMaybe<PropertyFilter>
  id: Scalars['Int']['input']
  pk: Scalars['ID']['input']
}

export type PropertyFlag = {
  __typename?: 'PropertyFlag'
  answer?: Maybe<Scalars['Boolean']['output']>
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  readAt?: Maybe<Scalars['DateTime']['output']>
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type PropertyFlagFilter = {
  AND?: InputMaybe<PropertyFlagFilter>
  NOT?: InputMaybe<PropertyFlagFilter>
  OR?: InputMaybe<PropertyFlagFilter>
  pk: Scalars['ID']['input']
}

export type PropertyFlagInput = {
  answer?: InputMaybe<Scalars['Boolean']['input']>
  application: OneToManyInput
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  type: Scalars['String']['input']
}

export type PropertyFlagInputPartial = {
  answer?: InputMaybe<Scalars['Boolean']['input']>
  application?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type PropertyFlagOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PropertyFlagUpdatePayload = OperationInfo | PropertyFlag

export type PropertyInput = {
  address?: InputMaybe<OneToManyInput>
  aquiredOn?: InputMaybe<Scalars['Date']['input']>
  aquiredPrice?: InputMaybe<Scalars['Decimal']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  dtiEscrowStatus?: InputMaybe<Scalars['String']['input']>
  estimatedDebt?: InputMaybe<Scalars['Decimal']['input']>
  estimatedUnpaidPrinciple?: InputMaybe<Scalars['Decimal']['input']>
  estimatedValue?: InputMaybe<Scalars['Decimal']['input']>
  grossLivingArea?: InputMaybe<Scalars['Int']['input']>
  imageInformation?: InputMaybe<Scalars['JSON']['input']>
  insuranceOrdered?: InputMaybe<Scalars['Date']['input']>
  insuranceReceived?: InputMaybe<Scalars['Date']['input']>
  isHoa?: InputMaybe<Scalars['Boolean']['input']>
  isLeaseAgreementRequired?: InputMaybe<Scalars['Boolean']['input']>
  lotSize?: InputMaybe<Scalars['Float']['input']>
  monthlyCostFlood?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostHoa?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostInsuranceHazard?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostInsuranceMortgage?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostOther?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostPrincipleInterest?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostTaxes?: InputMaybe<Scalars['Decimal']['input']>
  monthlyGrossRent?: InputMaybe<Scalars['Decimal']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  occupancy?: InputMaybe<Scalars['String']['input']>
  offerErrors?: InputMaybe<Scalars['String']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyUsage?: InputMaybe<Scalars['String']['input']>
  roofSolarPanel?: InputMaybe<Scalars['Boolean']['input']>
  titleHeld?: InputMaybe<Scalars['String']['input']>
  titleOwnership?: InputMaybe<Scalars['String']['input']>
  titleVesting?: InputMaybe<Scalars['String']['input']>
  trusteeType?: InputMaybe<Scalars['String']['input']>
  units?: InputMaybe<Scalars['Int']['input']>
  vestingNames?: InputMaybe<Scalars['String']['input']>
  yearBuilt?: InputMaybe<Scalars['Int']['input']>
}

export type PropertyInputPartial = {
  address?: InputMaybe<OneToManyInput>
  aquiredOn?: InputMaybe<Scalars['Date']['input']>
  aquiredPrice?: InputMaybe<Scalars['Decimal']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  dtiEscrowStatus?: InputMaybe<Scalars['String']['input']>
  estimatedDebt?: InputMaybe<Scalars['Decimal']['input']>
  estimatedUnpaidPrinciple?: InputMaybe<Scalars['Decimal']['input']>
  estimatedValue?: InputMaybe<Scalars['Decimal']['input']>
  grossLivingArea?: InputMaybe<Scalars['Int']['input']>
  imageInformation?: InputMaybe<Scalars['JSON']['input']>
  insuranceOrdered?: InputMaybe<Scalars['Date']['input']>
  insuranceReceived?: InputMaybe<Scalars['Date']['input']>
  isHoa?: InputMaybe<Scalars['Boolean']['input']>
  isLeaseAgreementRequired?: InputMaybe<Scalars['Boolean']['input']>
  lotSize?: InputMaybe<Scalars['Float']['input']>
  monthlyCostFlood?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostHoa?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostInsuranceHazard?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostInsuranceMortgage?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostOther?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostPrincipleInterest?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostTaxes?: InputMaybe<Scalars['Decimal']['input']>
  monthlyGrossRent?: InputMaybe<Scalars['Decimal']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  occupancy?: InputMaybe<Scalars['String']['input']>
  offerErrors?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyUsage?: InputMaybe<Scalars['String']['input']>
  roofSolarPanel?: InputMaybe<Scalars['Boolean']['input']>
  titleHeld?: InputMaybe<Scalars['String']['input']>
  titleOwnership?: InputMaybe<Scalars['String']['input']>
  titleVesting?: InputMaybe<Scalars['String']['input']>
  trusteeType?: InputMaybe<Scalars['String']['input']>
  units?: InputMaybe<Scalars['Int']['input']>
  vestingNames?: InputMaybe<Scalars['String']['input']>
  yearBuilt?: InputMaybe<Scalars['Int']['input']>
}

export type PropertyOrder = {
  id?: InputMaybe<Scalars['Int']['input']>
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type PropertyUpdatePayload = OperationInfo | Property

export type Query = {
  __typename?: 'Query'
  address: Address
  alert: Alert
  allAddresses: Array<Address>
  allAlerts: Array<Alert>
  allApplicationExceptions: Array<ApplicationException>
  allApplicationParties: Array<ApplicationParty>
  allApplicationProfiles: Array<ApplicationProfile>
  allApplications: Array<Application>
  allAppraisalOrders: Array<AppraisalOrder>
  allAssets: Array<Asset>
  allAtypicalityChecks: Array<AtypicalityCheck>
  allBackgroundTasks: Array<BackgroundTask>
  allCompanies: Array<Company>
  allCreditReportApplicants: Array<CreditReportApplicant>
  allCreditReportScores: Array<CreditReportScore>
  allCreditReports: Array<CreditReport>
  allCustomTokens: Array<CustomToken>
  allCustomerActions: Array<CustomerAction>
  allDealTeams: Array<DealTeam>
  allDeclarations: Array<Declaration>
  allDocumentFiles: Array<DocumentFile>
  allDocumentTemplates: Array<DocumentTemplate>
  allDocumentTradelines: Array<DocumentTradeline>
  allDocuments: Array<Document>
  allDocusignEnvelopeApplicationProfiles: Array<DocusignEnvelopeApplicationProfile>
  allDocusignEnvelopes: Array<DocusignEnvelope>
  allDscrs: Array<Dscr>
  allEscalations: Array<Escalation>
  allExpenses: Array<Expense>
  allFactors: Array<Factor>
  allHois: Array<Hoi>
  allIncomes: Array<Income>
  allKickBacks: Array<KickBack>
  allMessage: Array<Messages>
  allMessageTemplates: Array<MessageTemplate>
  allMultiDocumentsRequests: Array<MultiDocumentsRequest>
  allNote: Array<Notes>
  allNotification: Array<Notifications>
  allOffers: Array<Offer>
  allOverride: Array<Overrides>
  allParties: Array<Party>
  allPriceAcls: Array<PriceAcl>
  allPriceConfigs: Array<PriceConfig>
  allPriceExchangeRateValues: Array<PriceExchangeRateValue>
  allPriceExchangeRates: Array<PriceExchangeRate>
  allPriceThflBrackets: Array<PriceThflBracket>
  allPrices: Array<Price>
  allProfileProperties: Array<ProfileProperty>
  allProfiles: Array<Profile>
  allProperties: Array<Property>
  allPropertyFlags: Array<PropertyFlag>
  allServicingPayoffRequests: Array<ServicingPayoffRequest>
  allServicingTaskGroups: Array<ServicingTaskGroup>
  allServicingTasks: Array<ServicingTask>
  allSnapshots: Array<Snapshot>
  allStates: Array<State>
  allStreamingNoteReactions: Array<StreamingNoteReaction>
  allStreamingNotes: Array<StreamingNote>
  allSubscribers: Array<Subscriber>
  allTemplateDocuments: Array<TemplateDocument>
  allTitleOrders: Array<TitleOrder>
  allTitleReports: Array<TitleReport>
  allTradelines: Array<Tradeline>
  allUseOfProceed: Array<UseOfProceeds>
  allUserDatas: Array<UserData>
  allUserIncomes: Array<UserIncome>
  allValuations: Array<Valuation>
  allWorkQueue: Array<WorkQueues>
  allWorkQueuesPresets: Array<WorkQueuesPreset>
  allZendeskTickets: Array<ZendeskTicket>
  application: Application
  applicationException: ApplicationException
  applicationParty: ApplicationParty
  applicationProfile: ApplicationProfile
  appraisalOrder: AppraisalOrder
  asset: Asset
  atypicalityCheck: AtypicalityCheck
  backgroundTask: BackgroundTask
  company: Company
  creditReport: CreditReport
  creditReportApplicant: CreditReportApplicant
  creditReportScore: CreditReportScore
  customToken: CustomToken
  customerAction: CustomerAction
  dealTeam: DealTeam
  declaration: Declaration
  document: Document
  documentFile: DocumentFile
  documentTemplate: DocumentTemplate
  documentTradeline: DocumentTradeline
  docusignEnvelope: DocusignEnvelope
  docusignEnvelopeApplicationProfile: DocusignEnvelopeApplicationProfile
  dscr: Dscr
  escalation: Escalation
  expense: Expense
  factor: Factor
  hoi: Hoi
  income: Income
  kickBack: KickBack
  messageTemplate: MessageTemplate
  messages: Messages
  multiDocumentsRequest: MultiDocumentsRequest
  notes: Notes
  notifications: Notifications
  offer: Offer
  overrides: Overrides
  party: Party
  price: Price
  priceAcl: PriceAcl
  priceConfig: PriceConfig
  priceExchangeRate: PriceExchangeRate
  priceExchangeRateValue: PriceExchangeRateValue
  priceThflBracket: PriceThflBracket
  profile: Profile
  profileProperty: ProfileProperty
  property: Property
  propertyFlag: PropertyFlag
  servicingPayoffRequest: ServicingPayoffRequest
  servicingTask: ServicingTask
  servicingTaskGroup: ServicingTaskGroup
  snapshot: Snapshot
  state: State
  streamingNote: StreamingNote
  streamingNoteReaction: StreamingNoteReaction
  subscriber: Subscriber
  templateDocument: TemplateDocument
  titleOrder: TitleOrder
  titleReport: TitleReport
  tradeline: Tradeline
  useOfProceeds: UseOfProceeds
  userData: UserData
  userIncome: UserIncome
  valuation: Valuation
  workQueues: WorkQueues
  workQueuesPreset: WorkQueuesPreset
  zendeskTicket: ZendeskTicket
}

export type QueryAddressArgs = {
  pk: Scalars['ID']['input']
}

export type QueryAlertArgs = {
  pk: Scalars['ID']['input']
}

export type QueryAllAddressesArgs = {
  filters?: InputMaybe<AddressFilter>
  order?: InputMaybe<AddressOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllAlertsArgs = {
  filters?: InputMaybe<AlertFilter>
  order?: InputMaybe<AlertOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllApplicationExceptionsArgs = {
  filters?: InputMaybe<ApplicationExceptionFilter>
  order?: InputMaybe<ApplicationExceptionOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllApplicationPartiesArgs = {
  filters?: InputMaybe<ApplicationPartyFilter>
  order?: InputMaybe<ApplicationPartyOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllApplicationProfilesArgs = {
  filters?: InputMaybe<ApplicationProfileFilter>
  order?: InputMaybe<ApplicationProfileOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllApplicationsArgs = {
  filters?: InputMaybe<ApplicationFilter>
  order?: InputMaybe<ApplicationOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllAppraisalOrdersArgs = {
  filters?: InputMaybe<AppraisalOrderFilter>
  order?: InputMaybe<AppraisalOrderOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllAssetsArgs = {
  filters?: InputMaybe<AssetFilter>
  order?: InputMaybe<AssetOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllAtypicalityChecksArgs = {
  filters?: InputMaybe<AtypicalityCheckFilter>
  order?: InputMaybe<AtypicalityCheckOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllBackgroundTasksArgs = {
  filters?: InputMaybe<BackgroundTaskFilter>
  order?: InputMaybe<BackgroundTaskOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllCompaniesArgs = {
  filters?: InputMaybe<CompanyFilter>
  order?: InputMaybe<CompanyOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllCreditReportApplicantsArgs = {
  filters?: InputMaybe<CreditReportApplicantFilter>
  order?: InputMaybe<CreditReportApplicantOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllCreditReportScoresArgs = {
  filters?: InputMaybe<CreditReportScoreFilter>
  order?: InputMaybe<CreditReportScoreOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllCreditReportsArgs = {
  filters?: InputMaybe<CreditReportFilter>
  order?: InputMaybe<CreditReportOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllCustomTokensArgs = {
  filters?: InputMaybe<CustomTokenFilter>
  order?: InputMaybe<CustomTokenOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllCustomerActionsArgs = {
  filters?: InputMaybe<CustomerActionFilter>
  order?: InputMaybe<CustomerActionOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDealTeamsArgs = {
  filters?: InputMaybe<DealTeamFilter>
  order?: InputMaybe<DealTeamOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDeclarationsArgs = {
  filters?: InputMaybe<DeclarationFilter>
  order?: InputMaybe<DeclarationOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDocumentFilesArgs = {
  filters?: InputMaybe<DocumentFileFilter>
  order?: InputMaybe<DocumentFileOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDocumentTemplatesArgs = {
  filters?: InputMaybe<DocumentTemplateFilter>
  order?: InputMaybe<DocumentTemplateOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDocumentTradelinesArgs = {
  filters?: InputMaybe<DocumentTradelineFilter>
  order?: InputMaybe<DocumentTradelineOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDocumentsArgs = {
  filters?: InputMaybe<DocumentFilter>
  order?: InputMaybe<DocumentOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDocusignEnvelopeApplicationProfilesArgs = {
  filters?: InputMaybe<DocusignEnvelopeApplicationProfileFilter>
  order?: InputMaybe<DocusignEnvelopeApplicationProfileOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDocusignEnvelopesArgs = {
  filters?: InputMaybe<DocusignEnvelopeFilter>
  order?: InputMaybe<DocusignEnvelopeOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllDscrsArgs = {
  filters?: InputMaybe<DscrFilter>
  order?: InputMaybe<DscrOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllEscalationsArgs = {
  filters?: InputMaybe<EscalationFilter>
  order?: InputMaybe<EscalationOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllExpensesArgs = {
  filters?: InputMaybe<ExpenseFilter>
  order?: InputMaybe<ExpenseOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllFactorsArgs = {
  filters?: InputMaybe<FactorFilter>
  order?: InputMaybe<FactorOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllHoisArgs = {
  filters?: InputMaybe<HoiFilter>
  order?: InputMaybe<HoiOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllIncomesArgs = {
  filters?: InputMaybe<IncomeFilter>
  order?: InputMaybe<IncomeOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllKickBacksArgs = {
  filters?: InputMaybe<KickBackFilter>
  order?: InputMaybe<KickBackOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllMessageArgs = {
  filters?: InputMaybe<MessagesFilter>
  order?: InputMaybe<MessagesOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllMessageTemplatesArgs = {
  filters?: InputMaybe<MessageTemplateFilter>
  order?: InputMaybe<MessageTemplateOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllMultiDocumentsRequestsArgs = {
  filters?: InputMaybe<MultiDocumentsRequestFilter>
  order?: InputMaybe<MultiDocumentsRequestOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllNoteArgs = {
  filters?: InputMaybe<NotesFilter>
  order?: InputMaybe<NotesOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllNotificationArgs = {
  filters?: InputMaybe<NotificationsFilter>
  order?: InputMaybe<NotificationsOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllOffersArgs = {
  filters?: InputMaybe<OfferFilter>
  order?: InputMaybe<OfferOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllOverrideArgs = {
  filters?: InputMaybe<OverridesFilter>
  order?: InputMaybe<OverridesOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPartiesArgs = {
  filters?: InputMaybe<PartyFilter>
  order?: InputMaybe<PartyOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPriceAclsArgs = {
  filters?: InputMaybe<PriceAclFilter>
  order?: InputMaybe<PriceAclOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPriceConfigsArgs = {
  filters?: InputMaybe<PriceConfigFilter>
  order?: InputMaybe<PriceConfigOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPriceExchangeRateValuesArgs = {
  filters?: InputMaybe<PriceExchangeRateValueFilter>
  order?: InputMaybe<PriceExchangeRateValueOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPriceExchangeRatesArgs = {
  filters?: InputMaybe<PriceExchangeRateFilter>
  order?: InputMaybe<PriceExchangeRateOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPriceThflBracketsArgs = {
  filters?: InputMaybe<PriceThflBracketFilter>
  order?: InputMaybe<PriceThflBracketOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPricesArgs = {
  filters?: InputMaybe<PriceFilter>
  order?: InputMaybe<PriceOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllProfilePropertiesArgs = {
  filters?: InputMaybe<ProfilePropertyFilter>
  order?: InputMaybe<ProfilePropertyOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllProfilesArgs = {
  filters?: InputMaybe<ProfileFilter>
  order?: InputMaybe<ProfileOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPropertiesArgs = {
  filters?: InputMaybe<PropertyFilter>
  order?: InputMaybe<PropertyOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllPropertyFlagsArgs = {
  filters?: InputMaybe<PropertyFlagFilter>
  order?: InputMaybe<PropertyFlagOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllServicingPayoffRequestsArgs = {
  filters?: InputMaybe<ServicingPayoffRequestFilter>
  order?: InputMaybe<ServicingPayoffRequestOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllServicingTaskGroupsArgs = {
  filters?: InputMaybe<ServicingTaskGroupFilter>
  order?: InputMaybe<ServicingTaskGroupOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllServicingTasksArgs = {
  filters?: InputMaybe<ServicingTaskFilter>
  order?: InputMaybe<ServicingTaskOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllSnapshotsArgs = {
  filters?: InputMaybe<SnapshotFilter>
  order?: InputMaybe<SnapshotOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllStatesArgs = {
  filters?: InputMaybe<StateFilter>
  order?: InputMaybe<StateOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllStreamingNoteReactionsArgs = {
  filters?: InputMaybe<StreamingNoteReactionFilter>
  order?: InputMaybe<StreamingNoteReactionOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllStreamingNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllSubscribersArgs = {
  filters?: InputMaybe<SubscriberFilter>
  order?: InputMaybe<SubscriberOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllTemplateDocumentsArgs = {
  filters?: InputMaybe<TemplateDocumentFilter>
  order?: InputMaybe<TemplateDocumentOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllTitleOrdersArgs = {
  filters?: InputMaybe<TitleOrderFilter>
  order?: InputMaybe<TitleOrderOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllTitleReportsArgs = {
  filters?: InputMaybe<TitleReportFilter>
  order?: InputMaybe<TitleReportOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllTradelinesArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllUseOfProceedArgs = {
  filters?: InputMaybe<UseOfProceedsFilter>
  order?: InputMaybe<UseOfProceedsOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllUserDatasArgs = {
  filters?: InputMaybe<UserDataFilter>
  order?: InputMaybe<UserDataOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllUserIncomesArgs = {
  filters?: InputMaybe<UserIncomeFilter>
  order?: InputMaybe<UserIncomeOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllValuationsArgs = {
  filters?: InputMaybe<ValuationFilter>
  order?: InputMaybe<ValuationOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllWorkQueueArgs = {
  filters?: InputMaybe<WorkQueuesFilter>
  order?: InputMaybe<WorkQueuesOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllWorkQueuesPresetsArgs = {
  filters?: InputMaybe<WorkQueuesPresetFilter>
  order?: InputMaybe<WorkQueuesPresetOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryAllZendeskTicketsArgs = {
  filters?: InputMaybe<ZendeskTicketFilter>
  order?: InputMaybe<ZendeskTicketOrder>
  pagination?: InputMaybe<OffsetPaginationInput>
}

export type QueryApplicationArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>
  uuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryApplicationExceptionArgs = {
  pk: Scalars['ID']['input']
}

export type QueryApplicationPartyArgs = {
  pk: Scalars['ID']['input']
}

export type QueryApplicationProfileArgs = {
  pk: Scalars['ID']['input']
}

export type QueryAppraisalOrderArgs = {
  pk: Scalars['ID']['input']
}

export type QueryAssetArgs = {
  pk: Scalars['ID']['input']
}

export type QueryAtypicalityCheckArgs = {
  pk: Scalars['ID']['input']
}

export type QueryBackgroundTaskArgs = {
  pk: Scalars['ID']['input']
}

export type QueryCompanyArgs = {
  pk: Scalars['ID']['input']
}

export type QueryCreditReportArgs = {
  pk: Scalars['ID']['input']
}

export type QueryCreditReportApplicantArgs = {
  pk: Scalars['ID']['input']
}

export type QueryCreditReportScoreArgs = {
  pk: Scalars['ID']['input']
}

export type QueryCustomTokenArgs = {
  pk: Scalars['ID']['input']
}

export type QueryCustomerActionArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDealTeamArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDeclarationArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDocumentArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDocumentFileArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDocumentTemplateArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDocumentTradelineArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDocusignEnvelopeArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDocusignEnvelopeApplicationProfileArgs = {
  pk: Scalars['ID']['input']
}

export type QueryDscrArgs = {
  pk: Scalars['ID']['input']
}

export type QueryEscalationArgs = {
  pk: Scalars['ID']['input']
}

export type QueryExpenseArgs = {
  pk: Scalars['ID']['input']
}

export type QueryFactorArgs = {
  pk: Scalars['ID']['input']
}

export type QueryHoiArgs = {
  pk: Scalars['ID']['input']
}

export type QueryIncomeArgs = {
  pk: Scalars['ID']['input']
}

export type QueryKickBackArgs = {
  pk: Scalars['ID']['input']
}

export type QueryMessageTemplateArgs = {
  pk: Scalars['ID']['input']
}

export type QueryMessagesArgs = {
  pk: Scalars['ID']['input']
}

export type QueryMultiDocumentsRequestArgs = {
  pk: Scalars['ID']['input']
}

export type QueryNotesArgs = {
  pk: Scalars['ID']['input']
}

export type QueryNotificationsArgs = {
  pk: Scalars['ID']['input']
}

export type QueryOfferArgs = {
  pk: Scalars['ID']['input']
}

export type QueryOverridesArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPartyArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPriceArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPriceAclArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPriceConfigArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPriceExchangeRateArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPriceExchangeRateValueArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPriceThflBracketArgs = {
  pk: Scalars['ID']['input']
}

export type QueryProfileArgs = {
  pk: Scalars['ID']['input']
}

export type QueryProfilePropertyArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPropertyArgs = {
  pk: Scalars['ID']['input']
}

export type QueryPropertyFlagArgs = {
  pk: Scalars['ID']['input']
}

export type QueryServicingPayoffRequestArgs = {
  pk: Scalars['ID']['input']
}

export type QueryServicingTaskArgs = {
  pk: Scalars['ID']['input']
}

export type QueryServicingTaskGroupArgs = {
  pk: Scalars['ID']['input']
}

export type QuerySnapshotArgs = {
  pk: Scalars['ID']['input']
}

export type QueryStateArgs = {
  pk: Scalars['ID']['input']
}

export type QueryStreamingNoteArgs = {
  pk: Scalars['ID']['input']
}

export type QueryStreamingNoteReactionArgs = {
  pk: Scalars['ID']['input']
}

export type QuerySubscriberArgs = {
  pk: Scalars['ID']['input']
}

export type QueryTemplateDocumentArgs = {
  pk: Scalars['ID']['input']
}

export type QueryTitleOrderArgs = {
  pk: Scalars['ID']['input']
}

export type QueryTitleReportArgs = {
  pk: Scalars['ID']['input']
}

export type QueryTradelineArgs = {
  pk: Scalars['ID']['input']
}

export type QueryUseOfProceedsArgs = {
  pk: Scalars['ID']['input']
}

export type QueryUserDataArgs = {
  pk: Scalars['ID']['input']
}

export type QueryUserIncomeArgs = {
  pk: Scalars['ID']['input']
}

export type QueryValuationArgs = {
  pk: Scalars['ID']['input']
}

export type QueryWorkQueuesArgs = {
  pk: Scalars['ID']['input']
}

export type QueryWorkQueuesPresetArgs = {
  pk: Scalars['ID']['input']
}

export type QueryZendeskTicketArgs = {
  pk: Scalars['ID']['input']
}

export type ServicingPayoffRequest = {
  __typename?: 'ServicingPayoffRequest'
  closedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  payoffStatementDocument: Document
  pk: Scalars['ID']['output']
  servicingtaskgroupSet: ServicingTaskGroup
  status: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type ServicingPayoffRequestFilter = {
  AND?: InputMaybe<ServicingPayoffRequestFilter>
  NOT?: InputMaybe<ServicingPayoffRequestFilter>
  OR?: InputMaybe<ServicingPayoffRequestFilter>
  pk: Scalars['ID']['input']
}

export type ServicingPayoffRequestInput = {
  closedAt?: InputMaybe<Scalars['DateTime']['input']>
  payoffStatementDocument?: InputMaybe<OneToManyInput>
  status?: InputMaybe<Scalars['String']['input']>
}

export type ServicingPayoffRequestInputPartial = {
  closedAt?: InputMaybe<Scalars['DateTime']['input']>
  payoffStatementDocument?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export type ServicingPayoffRequestOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ServicingPayoffRequestUpdatePayload = OperationInfo | ServicingPayoffRequest

export type ServicingTask = {
  __typename?: 'ServicingTask'
  applicationProfiles: Array<ApplicationProfile>
  createdAt: Scalars['DateTime']['output']
  customerResponse?: Maybe<Scalars['JSON']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  documents: Array<Document>
  group: ServicingTaskGroup
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  payload: Scalars['JSON']['output']
  pk: Scalars['ID']['output']
  readAt?: Maybe<Scalars['DateTime']['output']>
  status: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type ServicingTaskApplicationProfilesArgs = {
  filters?: InputMaybe<ApplicationProfileFilter>
  order?: InputMaybe<ApplicationProfileOrder>
}

export type ServicingTaskDocumentsArgs = {
  filters?: InputMaybe<DocumentFilter>
  order?: InputMaybe<DocumentOrder>
}

export type ServicingTaskFilter = {
  AND?: InputMaybe<ServicingTaskFilter>
  NOT?: InputMaybe<ServicingTaskFilter>
  OR?: InputMaybe<ServicingTaskFilter>
  pk: Scalars['ID']['input']
}

export type ServicingTaskGroup = {
  __typename?: 'ServicingTaskGroup'
  application: Application
  createdAt: Scalars['DateTime']['output']
  declineReason?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  pk: Scalars['ID']['output']
  servicingPayoffRequest: ServicingPayoffRequest
  servicingTasks: Array<ServicingTask>
  status: Scalars['String']['output']
  transferredTo?: Maybe<DjangoModelType>
  uuid: Scalars['UUID']['output']
  zendeskTicket: ZendeskTicket
}

export type ServicingTaskGroupServicingTasksArgs = {
  filters?: InputMaybe<ServicingTaskFilter>
  order?: InputMaybe<ServicingTaskOrder>
}

export type ServicingTaskGroupFilter = {
  AND?: InputMaybe<ServicingTaskGroupFilter>
  NOT?: InputMaybe<ServicingTaskGroupFilter>
  OR?: InputMaybe<ServicingTaskGroupFilter>
  pk: Scalars['ID']['input']
}

export type ServicingTaskGroupInput = {
  application: OneToManyInput
  declineReason?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  servicingPayoffRequest?: InputMaybe<OneToOneInput>
  status?: InputMaybe<Scalars['String']['input']>
  transferredTo?: InputMaybe<OneToManyInput>
  zendeskTicket?: InputMaybe<OneToManyInput>
}

export type ServicingTaskGroupInputPartial = {
  application?: InputMaybe<OneToManyInput>
  declineReason?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  servicingPayoffRequest?: InputMaybe<OneToOneInput>
  status?: InputMaybe<Scalars['String']['input']>
  transferredTo?: InputMaybe<OneToManyInput>
  zendeskTicket?: InputMaybe<OneToManyInput>
}

export type ServicingTaskGroupOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ServicingTaskGroupUpdatePayload = OperationInfo | ServicingTaskGroup

export type ServicingTaskInput = {
  customerResponse?: InputMaybe<Scalars['JSON']['input']>
  group?: InputMaybe<OneToManyInput>
  name: Scalars['String']['input']
  payload: Scalars['JSON']['input']
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type ServicingTaskInputPartial = {
  customerResponse?: InputMaybe<Scalars['JSON']['input']>
  group?: InputMaybe<OneToManyInput>
  name?: InputMaybe<Scalars['String']['input']>
  payload?: InputMaybe<Scalars['JSON']['input']>
  pk: Scalars['ID']['input']
  readAt?: InputMaybe<Scalars['DateTime']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type ServicingTaskOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ServicingTaskUpdatePayload = OperationInfo | ServicingTask

export type Snapshot = {
  __typename?: 'Snapshot'
  active: Scalars['Boolean']['output']
  application: Application
  content: Scalars['JSON']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  pk: Scalars['ID']['output']
  snapshot: Array<Document>
  user: UserData
  uuid: Scalars['UUID']['output']
}

export type SnapshotSnapshotArgs = {
  filters?: InputMaybe<DocumentFilter>
  order?: InputMaybe<DocumentOrder>
}

export type SnapshotFilter = {
  AND?: InputMaybe<SnapshotFilter>
  NOT?: InputMaybe<SnapshotFilter>
  OR?: InputMaybe<SnapshotFilter>
  pk: Scalars['ID']['input']
}

export type SnapshotInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  application?: InputMaybe<OneToManyInput>
  content?: InputMaybe<Scalars['JSON']['input']>
  name: Scalars['String']['input']
  user?: InputMaybe<OneToManyInput>
}

export type SnapshotInputPartial = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  application?: InputMaybe<OneToManyInput>
  content?: InputMaybe<Scalars['JSON']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  user?: InputMaybe<OneToManyInput>
}

export type SnapshotOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type SnapshotUpdatePayload = OperationInfo | Snapshot

export type State = {
  __typename?: 'State'
  agricultrualFee?: Maybe<Scalars['String']['output']>
  brokerRecord: Company
  corporateEntity?: Maybe<DjangoModelType>
  countyMortgageTax?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  fseaTemplate?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  intangibleTax?: Maybe<Scalars['String']['output']>
  modifiedAt: Scalars['DateTime']['output']
  nmlsBranchLicenseNumber?: Maybe<Scalars['String']['output']>
  nmlsEnabled?: Maybe<Scalars['Boolean']['output']>
  nmlsOriginatorLicenseNumber?: Maybe<Scalars['String']['output']>
  originatingContactPerson?: Maybe<Scalars['String']['output']>
  originatingEntity?: Maybe<Scalars['String']['output']>
  originatingEntityAddress?: Maybe<Scalars['String']['output']>
  originatingOrgEntityReLicenseNumber?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  recordingFees?: Maybe<Scalars['String']['output']>
  securityInstrument?: Maybe<Scalars['String']['output']>
  securityInstrumentTemplate?: Maybe<Scalars['String']['output']>
  spouseRequired?: Maybe<Scalars['Boolean']['output']>
  spouseRequiredExceptions?: Maybe<Scalars['String']['output']>
  state: Scalars['String']['output']
  stateAbbreviation?: Maybe<Scalars['String']['output']>
  stateMortgageTax?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  trustee?: Maybe<Scalars['String']['output']>
  trusteeAddress?: Maybe<Scalars['String']['output']>
  uuid: Scalars['UUID']['output']
}

export type StateFilter = {
  AND?: InputMaybe<StateFilter>
  NOT?: InputMaybe<StateFilter>
  OR?: InputMaybe<StateFilter>
  pk: Scalars['ID']['input']
}

export type StateInput = {
  agricultrualFee?: InputMaybe<Scalars['String']['input']>
  brokerRecord?: InputMaybe<OneToManyInput>
  corporateEntity?: InputMaybe<OneToManyInput>
  countyMortgageTax?: InputMaybe<Scalars['String']['input']>
  fseaTemplate?: InputMaybe<Scalars['String']['input']>
  intangibleTax?: InputMaybe<Scalars['String']['input']>
  nmlsBranchLicenseNumber?: InputMaybe<Scalars['String']['input']>
  nmlsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  nmlsOriginatorLicenseNumber?: InputMaybe<Scalars['String']['input']>
  originatingContactPerson?: InputMaybe<Scalars['String']['input']>
  originatingEntity?: InputMaybe<Scalars['String']['input']>
  originatingEntityAddress?: InputMaybe<Scalars['String']['input']>
  originatingOrgEntityReLicenseNumber?: InputMaybe<Scalars['String']['input']>
  recordingFees?: InputMaybe<Scalars['String']['input']>
  securityInstrument?: InputMaybe<Scalars['String']['input']>
  securityInstrumentTemplate?: InputMaybe<Scalars['String']['input']>
  spouseRequired?: InputMaybe<Scalars['Boolean']['input']>
  spouseRequiredExceptions?: InputMaybe<Scalars['String']['input']>
  state: Scalars['String']['input']
  stateAbbreviation?: InputMaybe<Scalars['String']['input']>
  stateMortgageTax?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  trustee?: InputMaybe<Scalars['String']['input']>
  trusteeAddress?: InputMaybe<Scalars['String']['input']>
}

export type StateInputPartial = {
  agricultrualFee?: InputMaybe<Scalars['String']['input']>
  brokerRecord?: InputMaybe<OneToManyInput>
  corporateEntity?: InputMaybe<OneToManyInput>
  countyMortgageTax?: InputMaybe<Scalars['String']['input']>
  fseaTemplate?: InputMaybe<Scalars['String']['input']>
  intangibleTax?: InputMaybe<Scalars['String']['input']>
  nmlsBranchLicenseNumber?: InputMaybe<Scalars['String']['input']>
  nmlsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  nmlsOriginatorLicenseNumber?: InputMaybe<Scalars['String']['input']>
  originatingContactPerson?: InputMaybe<Scalars['String']['input']>
  originatingEntity?: InputMaybe<Scalars['String']['input']>
  originatingEntityAddress?: InputMaybe<Scalars['String']['input']>
  originatingOrgEntityReLicenseNumber?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  recordingFees?: InputMaybe<Scalars['String']['input']>
  securityInstrument?: InputMaybe<Scalars['String']['input']>
  securityInstrumentTemplate?: InputMaybe<Scalars['String']['input']>
  spouseRequired?: InputMaybe<Scalars['Boolean']['input']>
  spouseRequiredExceptions?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  stateAbbreviation?: InputMaybe<Scalars['String']['input']>
  stateMortgageTax?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  trustee?: InputMaybe<Scalars['String']['input']>
  trusteeAddress?: InputMaybe<Scalars['String']['input']>
}

export type StateOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type StateUpdatePayload = OperationInfo | State

export type StrFilterLookup = {
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  exact?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  iContains?: InputMaybe<Scalars['String']['input']>
  iEndsWith?: InputMaybe<Scalars['String']['input']>
  iExact?: InputMaybe<Scalars['String']['input']>
  iRegex?: InputMaybe<Scalars['String']['input']>
  iStartsWith?: InputMaybe<Scalars['String']['input']>
  inList?: InputMaybe<Array<Scalars['String']['input']>>
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  range?: InputMaybe<Array<Scalars['String']['input']>>
  regex?: InputMaybe<Scalars['String']['input']>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type StreamingNote = {
  __typename?: 'StreamingNote'
  application: Application
  childStreamingNotes: Array<StreamingNote>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  document: Document
  documents: Array<Document>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  noteType: Scalars['String']['output']
  parentStreamingNote: StreamingNote
  pk: Scalars['ID']['output']
  reactions: Array<StreamingNoteReaction>
  seenBy: Array<UserData>
  taggedUsers: Array<UserData>
  text: Scalars['String']['output']
  textEditedAt?: Maybe<Scalars['DateTime']['output']>
  user: UserData
  uuid: Scalars['UUID']['output']
}

export type StreamingNoteChildStreamingNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type StreamingNoteDocumentsArgs = {
  filters?: InputMaybe<DocumentFilter>
  order?: InputMaybe<DocumentOrder>
}

export type StreamingNoteReactionsArgs = {
  filters?: InputMaybe<StreamingNoteReactionFilter>
  order?: InputMaybe<StreamingNoteReactionOrder>
}

export type StreamingNoteSeenByArgs = {
  filters?: InputMaybe<UserDataFilter>
  order?: InputMaybe<UserDataOrder>
}

export type StreamingNoteTaggedUsersArgs = {
  filters?: InputMaybe<UserDataFilter>
  order?: InputMaybe<UserDataOrder>
}

export type StreamingNoteFilter = {
  AND?: InputMaybe<StreamingNoteFilter>
  NOT?: InputMaybe<StreamingNoteFilter>
  OR?: InputMaybe<StreamingNoteFilter>
  pk: Scalars['ID']['input']
}

export type StreamingNoteInput = {
  application: OneToManyInput
  document?: InputMaybe<OneToManyInput>
  noteType?: InputMaybe<Scalars['String']['input']>
  parentStreamingNote?: InputMaybe<OneToManyInput>
  text?: InputMaybe<Scalars['String']['input']>
  textEditedAt?: InputMaybe<Scalars['DateTime']['input']>
  user: OneToManyInput
}

export type StreamingNoteInputPartial = {
  application?: InputMaybe<OneToManyInput>
  document?: InputMaybe<OneToManyInput>
  noteType?: InputMaybe<Scalars['String']['input']>
  parentStreamingNote?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  text?: InputMaybe<Scalars['String']['input']>
  textEditedAt?: InputMaybe<Scalars['DateTime']['input']>
  user?: InputMaybe<OneToManyInput>
}

export type StreamingNoteOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type StreamingNoteReaction = {
  __typename?: 'StreamingNoteReaction'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  emoji?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  streamingNote: StreamingNote
  user: DjangoModelType
  uuid: Scalars['UUID']['output']
}

export type StreamingNoteReactionFilter = {
  AND?: InputMaybe<StreamingNoteReactionFilter>
  NOT?: InputMaybe<StreamingNoteReactionFilter>
  OR?: InputMaybe<StreamingNoteReactionFilter>
  pk: Scalars['ID']['input']
}

export type StreamingNoteReactionInput = {
  emoji?: InputMaybe<Scalars['String']['input']>
  streamingNote: OneToManyInput
  user: OneToManyInput
}

export type StreamingNoteReactionInputPartial = {
  emoji?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  streamingNote?: InputMaybe<OneToManyInput>
  user?: InputMaybe<OneToManyInput>
}

export type StreamingNoteReactionOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type StreamingNoteReactionUpdatePayload = OperationInfo | StreamingNoteReaction

export type StreamingNoteUpdatePayload = OperationInfo | StreamingNote

export type Subscriber = {
  __typename?: 'Subscriber'
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  streamingNotesUnseen: Scalars['Int']['output']
  subscriber: Array<DealTeam>
  user: DjangoModelType
  uuid: Scalars['UUID']['output']
}

export type SubscriberSubscriberArgs = {
  filters?: InputMaybe<DealTeamFilter>
  order?: InputMaybe<DealTeamOrder>
}

export type SubscriberFilter = {
  AND?: InputMaybe<SubscriberFilter>
  NOT?: InputMaybe<SubscriberFilter>
  OR?: InputMaybe<SubscriberFilter>
  pk: Scalars['ID']['input']
}

export type SubscriberInput = {
  application: OneToManyInput
  streamingNotesUnseen?: InputMaybe<Scalars['Int']['input']>
  user: OneToManyInput
}

export type SubscriberInputPartial = {
  application?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  streamingNotesUnseen?: InputMaybe<Scalars['Int']['input']>
  user?: InputMaybe<OneToManyInput>
}

export type SubscriberOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type SubscriberUpdatePayload = OperationInfo | Subscriber

export type Subscription = {
  __typename?: 'Subscription'
  applicationCalculationsSubscription: ApplicationCalculationsType
  applicationSubscription: Application
  count: Scalars['Int']['output']
  expensesCalculationsSubscription: ExpensesCalculationsType
  offerCalculationsSubscription: OfferCalculationsType
  titleCalculationsSubscription: TitleCalculationsType
  tradelinesCalculationsSubscription: TradelinesCalculationsType
  valuationsCalculationsSubscription: ValuationsCalculationsType
}

export type SubscriptionApplicationCalculationsSubscriptionArgs = {
  externalId: Scalars['String']['input']
}

export type SubscriptionApplicationSubscriptionArgs = {
  externalId: Scalars['String']['input']
}

export type SubscriptionCountArgs = {
  target?: Scalars['Int']['input']
}

export type SubscriptionExpensesCalculationsSubscriptionArgs = {
  externalId: Scalars['String']['input']
}

export type SubscriptionOfferCalculationsSubscriptionArgs = {
  externalId: Scalars['String']['input']
}

export type SubscriptionTitleCalculationsSubscriptionArgs = {
  externalId: Scalars['String']['input']
}

export type SubscriptionTradelinesCalculationsSubscriptionArgs = {
  externalId: Scalars['String']['input']
}

export type SubscriptionValuationsCalculationsSubscriptionArgs = {
  externalId: Scalars['String']['input']
}

export type TemplateDocument = {
  __typename?: 'TemplateDocument'
  applicationProfile: ApplicationProfile
  category?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  customerLastSeenAt?: Maybe<Scalars['DateTime']['output']>
  customerVisible: Scalars['Boolean']['output']
  data?: Maybe<Scalars['JSON']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  destination?: Maybe<Scalars['String']['output']>
  document?: Maybe<Scalars['String']['output']>
  documentPtr: Document
  documentTemplate: DocumentTemplate
  documentTradeline: DocumentTradeline
  files: Array<DocumentFile>
  id: Scalars['ID']['output']
  identifier?: Maybe<Scalars['String']['output']>
  kind?: Maybe<Scalars['String']['output']>
  messages: Array<Messages>
  modifiedAt: Scalars['DateTime']['output']
  notes: Array<StreamingNote>
  originalFilename?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  servicingTask: ServicingTask
  servicingpayoffrequestSet: Array<ServicingPayoffRequest>
  singleFile: DjangoFileType
  size?: Maybe<Scalars['Int']['output']>
  snapshot: Snapshot
  source?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streamingNotes: Array<StreamingNote>
  tag?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  uploadFinishedAt?: Maybe<Scalars['DateTime']['output']>
  uuid: Scalars['UUID']['output']
}

export type TemplateDocumentFilesArgs = {
  filters?: InputMaybe<DocumentFileFilter>
  order?: InputMaybe<DocumentFileOrder>
}

export type TemplateDocumentMessagesArgs = {
  filters?: InputMaybe<MessagesFilter>
  order?: InputMaybe<MessagesOrder>
}

export type TemplateDocumentNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type TemplateDocumentServicingpayoffrequestSetArgs = {
  filters?: InputMaybe<ServicingPayoffRequestFilter>
  order?: InputMaybe<ServicingPayoffRequestOrder>
}

export type TemplateDocumentStreamingNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type TemplateDocumentFilter = {
  AND?: InputMaybe<TemplateDocumentFilter>
  NOT?: InputMaybe<TemplateDocumentFilter>
  OR?: InputMaybe<TemplateDocumentFilter>
  pk: Scalars['ID']['input']
}

export type TemplateDocumentInput = {
  applicationProfile?: InputMaybe<OneToManyInput>
  category?: InputMaybe<Scalars['String']['input']>
  customerLastSeenAt?: InputMaybe<Scalars['DateTime']['input']>
  customerVisible?: InputMaybe<Scalars['Boolean']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  destination?: InputMaybe<Scalars['String']['input']>
  document?: InputMaybe<Scalars['String']['input']>
  documentPtr: OneToOneInput
  documentTemplate?: InputMaybe<OneToManyInput>
  identifier?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  originalFilename?: InputMaybe<Scalars['String']['input']>
  servicingTask?: InputMaybe<OneToManyInput>
  singleFile: Scalars['Upload']['input']
  size?: InputMaybe<Scalars['Int']['input']>
  snapshot?: InputMaybe<OneToManyInput>
  source?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  uploadFinishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TemplateDocumentInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  category?: InputMaybe<Scalars['String']['input']>
  customerLastSeenAt?: InputMaybe<Scalars['DateTime']['input']>
  customerVisible?: InputMaybe<Scalars['Boolean']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  destination?: InputMaybe<Scalars['String']['input']>
  document?: InputMaybe<Scalars['String']['input']>
  documentPtr?: InputMaybe<OneToOneInput>
  documentTemplate?: InputMaybe<OneToManyInput>
  identifier?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  originalFilename?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  servicingTask?: InputMaybe<OneToManyInput>
  singleFile?: InputMaybe<Scalars['Upload']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  snapshot?: InputMaybe<OneToManyInput>
  source?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  uploadFinishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TemplateDocumentOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type TemplateDocumentUpdatePayload = OperationInfo | TemplateDocument

export type TitleCalculationsType = {
  __typename?: 'TitleCalculationsType'
  _cachedAt?: Maybe<Scalars['DateTime']['output']>
  titleOrdered?: Maybe<Scalars['Date']['output']>
  titleReceived?: Maybe<Scalars['Date']['output']>
}

export type TitleOrder = {
  __typename?: 'TitleOrder'
  accepted?: Maybe<Scalars['Boolean']['output']>
  application: Application
  cancellationDate?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  customerEmail?: Maybe<Scalars['String']['output']>
  customerPhone?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  estimatedSettlementDate: Scalars['Date']['output']
  fileId?: Maybe<Scalars['String']['output']>
  fileNumber?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  maritalStatus?: Maybe<Scalars['String']['output']>
  middleName?: Maybe<Scalars['String']['output']>
  modifiedAt: Scalars['DateTime']['output']
  newLoanAmount: Scalars['Decimal']['output']
  newLoanNumber: Scalars['String']['output']
  ordered?: Maybe<Scalars['DateTime']['output']>
  pk: Scalars['ID']['output']
  primaryContact: Scalars['String']['output']
  propertyCity: Scalars['String']['output']
  propertyCounty: Scalars['String']['output']
  propertyState: Scalars['String']['output']
  propertyStreetName: Scalars['String']['output']
  propertyUnitNumber?: Maybe<Scalars['String']['output']>
  propertyZip: Scalars['String']['output']
  provider: Scalars['String']['output']
  received?: Maybe<Scalars['DateTime']['output']>
  sameAddressAsPropertyAddress: Scalars['Boolean']['output']
  spouseEmail?: Maybe<Scalars['String']['output']>
  spouseFirstName?: Maybe<Scalars['String']['output']>
  spouseLastName?: Maybe<Scalars['String']['output']>
  spouseMiddleName?: Maybe<Scalars['String']['output']>
  spousePhone?: Maybe<Scalars['String']['output']>
  spouseSsn?: Maybe<Scalars['String']['output']>
  ssn: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type TitleOrderFilter = {
  AND?: InputMaybe<TitleOrderFilter>
  NOT?: InputMaybe<TitleOrderFilter>
  OR?: InputMaybe<TitleOrderFilter>
  pk: Scalars['ID']['input']
}

export type TitleOrderInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>
  application: OneToManyInput
  cancellationDate?: InputMaybe<Scalars['DateTime']['input']>
  customerEmail?: InputMaybe<Scalars['String']['input']>
  customerPhone?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedSettlementDate: Scalars['Date']['input']
  fileId?: InputMaybe<Scalars['String']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  newLoanAmount: Scalars['Decimal']['input']
  newLoanNumber: Scalars['String']['input']
  ordered?: InputMaybe<Scalars['DateTime']['input']>
  primaryContact: Scalars['String']['input']
  propertyCity: Scalars['String']['input']
  propertyCounty: Scalars['String']['input']
  propertyState: Scalars['String']['input']
  propertyStreetName: Scalars['String']['input']
  propertyUnitNumber?: InputMaybe<Scalars['String']['input']>
  propertyZip: Scalars['String']['input']
  provider: Scalars['String']['input']
  received?: InputMaybe<Scalars['DateTime']['input']>
  sameAddressAsPropertyAddress?: InputMaybe<Scalars['Boolean']['input']>
  spouseEmail?: InputMaybe<Scalars['String']['input']>
  spouseFirstName?: InputMaybe<Scalars['String']['input']>
  spouseLastName?: InputMaybe<Scalars['String']['input']>
  spouseMiddleName?: InputMaybe<Scalars['String']['input']>
  spousePhone?: InputMaybe<Scalars['String']['input']>
  spouseSsn?: InputMaybe<Scalars['String']['input']>
  ssn: Scalars['String']['input']
}

export type TitleOrderInputPartial = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>
  application?: InputMaybe<OneToManyInput>
  cancellationDate?: InputMaybe<Scalars['DateTime']['input']>
  customerEmail?: InputMaybe<Scalars['String']['input']>
  customerPhone?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedSettlementDate?: InputMaybe<Scalars['Date']['input']>
  fileId?: InputMaybe<Scalars['String']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  newLoanAmount?: InputMaybe<Scalars['Decimal']['input']>
  newLoanNumber?: InputMaybe<Scalars['String']['input']>
  ordered?: InputMaybe<Scalars['DateTime']['input']>
  pk: Scalars['ID']['input']
  primaryContact?: InputMaybe<Scalars['String']['input']>
  propertyCity?: InputMaybe<Scalars['String']['input']>
  propertyCounty?: InputMaybe<Scalars['String']['input']>
  propertyState?: InputMaybe<Scalars['String']['input']>
  propertyStreetName?: InputMaybe<Scalars['String']['input']>
  propertyUnitNumber?: InputMaybe<Scalars['String']['input']>
  propertyZip?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  received?: InputMaybe<Scalars['DateTime']['input']>
  sameAddressAsPropertyAddress?: InputMaybe<Scalars['Boolean']['input']>
  spouseEmail?: InputMaybe<Scalars['String']['input']>
  spouseFirstName?: InputMaybe<Scalars['String']['input']>
  spouseLastName?: InputMaybe<Scalars['String']['input']>
  spouseMiddleName?: InputMaybe<Scalars['String']['input']>
  spousePhone?: InputMaybe<Scalars['String']['input']>
  spouseSsn?: InputMaybe<Scalars['String']['input']>
  ssn?: InputMaybe<Scalars['String']['input']>
}

export type TitleOrderOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type TitleOrderUpdatePayload = OperationInfo | TitleOrder

export type TitleReport = {
  __typename?: 'TitleReport'
  annualTaxesDue?: Maybe<Scalars['Decimal']['output']>
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  effectiveDate?: Maybe<Scalars['Date']['output']>
  fileNumber: Scalars['String']['output']
  id: Scalars['ID']['output']
  legalDescription: Scalars['String']['output']
  legalDescriptionAbbreviated?: Maybe<Scalars['String']['output']>
  liens: Scalars['String']['output']
  modifiedAt: Scalars['DateTime']['output']
  nextTaxDue?: Maybe<Scalars['Date']['output']>
  nooNameOfSpouse: Scalars['String']['output']
  ordered?: Maybe<Scalars['Date']['output']>
  ownerNames: Scalars['JSON']['output']
  pk: Scalars['ID']['output']
  prReviewDate?: Maybe<Scalars['Date']['output']>
  prReviewStatus?: Maybe<Scalars['String']['output']>
  received?: Maybe<Scalars['Date']['output']>
  settlementAgent: Scalars['String']['output']
  taxes: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type TitleReportFilter = {
  AND?: InputMaybe<TitleReportFilter>
  NOT?: InputMaybe<TitleReportFilter>
  OR?: InputMaybe<TitleReportFilter>
  pk: Scalars['ID']['input']
}

export type TitleReportInput = {
  annualTaxesDue?: InputMaybe<Scalars['Decimal']['input']>
  application: OneToOneInput
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  legalDescription?: InputMaybe<Scalars['String']['input']>
  legalDescriptionAbbreviated?: InputMaybe<Scalars['String']['input']>
  liens?: InputMaybe<Scalars['String']['input']>
  nextTaxDue?: InputMaybe<Scalars['Date']['input']>
  nooNameOfSpouse?: InputMaybe<Scalars['String']['input']>
  ordered?: InputMaybe<Scalars['Date']['input']>
  ownerNames?: InputMaybe<Scalars['JSON']['input']>
  prReviewDate?: InputMaybe<Scalars['Date']['input']>
  prReviewStatus?: InputMaybe<Scalars['String']['input']>
  received?: InputMaybe<Scalars['Date']['input']>
  settlementAgent?: InputMaybe<Scalars['String']['input']>
  taxes?: InputMaybe<Scalars['String']['input']>
}

export type TitleReportInputPartial = {
  annualTaxesDue?: InputMaybe<Scalars['Decimal']['input']>
  application?: InputMaybe<OneToOneInput>
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  legalDescription?: InputMaybe<Scalars['String']['input']>
  legalDescriptionAbbreviated?: InputMaybe<Scalars['String']['input']>
  liens?: InputMaybe<Scalars['String']['input']>
  nextTaxDue?: InputMaybe<Scalars['Date']['input']>
  nooNameOfSpouse?: InputMaybe<Scalars['String']['input']>
  ordered?: InputMaybe<Scalars['Date']['input']>
  ownerNames?: InputMaybe<Scalars['JSON']['input']>
  pk: Scalars['ID']['input']
  prReviewDate?: InputMaybe<Scalars['Date']['input']>
  prReviewStatus?: InputMaybe<Scalars['String']['input']>
  received?: InputMaybe<Scalars['Date']['input']>
  settlementAgent?: InputMaybe<Scalars['String']['input']>
  taxes?: InputMaybe<Scalars['String']['input']>
}

export type TitleReportOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type TitleReportUpdatePayload = OperationInfo | TitleReport

export type Tradeline = {
  __typename?: 'Tradeline'
  accountClosedOn?: Maybe<Scalars['Date']['output']>
  accountIdentifier?: Maybe<Scalars['String']['output']>
  accountIdentifierSha512?: Maybe<Scalars['String']['output']>
  accountOpenedOn?: Maybe<Scalars['Date']['output']>
  accountOwnershipType?: Maybe<Scalars['String']['output']>
  accountPaidOn?: Maybe<Scalars['Date']['output']>
  accountStatusType?: Maybe<Scalars['String']['output']>
  accountType?: Maybe<Scalars['String']['output']>
  addedBy: UserData
  amortizationType?: Maybe<Scalars['String']['output']>
  application: Application
  applicationProfile: ApplicationProfile
  coBorrower: ApplicationProfile
  createdAt: Scalars['DateTime']['output']
  creditBusinessType?: Maybe<Scalars['String']['output']>
  creditComments: Scalars['JSON']['output']
  creditLoanType?: Maybe<Scalars['String']['output']>
  creditReport: CreditReport
  creditRepositrySourceType?: Maybe<Scalars['String']['output']>
  currentRatingCode?: Maybe<Scalars['String']['output']>
  currentRatingType?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  documentTradelines: Array<DocumentTradeline>
  escrowAmountOverridden?: Maybe<Scalars['Decimal']['output']>
  escrowStatus?: Maybe<Scalars['String']['output']>
  externalId: Scalars['String']['output']
  goodThroughOn?: Maybe<Scalars['String']['output']>
  highCreditAmount?: Maybe<Scalars['Decimal']['output']>
  highestAdverseRatingCode?: Maybe<Scalars['String']['output']>
  highestAdverseRatingOn?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  ignoreIndicator: Scalars['Boolean']['output']
  ignoredAt?: Maybe<Scalars['DateTime']['output']>
  ignoredBy: Profile
  interestRate?: Maybe<Scalars['Decimal']['output']>
  isExoticMortgage: Scalars['Boolean']['output']
  isPayoff: Scalars['Boolean']['output']
  isSubjectProperty?: Maybe<Scalars['Boolean']['output']>
  isSubordinated: Scalars['Boolean']['output']
  lastActivityOn?: Maybe<Scalars['Date']['output']>
  lienPosition?: Maybe<Scalars['Int']['output']>
  manualUpdateIndicator: Scalars['Boolean']['output']
  markedAsPayoffAt?: Maybe<Scalars['DateTime']['output']>
  modifiedAt: Scalars['DateTime']['output']
  monthlyPaymentAmount?: Maybe<Scalars['Decimal']['output']>
  monthsReviewed?: Maybe<Scalars['Int']['output']>
  mortgageDebt: Scalars['Boolean']['output']
  mortgageFor: Property
  mortgageProductType?: Maybe<Scalars['String']['output']>
  mostRecentAdverseRatingCode?: Maybe<Scalars['String']['output']>
  mostRecentAdverseRatingOn?: Maybe<Scalars['Date']['output']>
  mostRecentAdverseRatingType?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  originalInfo: Scalars['JSON']['output']
  pastDueAmount?: Maybe<Scalars['Int']['output']>
  paymentPatternData?: Maybe<Scalars['String']['output']>
  paymentPatternStartOn?: Maybe<Scalars['Date']['output']>
  payoffAmount: Scalars['Decimal']['output']
  payoffIncluded: Scalars['Boolean']['output']
  payoffType?: Maybe<Scalars['String']['output']>
  perDiem: Scalars['Boolean']['output']
  pk: Scalars['ID']['output']
  priorAdverseRatings: Scalars['JSON']['output']
  reportedOn?: Maybe<Scalars['Date']['output']>
  solarTermsInMonths?: Maybe<Scalars['Int']['output']>
  termDescription?: Maybe<Scalars['String']['output']>
  termOriginalMonths?: Maybe<Scalars['Int']['output']>
  termRemainingMonths?: Maybe<Scalars['Int']['output']>
  termSource?: Maybe<Scalars['String']['output']>
  tradelineStatus?: Maybe<Scalars['String']['output']>
  unpaidBalanceAmount?: Maybe<Scalars['Decimal']['output']>
  uuid: Scalars['UUID']['output']
  x30DaysLate?: Maybe<Scalars['Int']['output']>
  x60DaysLate?: Maybe<Scalars['Int']['output']>
  x90DaysLate?: Maybe<Scalars['Int']['output']>
}

export type TradelineDocumentTradelinesArgs = {
  filters?: InputMaybe<DocumentTradelineFilter>
  order?: InputMaybe<DocumentTradelineOrder>
}

export type TradelineFilter = {
  AND?: InputMaybe<TradelineFilter>
  NOT?: InputMaybe<TradelineFilter>
  OR?: InputMaybe<TradelineFilter>
  pk: Scalars['ID']['input']
}

export type TradelineInput = {
  accountClosedOn?: InputMaybe<Scalars['Date']['input']>
  accountIdentifier?: InputMaybe<Scalars['String']['input']>
  accountIdentifierSha512?: InputMaybe<Scalars['String']['input']>
  accountOpenedOn?: InputMaybe<Scalars['Date']['input']>
  accountOwnershipType?: InputMaybe<Scalars['String']['input']>
  accountPaidOn?: InputMaybe<Scalars['Date']['input']>
  accountStatusType?: InputMaybe<Scalars['String']['input']>
  accountType?: InputMaybe<Scalars['String']['input']>
  addedBy?: InputMaybe<OneToManyInput>
  amortizationType?: InputMaybe<Scalars['String']['input']>
  application?: InputMaybe<OneToManyInput>
  applicationProfile?: InputMaybe<OneToManyInput>
  coBorrower?: InputMaybe<OneToManyInput>
  creditBusinessType?: InputMaybe<Scalars['String']['input']>
  creditComments?: InputMaybe<Scalars['JSON']['input']>
  creditLoanType?: InputMaybe<Scalars['String']['input']>
  creditReport?: InputMaybe<OneToManyInput>
  creditRepositrySourceType?: InputMaybe<Scalars['String']['input']>
  currentRatingCode?: InputMaybe<Scalars['String']['input']>
  currentRatingType?: InputMaybe<Scalars['String']['input']>
  escrowAmountOverridden?: InputMaybe<Scalars['Decimal']['input']>
  escrowStatus?: InputMaybe<Scalars['String']['input']>
  goodThroughOn?: InputMaybe<Scalars['String']['input']>
  highCreditAmount?: InputMaybe<Scalars['Decimal']['input']>
  highestAdverseRatingCode?: InputMaybe<Scalars['String']['input']>
  highestAdverseRatingOn?: InputMaybe<Scalars['Date']['input']>
  ignoreIndicator?: InputMaybe<Scalars['Boolean']['input']>
  ignoredAt?: InputMaybe<Scalars['DateTime']['input']>
  ignoredBy?: InputMaybe<OneToManyInput>
  interestRate?: InputMaybe<Scalars['Decimal']['input']>
  isExoticMortgage?: InputMaybe<Scalars['Boolean']['input']>
  isPayoff?: InputMaybe<Scalars['Boolean']['input']>
  isSubjectProperty?: InputMaybe<Scalars['Boolean']['input']>
  isSubordinated?: InputMaybe<Scalars['Boolean']['input']>
  lastActivityOn?: InputMaybe<Scalars['Date']['input']>
  lienPosition?: InputMaybe<Scalars['Int']['input']>
  manualUpdateIndicator?: InputMaybe<Scalars['Boolean']['input']>
  markedAsPayoffAt?: InputMaybe<Scalars['DateTime']['input']>
  monthlyPaymentAmount?: InputMaybe<Scalars['Decimal']['input']>
  monthsReviewed?: InputMaybe<Scalars['Int']['input']>
  mortgageDebt?: InputMaybe<Scalars['Boolean']['input']>
  mortgageFor?: InputMaybe<OneToManyInput>
  mortgageProductType?: InputMaybe<Scalars['String']['input']>
  mostRecentAdverseRatingCode?: InputMaybe<Scalars['String']['input']>
  mostRecentAdverseRatingOn?: InputMaybe<Scalars['Date']['input']>
  mostRecentAdverseRatingType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  originalInfo?: InputMaybe<Scalars['JSON']['input']>
  pastDueAmount?: InputMaybe<Scalars['Int']['input']>
  paymentPatternData?: InputMaybe<Scalars['String']['input']>
  paymentPatternStartOn?: InputMaybe<Scalars['Date']['input']>
  payoffAmount?: InputMaybe<Scalars['Decimal']['input']>
  payoffIncluded?: InputMaybe<Scalars['Boolean']['input']>
  payoffType?: InputMaybe<Scalars['String']['input']>
  perDiem?: InputMaybe<Scalars['Boolean']['input']>
  priorAdverseRatings?: InputMaybe<Scalars['JSON']['input']>
  reportedOn?: InputMaybe<Scalars['Date']['input']>
  solarTermsInMonths?: InputMaybe<Scalars['Int']['input']>
  termDescription?: InputMaybe<Scalars['String']['input']>
  termOriginalMonths?: InputMaybe<Scalars['Int']['input']>
  termRemainingMonths?: InputMaybe<Scalars['Int']['input']>
  termSource?: InputMaybe<Scalars['String']['input']>
  tradelineStatus?: InputMaybe<Scalars['String']['input']>
  unpaidBalanceAmount?: InputMaybe<Scalars['Decimal']['input']>
  x30DaysLate?: InputMaybe<Scalars['Int']['input']>
  x60DaysLate?: InputMaybe<Scalars['Int']['input']>
  x90DaysLate?: InputMaybe<Scalars['Int']['input']>
}

export type TradelineInputPartial = {
  accountClosedOn?: InputMaybe<Scalars['Date']['input']>
  accountIdentifier?: InputMaybe<Scalars['String']['input']>
  accountIdentifierSha512?: InputMaybe<Scalars['String']['input']>
  accountOpenedOn?: InputMaybe<Scalars['Date']['input']>
  accountOwnershipType?: InputMaybe<Scalars['String']['input']>
  accountPaidOn?: InputMaybe<Scalars['Date']['input']>
  accountStatusType?: InputMaybe<Scalars['String']['input']>
  accountType?: InputMaybe<Scalars['String']['input']>
  addedBy?: InputMaybe<OneToManyInput>
  amortizationType?: InputMaybe<Scalars['String']['input']>
  application?: InputMaybe<OneToManyInput>
  applicationProfile?: InputMaybe<OneToManyInput>
  coBorrower?: InputMaybe<OneToManyInput>
  creditBusinessType?: InputMaybe<Scalars['String']['input']>
  creditComments?: InputMaybe<Scalars['JSON']['input']>
  creditLoanType?: InputMaybe<Scalars['String']['input']>
  creditReport?: InputMaybe<OneToManyInput>
  creditRepositrySourceType?: InputMaybe<Scalars['String']['input']>
  currentRatingCode?: InputMaybe<Scalars['String']['input']>
  currentRatingType?: InputMaybe<Scalars['String']['input']>
  escrowAmountOverridden?: InputMaybe<Scalars['Decimal']['input']>
  escrowStatus?: InputMaybe<Scalars['String']['input']>
  goodThroughOn?: InputMaybe<Scalars['String']['input']>
  highCreditAmount?: InputMaybe<Scalars['Decimal']['input']>
  highestAdverseRatingCode?: InputMaybe<Scalars['String']['input']>
  highestAdverseRatingOn?: InputMaybe<Scalars['Date']['input']>
  ignoreIndicator?: InputMaybe<Scalars['Boolean']['input']>
  ignoredAt?: InputMaybe<Scalars['DateTime']['input']>
  ignoredBy?: InputMaybe<OneToManyInput>
  interestRate?: InputMaybe<Scalars['Decimal']['input']>
  isExoticMortgage?: InputMaybe<Scalars['Boolean']['input']>
  isPayoff?: InputMaybe<Scalars['Boolean']['input']>
  isSubjectProperty?: InputMaybe<Scalars['Boolean']['input']>
  isSubordinated?: InputMaybe<Scalars['Boolean']['input']>
  lastActivityOn?: InputMaybe<Scalars['Date']['input']>
  lienPosition?: InputMaybe<Scalars['Int']['input']>
  manualUpdateIndicator?: InputMaybe<Scalars['Boolean']['input']>
  markedAsPayoffAt?: InputMaybe<Scalars['DateTime']['input']>
  monthlyPaymentAmount?: InputMaybe<Scalars['Decimal']['input']>
  monthsReviewed?: InputMaybe<Scalars['Int']['input']>
  mortgageDebt?: InputMaybe<Scalars['Boolean']['input']>
  mortgageFor?: InputMaybe<OneToManyInput>
  mortgageProductType?: InputMaybe<Scalars['String']['input']>
  mostRecentAdverseRatingCode?: InputMaybe<Scalars['String']['input']>
  mostRecentAdverseRatingOn?: InputMaybe<Scalars['Date']['input']>
  mostRecentAdverseRatingType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  originalInfo?: InputMaybe<Scalars['JSON']['input']>
  pastDueAmount?: InputMaybe<Scalars['Int']['input']>
  paymentPatternData?: InputMaybe<Scalars['String']['input']>
  paymentPatternStartOn?: InputMaybe<Scalars['Date']['input']>
  payoffAmount?: InputMaybe<Scalars['Decimal']['input']>
  payoffIncluded?: InputMaybe<Scalars['Boolean']['input']>
  payoffType?: InputMaybe<Scalars['String']['input']>
  perDiem?: InputMaybe<Scalars['Boolean']['input']>
  pk: Scalars['ID']['input']
  priorAdverseRatings?: InputMaybe<Scalars['JSON']['input']>
  reportedOn?: InputMaybe<Scalars['Date']['input']>
  solarTermsInMonths?: InputMaybe<Scalars['Int']['input']>
  termDescription?: InputMaybe<Scalars['String']['input']>
  termOriginalMonths?: InputMaybe<Scalars['Int']['input']>
  termRemainingMonths?: InputMaybe<Scalars['Int']['input']>
  termSource?: InputMaybe<Scalars['String']['input']>
  tradelineStatus?: InputMaybe<Scalars['String']['input']>
  unpaidBalanceAmount?: InputMaybe<Scalars['Decimal']['input']>
  x30DaysLate?: InputMaybe<Scalars['Int']['input']>
  x60DaysLate?: InputMaybe<Scalars['Int']['input']>
  x90DaysLate?: InputMaybe<Scalars['Int']['input']>
}

export type TradelineOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type TradelineUpdatePayload = OperationInfo | Tradeline

export type TradelinesCalculationsType = {
  __typename?: 'TradelinesCalculationsType'
  _cachedAt?: Maybe<Scalars['DateTime']['output']>
  existingMortgageDebt?: Maybe<Scalars['Float']['output']>
  lienPosition?: Maybe<Scalars['String']['output']>
  maxPayoff?: Maybe<Scalars['Float']['output']>
  monthlyDebt?: Maybe<Scalars['Float']['output']>
  monthlyDebtPrePayoffs?: Maybe<Scalars['Float']['output']>
  monthlyDebtReduction?: Maybe<Scalars['Float']['output']>
  monthlyDebtReductionPrePayoffs?: Maybe<Scalars['Float']['output']>
  monthlyIncome?: Maybe<Scalars['Float']['output']>
  monthlyPaymentAmountTotal?: Maybe<Scalars['Float']['output']>
  payingOffMortgageDebt?: Maybe<Scalars['Float']['output']>
  payoffMortgageDebt?: Maybe<Scalars['Float']['output']>
  payoffsTotal?: Maybe<Scalars['Float']['output']>
  payoffsTotalAccountBalance?: Maybe<Scalars['Float']['output']>
  postOriginationMortgageDebt?: Maybe<Scalars['Float']['output']>
  totalMonthlyIncome?: Maybe<Scalars['Float']['output']>
  tradelinesBalance?: Maybe<Scalars['Float']['output']>
  tradelinesMinMonthlyPaymentTotal?: Maybe<Scalars['Float']['output']>
  tradelinesTotalAccountBalance?: Maybe<Scalars['Float']['output']>
}

export type UseOfProceeds = {
  __typename?: 'UseOfProceeds'
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  pk: Scalars['ID']['output']
  uuid: Scalars['UUID']['output']
}

export type UseOfProceedsFilter = {
  AND?: InputMaybe<UseOfProceedsFilter>
  NOT?: InputMaybe<UseOfProceedsFilter>
  OR?: InputMaybe<UseOfProceedsFilter>
  pk: Scalars['ID']['input']
}

export type UseOfProceedsInput = {
  application: OneToManyInput
  name: Scalars['String']['input']
}

export type UseOfProceedsInputPartial = {
  application?: InputMaybe<OneToManyInput>
  name?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
}

export type UseOfProceedsOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type UseOfProceedsUpdatePayload = OperationInfo | UseOfProceeds

export type UserData = {
  __typename?: 'UserData'
  createdAt: Scalars['DateTime']['output']
  defaultWorkQueuesPreset: WorkQueuesPreset
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  escalationSet: Array<Escalation>
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  isBot: Scalars['Boolean']['output']
  isUserControllerFeatureFlagOn: Scalars['Boolean']['output']
  jiraAccountId?: Maybe<Scalars['String']['output']>
  lastDealAssignedAt?: Maybe<Scalars['DateTime']['output']>
  logoutAt?: Maybe<Scalars['DateTime']['output']>
  manager?: Maybe<DjangoModelType>
  meetingLink?: Maybe<Scalars['String']['output']>
  modifiedAt: Scalars['DateTime']['output']
  newLeadsChannelId?: Maybe<Scalars['String']['output']>
  nmlsDisplayName?: Maybe<Scalars['String']['output']>
  nmlsId?: Maybe<Scalars['String']['output']>
  outOfOffice: Scalars['Boolean']['output']
  outreachId?: Maybe<Scalars['String']['output']>
  outreachLegacyUnlockId?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  releasesSeenOn?: Maybe<Scalars['DateTime']['output']>
  requestedEscalations: Array<Escalation>
  respondedEscalations: Array<Escalation>
  role: Scalars['String']['output']
  seenBy: Array<StreamingNote>
  slackUserId?: Maybe<Scalars['String']['output']>
  snapshots: Array<Snapshot>
  staffAddress?: Maybe<Scalars['String']['output']>
  staffNotificationsEmail: Scalars['Boolean']['output']
  staffNotificationsSlack: Scalars['Boolean']['output']
  staffNotificationsSystemNotifications: Scalars['Boolean']['output']
  staffNotificationsUserMention: Scalars['Boolean']['output']
  streamingNotes: Array<StreamingNote>
  streamingnoteSet: Array<StreamingNote>
  timezone?: Maybe<Scalars['String']['output']>
  tradelineSet: Array<Tradeline>
  uiPreferences: Scalars['JSON']['output']
  user: DjangoModelType
  uuid: Scalars['UUID']['output']
}

export type UserDataEscalationSetArgs = {
  filters?: InputMaybe<EscalationFilter>
  order?: InputMaybe<EscalationOrder>
}

export type UserDataRequestedEscalationsArgs = {
  filters?: InputMaybe<EscalationFilter>
  order?: InputMaybe<EscalationOrder>
}

export type UserDataRespondedEscalationsArgs = {
  filters?: InputMaybe<EscalationFilter>
  order?: InputMaybe<EscalationOrder>
}

export type UserDataSeenByArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type UserDataSnapshotsArgs = {
  filters?: InputMaybe<SnapshotFilter>
  order?: InputMaybe<SnapshotOrder>
}

export type UserDataStreamingNotesArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type UserDataStreamingnoteSetArgs = {
  filters?: InputMaybe<StreamingNoteFilter>
  order?: InputMaybe<StreamingNoteOrder>
}

export type UserDataTradelineSetArgs = {
  filters?: InputMaybe<TradelineFilter>
  order?: InputMaybe<TradelineOrder>
}

export type UserDataFilter = {
  AND?: InputMaybe<UserDataFilter>
  NOT?: InputMaybe<UserDataFilter>
  OR?: InputMaybe<UserDataFilter>
  pk: Scalars['ID']['input']
}

export type UserDataInput = {
  defaultWorkQueuesPreset?: InputMaybe<OneToManyInput>
  isBot?: InputMaybe<Scalars['Boolean']['input']>
  isUserControllerFeatureFlagOn?: InputMaybe<Scalars['Boolean']['input']>
  jiraAccountId?: InputMaybe<Scalars['String']['input']>
  lastDealAssignedAt?: InputMaybe<Scalars['DateTime']['input']>
  logoutAt?: InputMaybe<Scalars['DateTime']['input']>
  manager?: InputMaybe<OneToManyInput>
  meetingLink?: InputMaybe<Scalars['String']['input']>
  newLeadsChannelId?: InputMaybe<Scalars['String']['input']>
  nmlsDisplayName?: InputMaybe<Scalars['String']['input']>
  nmlsId?: InputMaybe<Scalars['String']['input']>
  outOfOffice?: InputMaybe<Scalars['Boolean']['input']>
  outreachId?: InputMaybe<Scalars['String']['input']>
  outreachLegacyUnlockId?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  releasesSeenOn?: InputMaybe<Scalars['DateTime']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  slackUserId?: InputMaybe<Scalars['String']['input']>
  staffAddress?: InputMaybe<Scalars['String']['input']>
  staffNotificationsEmail?: InputMaybe<Scalars['Boolean']['input']>
  staffNotificationsSlack?: InputMaybe<Scalars['Boolean']['input']>
  staffNotificationsSystemNotifications?: InputMaybe<Scalars['Boolean']['input']>
  staffNotificationsUserMention?: InputMaybe<Scalars['Boolean']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  uiPreferences?: InputMaybe<Scalars['JSON']['input']>
  user: OneToOneInput
}

export type UserDataInputPartial = {
  defaultWorkQueuesPreset?: InputMaybe<OneToManyInput>
  isBot?: InputMaybe<Scalars['Boolean']['input']>
  isUserControllerFeatureFlagOn?: InputMaybe<Scalars['Boolean']['input']>
  jiraAccountId?: InputMaybe<Scalars['String']['input']>
  lastDealAssignedAt?: InputMaybe<Scalars['DateTime']['input']>
  logoutAt?: InputMaybe<Scalars['DateTime']['input']>
  manager?: InputMaybe<OneToManyInput>
  meetingLink?: InputMaybe<Scalars['String']['input']>
  newLeadsChannelId?: InputMaybe<Scalars['String']['input']>
  nmlsDisplayName?: InputMaybe<Scalars['String']['input']>
  nmlsId?: InputMaybe<Scalars['String']['input']>
  outOfOffice?: InputMaybe<Scalars['Boolean']['input']>
  outreachId?: InputMaybe<Scalars['String']['input']>
  outreachLegacyUnlockId?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  releasesSeenOn?: InputMaybe<Scalars['DateTime']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  slackUserId?: InputMaybe<Scalars['String']['input']>
  staffAddress?: InputMaybe<Scalars['String']['input']>
  staffNotificationsEmail?: InputMaybe<Scalars['Boolean']['input']>
  staffNotificationsSlack?: InputMaybe<Scalars['Boolean']['input']>
  staffNotificationsSystemNotifications?: InputMaybe<Scalars['Boolean']['input']>
  staffNotificationsUserMention?: InputMaybe<Scalars['Boolean']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  uiPreferences?: InputMaybe<Scalars['JSON']['input']>
  user?: InputMaybe<OneToOneInput>
}

export type UserDataOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type UserDataUpdatePayload = OperationInfo | UserData

export type UserIncome = {
  __typename?: 'UserIncome'
  applicationProfile: ApplicationProfile
  bcoCurrentYear?: Maybe<Scalars['Decimal']['output']>
  bcoLastYear?: Maybe<Scalars['Decimal']['output']>
  bcoYearBefore?: Maybe<Scalars['Decimal']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  period: Scalars['String']['output']
  pk: Scalars['ID']['output']
  rapMonthly?: Maybe<Scalars['Decimal']['output']>
  selfBoLastYear?: Maybe<Scalars['Decimal']['output']>
  selfBoYearBefore?: Maybe<Scalars['Decimal']['output']>
  selfSpLastYear?: Maybe<Scalars['Decimal']['output']>
  selfSpYearBefore?: Maybe<Scalars['Decimal']['output']>
  source: Scalars['String']['output']
  ssVabNtiMonthly?: Maybe<Scalars['Decimal']['output']>
  uuid: Scalars['UUID']['output']
  w2Annual?: Maybe<Scalars['Decimal']['output']>
  w2BiweeklyCheck1: Scalars['Decimal']['output']
  w2BiweeklyCheck2: Scalars['Decimal']['output']
  w2HourlyHours?: Maybe<Scalars['Decimal']['output']>
  w2HourlyRate?: Maybe<Scalars['Decimal']['output']>
  w2Monthly?: Maybe<Scalars['Decimal']['output']>
  w2SemimonthlyCheck1?: Maybe<Scalars['Decimal']['output']>
  w2SemimonthlyCheck2?: Maybe<Scalars['Decimal']['output']>
  w2Weekly?: Maybe<Scalars['Decimal']['output']>
}

export type UserIncomeFilter = {
  AND?: InputMaybe<UserIncomeFilter>
  NOT?: InputMaybe<UserIncomeFilter>
  OR?: InputMaybe<UserIncomeFilter>
  pk: Scalars['ID']['input']
}

export type UserIncomeInput = {
  applicationProfile: OneToManyInput
  bcoCurrentYear?: InputMaybe<Scalars['Decimal']['input']>
  bcoLastYear?: InputMaybe<Scalars['Decimal']['input']>
  bcoYearBefore?: InputMaybe<Scalars['Decimal']['input']>
  period: Scalars['String']['input']
  rapMonthly?: InputMaybe<Scalars['Decimal']['input']>
  selfBoLastYear?: InputMaybe<Scalars['Decimal']['input']>
  selfBoYearBefore?: InputMaybe<Scalars['Decimal']['input']>
  selfSpLastYear?: InputMaybe<Scalars['Decimal']['input']>
  selfSpYearBefore?: InputMaybe<Scalars['Decimal']['input']>
  source: Scalars['String']['input']
  ssVabNtiMonthly?: InputMaybe<Scalars['Decimal']['input']>
  w2Annual?: InputMaybe<Scalars['Decimal']['input']>
  w2BiweeklyCheck1?: InputMaybe<Scalars['Decimal']['input']>
  w2BiweeklyCheck2?: InputMaybe<Scalars['Decimal']['input']>
  w2HourlyHours?: InputMaybe<Scalars['Decimal']['input']>
  w2HourlyRate?: InputMaybe<Scalars['Decimal']['input']>
  w2Monthly?: InputMaybe<Scalars['Decimal']['input']>
  w2SemimonthlyCheck1?: InputMaybe<Scalars['Decimal']['input']>
  w2SemimonthlyCheck2?: InputMaybe<Scalars['Decimal']['input']>
  w2Weekly?: InputMaybe<Scalars['Decimal']['input']>
}

export type UserIncomeInputPartial = {
  applicationProfile?: InputMaybe<OneToManyInput>
  bcoCurrentYear?: InputMaybe<Scalars['Decimal']['input']>
  bcoLastYear?: InputMaybe<Scalars['Decimal']['input']>
  bcoYearBefore?: InputMaybe<Scalars['Decimal']['input']>
  period?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  rapMonthly?: InputMaybe<Scalars['Decimal']['input']>
  selfBoLastYear?: InputMaybe<Scalars['Decimal']['input']>
  selfBoYearBefore?: InputMaybe<Scalars['Decimal']['input']>
  selfSpLastYear?: InputMaybe<Scalars['Decimal']['input']>
  selfSpYearBefore?: InputMaybe<Scalars['Decimal']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  ssVabNtiMonthly?: InputMaybe<Scalars['Decimal']['input']>
  w2Annual?: InputMaybe<Scalars['Decimal']['input']>
  w2BiweeklyCheck1?: InputMaybe<Scalars['Decimal']['input']>
  w2BiweeklyCheck2?: InputMaybe<Scalars['Decimal']['input']>
  w2HourlyHours?: InputMaybe<Scalars['Decimal']['input']>
  w2HourlyRate?: InputMaybe<Scalars['Decimal']['input']>
  w2Monthly?: InputMaybe<Scalars['Decimal']['input']>
  w2SemimonthlyCheck1?: InputMaybe<Scalars['Decimal']['input']>
  w2SemimonthlyCheck2?: InputMaybe<Scalars['Decimal']['input']>
  w2Weekly?: InputMaybe<Scalars['Decimal']['input']>
}

export type UserIncomeOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type UserIncomeUpdatePayload = OperationInfo | UserIncome

export type Valuation = {
  __typename?: 'Valuation'
  additionalFeatures?: Maybe<Scalars['String']['output']>
  adverseSiteConditions?: Maybe<Scalars['String']['output']>
  application: Application
  appraisalCost?: Maybe<Scalars['Decimal']['output']>
  appraisalReviewStatus?: Maybe<Scalars['String']['output']>
  appraisalReviewStatusDate?: Maybe<Scalars['DateTime']['output']>
  avmVariance?: Maybe<Scalars['Decimal']['output']>
  comparableFartherThanMile?: Maybe<Scalars['Boolean']['output']>
  comparableSalesRecency?: Maybe<Scalars['Int']['output']>
  conditionOfAppraisalType?: Maybe<Scalars['String']['output']>
  confidence?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<DjangoModelType>
  currentOccupancyType?: Maybe<Scalars['String']['output']>
  deferredMaintenanceItems?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  document?: Maybe<DjangoModelType>
  effectiveDate?: Maybe<Scalars['Date']['output']>
  floodZoneHazardIndicator?: Maybe<Scalars['Boolean']['output']>
  grossAdjustment?: Maybe<Scalars['Decimal']['output']>
  grossLivingArea?: Maybe<Scalars['Decimal']['output']>
  id: Scalars['ID']['output']
  inspectionScheduled?: Maybe<Scalars['Date']['output']>
  isEscalateToUam?: Maybe<Scalars['Boolean']['output']>
  isHoa?: Maybe<Scalars['Boolean']['output']>
  isPrimary?: Maybe<Scalars['Boolean']['output']>
  isPrimaryAvm?: Maybe<Scalars['Boolean']['output']>
  isPud?: Maybe<Scalars['Boolean']['output']>
  isSecondary?: Maybe<Scalars['Boolean']['output']>
  listedWithinPreviousYear?: Maybe<Scalars['String']['output']>
  maxValue?: Maybe<Scalars['Decimal']['output']>
  minValue?: Maybe<Scalars['Decimal']['output']>
  modifiedAt: Scalars['DateTime']['output']
  netAdjustment?: Maybe<Scalars['Decimal']['output']>
  netGrossAdjustment?: Maybe<Scalars['Int']['output']>
  orderNumber?: Maybe<Scalars['String']['output']>
  ordered?: Maybe<Scalars['Date']['output']>
  physicalDeficiency?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  propertyBaths?: Maybe<Scalars['Decimal']['output']>
  propertyBeds?: Maybe<Scalars['Int']['output']>
  propertyCondition?: Maybe<Scalars['String']['output']>
  propertyInspectionResultCommentDescription?: Maybe<Scalars['String']['output']>
  propertyNeighborhoodBuiltUpRangeType?: Maybe<Scalars['String']['output']>
  propertyNeighborhoodGrowthPaceType?: Maybe<Scalars['String']['output']>
  propertyNeighborhoodLocationType?: Maybe<Scalars['String']['output']>
  propertySquareFeet?: Maybe<Scalars['Decimal']['output']>
  provider?: Maybe<Scalars['String']['output']>
  providerId?: Maybe<Scalars['String']['output']>
  received?: Maybe<Scalars['Date']['output']>
  siteZoningClassificationDescription?: Maybe<Scalars['String']['output']>
  siteZoningClassificationIdentifier?: Maybe<Scalars['String']['output']>
  siteZoningComplianceDescription?: Maybe<Scalars['String']['output']>
  siteZoningComplianceType?: Maybe<Scalars['String']['output']>
  startingHomeValue?: Maybe<Scalars['Int']['output']>
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
  valExpress?: Maybe<Scalars['Boolean']['output']>
  valExpressOverride?: Maybe<Scalars['Boolean']['output']>
  valuationOn?: Maybe<Scalars['Date']['output']>
  valuationReportExpected?: Maybe<Scalars['Date']['output']>
  value?: Maybe<Scalars['Decimal']['output']>
}

export type ValuationFilter = {
  AND?: InputMaybe<ValuationFilter>
  NOT?: InputMaybe<ValuationFilter>
  OR?: InputMaybe<ValuationFilter>
  pk: Scalars['ID']['input']
}

export type ValuationInput = {
  additionalFeatures?: InputMaybe<Scalars['String']['input']>
  adverseSiteConditions?: InputMaybe<Scalars['String']['input']>
  application: OneToManyInput
  appraisalCost?: InputMaybe<Scalars['Decimal']['input']>
  appraisalReviewStatus?: InputMaybe<Scalars['String']['input']>
  appraisalReviewStatusDate?: InputMaybe<Scalars['DateTime']['input']>
  comparableFartherThanMile?: InputMaybe<Scalars['Boolean']['input']>
  comparableSalesRecency?: InputMaybe<Scalars['Int']['input']>
  conditionOfAppraisalType?: InputMaybe<Scalars['String']['input']>
  confidence?: InputMaybe<Scalars['Int']['input']>
  createdBy?: InputMaybe<OneToManyInput>
  currentOccupancyType?: InputMaybe<Scalars['String']['input']>
  deferredMaintenanceItems?: InputMaybe<Scalars['String']['input']>
  document?: InputMaybe<OneToOneInput>
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  floodZoneHazardIndicator?: InputMaybe<Scalars['Boolean']['input']>
  grossAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  grossLivingArea?: InputMaybe<Scalars['Decimal']['input']>
  inspectionScheduled?: InputMaybe<Scalars['Date']['input']>
  isEscalateToUam?: InputMaybe<Scalars['Boolean']['input']>
  isHoa?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  isPrimaryAvm?: InputMaybe<Scalars['Boolean']['input']>
  isPud?: InputMaybe<Scalars['Boolean']['input']>
  isSecondary?: InputMaybe<Scalars['Boolean']['input']>
  listedWithinPreviousYear?: InputMaybe<Scalars['String']['input']>
  maxValue?: InputMaybe<Scalars['Decimal']['input']>
  minValue?: InputMaybe<Scalars['Decimal']['input']>
  netAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  netGrossAdjustment?: InputMaybe<Scalars['Int']['input']>
  orderNumber?: InputMaybe<Scalars['String']['input']>
  ordered?: InputMaybe<Scalars['Date']['input']>
  physicalDeficiency?: InputMaybe<Scalars['String']['input']>
  propertyBaths?: InputMaybe<Scalars['Decimal']['input']>
  propertyBeds?: InputMaybe<Scalars['Int']['input']>
  propertyCondition?: InputMaybe<Scalars['String']['input']>
  propertyInspectionResultCommentDescription?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodBuiltUpRangeType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodGrowthPaceType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodLocationType?: InputMaybe<Scalars['String']['input']>
  propertySquareFeet?: InputMaybe<Scalars['Decimal']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  providerId?: InputMaybe<Scalars['String']['input']>
  received?: InputMaybe<Scalars['Date']['input']>
  siteZoningClassificationDescription?: InputMaybe<Scalars['String']['input']>
  siteZoningClassificationIdentifier?: InputMaybe<Scalars['String']['input']>
  siteZoningComplianceDescription?: InputMaybe<Scalars['String']['input']>
  siteZoningComplianceType?: InputMaybe<Scalars['String']['input']>
  startingHomeValue?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  valExpress?: InputMaybe<Scalars['Boolean']['input']>
  valExpressOverride?: InputMaybe<Scalars['Boolean']['input']>
  valuationOn?: InputMaybe<Scalars['Date']['input']>
  valuationReportExpected?: InputMaybe<Scalars['Date']['input']>
  value?: InputMaybe<Scalars['Decimal']['input']>
}

export type ValuationInputPartial = {
  additionalFeatures?: InputMaybe<Scalars['String']['input']>
  adverseSiteConditions?: InputMaybe<Scalars['String']['input']>
  application?: InputMaybe<OneToManyInput>
  appraisalCost?: InputMaybe<Scalars['Decimal']['input']>
  appraisalReviewStatus?: InputMaybe<Scalars['String']['input']>
  appraisalReviewStatusDate?: InputMaybe<Scalars['DateTime']['input']>
  comparableFartherThanMile?: InputMaybe<Scalars['Boolean']['input']>
  comparableSalesRecency?: InputMaybe<Scalars['Int']['input']>
  conditionOfAppraisalType?: InputMaybe<Scalars['String']['input']>
  confidence?: InputMaybe<Scalars['Int']['input']>
  createdBy?: InputMaybe<OneToManyInput>
  currentOccupancyType?: InputMaybe<Scalars['String']['input']>
  deferredMaintenanceItems?: InputMaybe<Scalars['String']['input']>
  document?: InputMaybe<OneToOneInput>
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  floodZoneHazardIndicator?: InputMaybe<Scalars['Boolean']['input']>
  grossAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  grossLivingArea?: InputMaybe<Scalars['Decimal']['input']>
  inspectionScheduled?: InputMaybe<Scalars['Date']['input']>
  isEscalateToUam?: InputMaybe<Scalars['Boolean']['input']>
  isHoa?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  isPrimaryAvm?: InputMaybe<Scalars['Boolean']['input']>
  isPud?: InputMaybe<Scalars['Boolean']['input']>
  isSecondary?: InputMaybe<Scalars['Boolean']['input']>
  listedWithinPreviousYear?: InputMaybe<Scalars['String']['input']>
  maxValue?: InputMaybe<Scalars['Decimal']['input']>
  minValue?: InputMaybe<Scalars['Decimal']['input']>
  netAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  netGrossAdjustment?: InputMaybe<Scalars['Int']['input']>
  orderNumber?: InputMaybe<Scalars['String']['input']>
  ordered?: InputMaybe<Scalars['Date']['input']>
  physicalDeficiency?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  propertyBaths?: InputMaybe<Scalars['Decimal']['input']>
  propertyBeds?: InputMaybe<Scalars['Int']['input']>
  propertyCondition?: InputMaybe<Scalars['String']['input']>
  propertyInspectionResultCommentDescription?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodBuiltUpRangeType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodGrowthPaceType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodLocationType?: InputMaybe<Scalars['String']['input']>
  propertySquareFeet?: InputMaybe<Scalars['Decimal']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  providerId?: InputMaybe<Scalars['String']['input']>
  received?: InputMaybe<Scalars['Date']['input']>
  siteZoningClassificationDescription?: InputMaybe<Scalars['String']['input']>
  siteZoningClassificationIdentifier?: InputMaybe<Scalars['String']['input']>
  siteZoningComplianceDescription?: InputMaybe<Scalars['String']['input']>
  siteZoningComplianceType?: InputMaybe<Scalars['String']['input']>
  startingHomeValue?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  valExpress?: InputMaybe<Scalars['Boolean']['input']>
  valExpressOverride?: InputMaybe<Scalars['Boolean']['input']>
  valuationOn?: InputMaybe<Scalars['Date']['input']>
  valuationReportExpected?: InputMaybe<Scalars['Date']['input']>
  value?: InputMaybe<Scalars['Decimal']['input']>
}

export type ValuationOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ValuationUpdatePayload = OperationInfo | Valuation

export type ValuationsCalculationsType = {
  __typename?: 'ValuationsCalculationsType'
  _cachedAt?: Maybe<Scalars['DateTime']['output']>
  appraisalOrdered?: Maybe<Scalars['Date']['output']>
  appraisalReceived?: Maybe<Scalars['Date']['output']>
  appraisalReport?: Maybe<Valuation>
  appraisalReviewStatus?: Maybe<Scalars['String']['output']>
  avmVariance?: Maybe<Scalars['Float']['output']>
  cov?: Maybe<Scalars['Float']['output']>
  estimatedHomeValue?: Maybe<Scalars['Float']['output']>
  estimatedValue?: Maybe<Scalars['Float']['output']>
  estimatedValueWithOverrides?: Maybe<Scalars['Float']['output']>
  primaryAvm?: Maybe<Valuation>
  propertyEstimatedValue?: Maybe<Scalars['Float']['output']>
  secondaryValuation?: Maybe<Valuation>
}

export type WorkQueues = {
  __typename?: 'WorkQueues'
  adjustedExchangeRate?: Maybe<Scalars['String']['output']>
  agreementEffectiveOn?: Maybe<Scalars['Date']['output']>
  annualizedCostLimit?: Maybe<Scalars['String']['output']>
  annualizedCostLimitCalcVersion?: Maybe<Scalars['Int']['output']>
  applicants?: Maybe<Scalars['String']['output']>
  application: Application
  applicationCreatedAt?: Maybe<Scalars['DateTime']['output']>
  applicationPartyName?: Maybe<Scalars['String']['output']>
  applicationState?: Maybe<Scalars['String']['output']>
  applicationStateIndex?: Maybe<Scalars['Int']['output']>
  applicationStateLabel?: Maybe<Scalars['String']['output']>
  applicationStateModifiedAt?: Maybe<Scalars['String']['output']>
  appraisalEffectiveDate?: Maybe<Scalars['Date']['output']>
  appraisalExpirationDate?: Maybe<Scalars['Date']['output']>
  appraisalOrdered?: Maybe<Scalars['Date']['output']>
  appraisalReceived?: Maybe<Scalars['Date']['output']>
  appraisalReviewStatus?: Maybe<Scalars['String']['output']>
  appraisalReviewStatusDate?: Maybe<Scalars['DateTime']['output']>
  appraisalType?: Maybe<Scalars['String']['output']>
  appraisedHomeValue?: Maybe<Scalars['Decimal']['output']>
  approvedEscalations: Scalars['String']['output']
  assessorParcelNumber?: Maybe<Scalars['String']['output']>
  automatedExceptions?: Maybe<Scalars['JSON']['output']>
  automatedFlags?: Maybe<Scalars['JSON']['output']>
  automatedReviewStatus?: Maybe<Scalars['String']['output']>
  avmVariance?: Maybe<Scalars['Decimal']['output']>
  bornOn?: Maybe<Scalars['String']['output']>
  calcApplicationFico?: Maybe<Scalars['Int']['output']>
  callCompleted?: Maybe<Scalars['Date']['output']>
  callScheduled?: Maybe<Scalars['DateTime']['output']>
  city?: Maybe<Scalars['String']['output']>
  cltv?: Maybe<Scalars['Decimal']['output']>
  comparableFartherThanMile?: Maybe<Scalars['Boolean']['output']>
  comparableSalesRecency?: Maybe<Scalars['Int']['output']>
  completedCustomerTasks?: Maybe<Scalars['Int']['output']>
  county?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  dealTeams?: Maybe<Scalars['JSON']['output']>
  dealTeamsUserIds?: Maybe<Scalars['String']['output']>
  delayReasons?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  estimatedCloseOn?: Maybe<Scalars['Date']['output']>
  estimatedValueWithOverrides?: Maybe<Scalars['Decimal']['output']>
  exchangeRate?: Maybe<Scalars['String']['output']>
  exchangeRateAdjustment?: Maybe<Scalars['Decimal']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  ficoOverride?: Maybe<Scalars['Int']['output']>
  fileNumber?: Maybe<Scalars['String']['output']>
  finalNetClosingProceeds?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  floodZoneHazardIndicator?: Maybe<Scalars['Boolean']['output']>
  followUp?: Maybe<Scalars['Date']['output']>
  grossAdjustment?: Maybe<Scalars['Decimal']['output']>
  grossLivingArea?: Maybe<Scalars['String']['output']>
  homeFinanceLimit?: Maybe<Scalars['String']['output']>
  homeValueOverride?: Maybe<Scalars['Decimal']['output']>
  hubspotContactId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  incompleteCustomerTasks?: Maybe<Scalars['Int']['output']>
  inspectionScheduled?: Maybe<Scalars['Date']['output']>
  investmentPayment?: Maybe<Scalars['Decimal']['output']>
  investmentPercentage?: Maybe<Scalars['String']['output']>
  isMtgInquires?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  lossReason?: Maybe<Scalars['String']['output']>
  lossType?: Maybe<Scalars['String']['output']>
  lotSize?: Maybe<Scalars['String']['output']>
  mailingAddress?: Maybe<Scalars['String']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  maxInvestmentAmount?: Maybe<Scalars['Decimal']['output']>
  minInvestmentOverride?: Maybe<Scalars['Decimal']['output']>
  modifiedAt?: Maybe<Scalars['String']['output']>
  monthlyCostHoa?: Maybe<Scalars['Decimal']['output']>
  name?: Maybe<Scalars['String']['output']>
  netAdjustment?: Maybe<Scalars['Decimal']['output']>
  opsDelayReasons?: Maybe<Scalars['String']['output']>
  outreachOpportunityId?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  pk: Scalars['ID']['output']
  pricingVersion?: Maybe<Scalars['Float']['output']>
  property?: Maybe<Scalars['JSON']['output']>
  propertyCondition?: Maybe<Scalars['String']['output']>
  propertyNeighborhoodBuiltUpRangeType?: Maybe<Scalars['String']['output']>
  propertyNeighborhoodGrowthPaceType?: Maybe<Scalars['String']['output']>
  propertyNeighborhoodLocationType?: Maybe<Scalars['String']['output']>
  propertyType?: Maybe<Scalars['String']['output']>
  propertyUsage?: Maybe<Scalars['String']['output']>
  receivedDocumentsCount?: Maybe<Scalars['Int']['output']>
  reportExpiresAt?: Maybe<Scalars['DateTime']['output']>
  reportOrderedAt?: Maybe<Scalars['Date']['output']>
  requestedDocumentsCount?: Maybe<Scalars['Int']['output']>
  requestedInvestment?: Maybe<Scalars['Decimal']['output']>
  roofSolarPanel?: Maybe<Scalars['Boolean']['output']>
  settlementAgent?: Maybe<Scalars['String']['output']>
  siteZoningClassificationIdentifier?: Maybe<Scalars['String']['output']>
  siteZoningComplianceType?: Maybe<Scalars['String']['output']>
  socialSecurityNumber?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  subjectPropertyAddress?: Maybe<Scalars['String']['output']>
  subjectPropertyState?: Maybe<Scalars['String']['output']>
  taskAuditStatus?: Maybe<Scalars['String']['output']>
  taxes?: Maybe<Scalars['String']['output']>
  titleHeld?: Maybe<Scalars['String']['output']>
  titleOrdered?: Maybe<Scalars['Date']['output']>
  titlePrDate?: Maybe<Scalars['Date']['output']>
  titlePrStatus?: Maybe<Scalars['String']['output']>
  titleReceived?: Maybe<Scalars['Date']['output']>
  titleReportEffectiveDate?: Maybe<Scalars['Date']['output']>
  titleReportExpirationDate?: Maybe<Scalars['Date']['output']>
  totalPayoffs?: Maybe<Scalars['String']['output']>
  unitNumber?: Maybe<Scalars['String']['output']>
  unlockPercentage?: Maybe<Scalars['String']['output']>
  useOfProceeds?: Maybe<Scalars['JSON']['output']>
  uwSubmittedAt?: Maybe<Scalars['DateTime']['output']>
  valExpress?: Maybe<Scalars['Boolean']['output']>
  valuationReportExpected?: Maybe<Scalars['Date']['output']>
  wireToEscrowOn?: Maybe<Scalars['Date']['output']>
  yearBuilt?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type WorkQueuesFilter = {
  AND?: InputMaybe<WorkQueuesFilter>
  NOT?: InputMaybe<WorkQueuesFilter>
  OR?: InputMaybe<WorkQueuesFilter>
  pk: Scalars['ID']['input']
}

export type WorkQueuesInput = {
  adjustedExchangeRate?: InputMaybe<Scalars['String']['input']>
  agreementEffectiveOn?: InputMaybe<Scalars['Date']['input']>
  annualizedCostLimit?: InputMaybe<Scalars['String']['input']>
  annualizedCostLimitCalcVersion?: InputMaybe<Scalars['Int']['input']>
  applicants?: InputMaybe<Scalars['String']['input']>
  application: OneToOneInput
  applicationCreatedAt?: InputMaybe<Scalars['DateTime']['input']>
  applicationPartyName?: InputMaybe<Scalars['String']['input']>
  applicationState?: InputMaybe<Scalars['String']['input']>
  applicationStateIndex?: InputMaybe<Scalars['Int']['input']>
  applicationStateLabel?: InputMaybe<Scalars['String']['input']>
  applicationStateModifiedAt?: InputMaybe<Scalars['String']['input']>
  appraisalEffectiveDate?: InputMaybe<Scalars['Date']['input']>
  appraisalExpirationDate?: InputMaybe<Scalars['Date']['input']>
  appraisalOrdered?: InputMaybe<Scalars['Date']['input']>
  appraisalReceived?: InputMaybe<Scalars['Date']['input']>
  appraisalReviewStatus?: InputMaybe<Scalars['String']['input']>
  appraisalReviewStatusDate?: InputMaybe<Scalars['DateTime']['input']>
  appraisalType?: InputMaybe<Scalars['String']['input']>
  appraisedHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  approvedEscalations?: InputMaybe<Scalars['String']['input']>
  assessorParcelNumber?: InputMaybe<Scalars['String']['input']>
  automatedExceptions?: InputMaybe<Scalars['JSON']['input']>
  automatedFlags?: InputMaybe<Scalars['JSON']['input']>
  automatedReviewStatus?: InputMaybe<Scalars['String']['input']>
  avmVariance?: InputMaybe<Scalars['Decimal']['input']>
  bornOn?: InputMaybe<Scalars['String']['input']>
  calcApplicationFico?: InputMaybe<Scalars['Int']['input']>
  callCompleted?: InputMaybe<Scalars['Date']['input']>
  callScheduled?: InputMaybe<Scalars['DateTime']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  cltv?: InputMaybe<Scalars['Decimal']['input']>
  comparableFartherThanMile?: InputMaybe<Scalars['Boolean']['input']>
  comparableSalesRecency?: InputMaybe<Scalars['Int']['input']>
  completedCustomerTasks?: InputMaybe<Scalars['Int']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  dealTeams?: InputMaybe<Scalars['JSON']['input']>
  dealTeamsUserIds?: InputMaybe<Scalars['String']['input']>
  delayReasons?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedCloseOn?: InputMaybe<Scalars['Date']['input']>
  estimatedValueWithOverrides?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRate?: InputMaybe<Scalars['String']['input']>
  exchangeRateAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  ficoOverride?: InputMaybe<Scalars['Int']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  finalNetClosingProceeds?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  floodZoneHazardIndicator?: InputMaybe<Scalars['Boolean']['input']>
  followUp?: InputMaybe<Scalars['Date']['input']>
  grossAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  grossLivingArea?: InputMaybe<Scalars['String']['input']>
  homeFinanceLimit?: InputMaybe<Scalars['String']['input']>
  homeValueOverride?: InputMaybe<Scalars['Decimal']['input']>
  hubspotContactId?: InputMaybe<Scalars['String']['input']>
  incompleteCustomerTasks?: InputMaybe<Scalars['Int']['input']>
  inspectionScheduled?: InputMaybe<Scalars['Date']['input']>
  investmentPayment?: InputMaybe<Scalars['Decimal']['input']>
  investmentPercentage?: InputMaybe<Scalars['String']['input']>
  isMtgInquires?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lossReason?: InputMaybe<Scalars['String']['input']>
  lossType?: InputMaybe<Scalars['String']['input']>
  lotSize?: InputMaybe<Scalars['String']['input']>
  mailingAddress?: InputMaybe<Scalars['String']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  maxInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>
  minInvestmentOverride?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostHoa?: InputMaybe<Scalars['Decimal']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  netAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  opsDelayReasons?: InputMaybe<Scalars['String']['input']>
  outreachOpportunityId?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  pricingVersion?: InputMaybe<Scalars['Float']['input']>
  property?: InputMaybe<Scalars['JSON']['input']>
  propertyCondition?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodBuiltUpRangeType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodGrowthPaceType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodLocationType?: InputMaybe<Scalars['String']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyUsage?: InputMaybe<Scalars['String']['input']>
  receivedDocumentsCount?: InputMaybe<Scalars['Int']['input']>
  reportExpiresAt?: InputMaybe<Scalars['DateTime']['input']>
  reportOrderedAt?: InputMaybe<Scalars['Date']['input']>
  requestedDocumentsCount?: InputMaybe<Scalars['Int']['input']>
  requestedInvestment?: InputMaybe<Scalars['Decimal']['input']>
  roofSolarPanel?: InputMaybe<Scalars['Boolean']['input']>
  settlementAgent?: InputMaybe<Scalars['String']['input']>
  siteZoningClassificationIdentifier?: InputMaybe<Scalars['String']['input']>
  siteZoningComplianceType?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  subjectPropertyAddress?: InputMaybe<Scalars['String']['input']>
  subjectPropertyState?: InputMaybe<Scalars['String']['input']>
  taskAuditStatus?: InputMaybe<Scalars['String']['input']>
  taxes?: InputMaybe<Scalars['String']['input']>
  titleHeld?: InputMaybe<Scalars['String']['input']>
  titleOrdered?: InputMaybe<Scalars['Date']['input']>
  titlePrDate?: InputMaybe<Scalars['Date']['input']>
  titlePrStatus?: InputMaybe<Scalars['String']['input']>
  titleReceived?: InputMaybe<Scalars['Date']['input']>
  titleReportEffectiveDate?: InputMaybe<Scalars['Date']['input']>
  titleReportExpirationDate?: InputMaybe<Scalars['Date']['input']>
  totalPayoffs?: InputMaybe<Scalars['String']['input']>
  unitNumber?: InputMaybe<Scalars['String']['input']>
  unlockPercentage?: InputMaybe<Scalars['String']['input']>
  useOfProceeds?: InputMaybe<Scalars['JSON']['input']>
  uwSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>
  valExpress?: InputMaybe<Scalars['Boolean']['input']>
  valuationReportExpected?: InputMaybe<Scalars['Date']['input']>
  wireToEscrowOn?: InputMaybe<Scalars['Date']['input']>
  yearBuilt?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type WorkQueuesInputPartial = {
  adjustedExchangeRate?: InputMaybe<Scalars['String']['input']>
  agreementEffectiveOn?: InputMaybe<Scalars['Date']['input']>
  annualizedCostLimit?: InputMaybe<Scalars['String']['input']>
  annualizedCostLimitCalcVersion?: InputMaybe<Scalars['Int']['input']>
  applicants?: InputMaybe<Scalars['String']['input']>
  application?: InputMaybe<OneToOneInput>
  applicationCreatedAt?: InputMaybe<Scalars['DateTime']['input']>
  applicationPartyName?: InputMaybe<Scalars['String']['input']>
  applicationState?: InputMaybe<Scalars['String']['input']>
  applicationStateIndex?: InputMaybe<Scalars['Int']['input']>
  applicationStateLabel?: InputMaybe<Scalars['String']['input']>
  applicationStateModifiedAt?: InputMaybe<Scalars['String']['input']>
  appraisalEffectiveDate?: InputMaybe<Scalars['Date']['input']>
  appraisalExpirationDate?: InputMaybe<Scalars['Date']['input']>
  appraisalOrdered?: InputMaybe<Scalars['Date']['input']>
  appraisalReceived?: InputMaybe<Scalars['Date']['input']>
  appraisalReviewStatus?: InputMaybe<Scalars['String']['input']>
  appraisalReviewStatusDate?: InputMaybe<Scalars['DateTime']['input']>
  appraisalType?: InputMaybe<Scalars['String']['input']>
  appraisedHomeValue?: InputMaybe<Scalars['Decimal']['input']>
  approvedEscalations?: InputMaybe<Scalars['String']['input']>
  assessorParcelNumber?: InputMaybe<Scalars['String']['input']>
  automatedExceptions?: InputMaybe<Scalars['JSON']['input']>
  automatedFlags?: InputMaybe<Scalars['JSON']['input']>
  automatedReviewStatus?: InputMaybe<Scalars['String']['input']>
  avmVariance?: InputMaybe<Scalars['Decimal']['input']>
  bornOn?: InputMaybe<Scalars['String']['input']>
  calcApplicationFico?: InputMaybe<Scalars['Int']['input']>
  callCompleted?: InputMaybe<Scalars['Date']['input']>
  callScheduled?: InputMaybe<Scalars['DateTime']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  cltv?: InputMaybe<Scalars['Decimal']['input']>
  comparableFartherThanMile?: InputMaybe<Scalars['Boolean']['input']>
  comparableSalesRecency?: InputMaybe<Scalars['Int']['input']>
  completedCustomerTasks?: InputMaybe<Scalars['Int']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  dealTeams?: InputMaybe<Scalars['JSON']['input']>
  dealTeamsUserIds?: InputMaybe<Scalars['String']['input']>
  delayReasons?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  estimatedCloseOn?: InputMaybe<Scalars['Date']['input']>
  estimatedValueWithOverrides?: InputMaybe<Scalars['Decimal']['input']>
  exchangeRate?: InputMaybe<Scalars['String']['input']>
  exchangeRateAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  ficoOverride?: InputMaybe<Scalars['Int']['input']>
  fileNumber?: InputMaybe<Scalars['String']['input']>
  finalNetClosingProceeds?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  floodZoneHazardIndicator?: InputMaybe<Scalars['Boolean']['input']>
  followUp?: InputMaybe<Scalars['Date']['input']>
  grossAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  grossLivingArea?: InputMaybe<Scalars['String']['input']>
  homeFinanceLimit?: InputMaybe<Scalars['String']['input']>
  homeValueOverride?: InputMaybe<Scalars['Decimal']['input']>
  hubspotContactId?: InputMaybe<Scalars['String']['input']>
  incompleteCustomerTasks?: InputMaybe<Scalars['Int']['input']>
  inspectionScheduled?: InputMaybe<Scalars['Date']['input']>
  investmentPayment?: InputMaybe<Scalars['Decimal']['input']>
  investmentPercentage?: InputMaybe<Scalars['String']['input']>
  isMtgInquires?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lossReason?: InputMaybe<Scalars['String']['input']>
  lossType?: InputMaybe<Scalars['String']['input']>
  lotSize?: InputMaybe<Scalars['String']['input']>
  mailingAddress?: InputMaybe<Scalars['String']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  maxInvestmentAmount?: InputMaybe<Scalars['Decimal']['input']>
  minInvestmentOverride?: InputMaybe<Scalars['Decimal']['input']>
  monthlyCostHoa?: InputMaybe<Scalars['Decimal']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  netAdjustment?: InputMaybe<Scalars['Decimal']['input']>
  opsDelayReasons?: InputMaybe<Scalars['String']['input']>
  outreachOpportunityId?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  pricingVersion?: InputMaybe<Scalars['Float']['input']>
  property?: InputMaybe<Scalars['JSON']['input']>
  propertyCondition?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodBuiltUpRangeType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodGrowthPaceType?: InputMaybe<Scalars['String']['input']>
  propertyNeighborhoodLocationType?: InputMaybe<Scalars['String']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyUsage?: InputMaybe<Scalars['String']['input']>
  receivedDocumentsCount?: InputMaybe<Scalars['Int']['input']>
  reportExpiresAt?: InputMaybe<Scalars['DateTime']['input']>
  reportOrderedAt?: InputMaybe<Scalars['Date']['input']>
  requestedDocumentsCount?: InputMaybe<Scalars['Int']['input']>
  requestedInvestment?: InputMaybe<Scalars['Decimal']['input']>
  roofSolarPanel?: InputMaybe<Scalars['Boolean']['input']>
  settlementAgent?: InputMaybe<Scalars['String']['input']>
  siteZoningClassificationIdentifier?: InputMaybe<Scalars['String']['input']>
  siteZoningComplianceType?: InputMaybe<Scalars['String']['input']>
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  subjectPropertyAddress?: InputMaybe<Scalars['String']['input']>
  subjectPropertyState?: InputMaybe<Scalars['String']['input']>
  taskAuditStatus?: InputMaybe<Scalars['String']['input']>
  taxes?: InputMaybe<Scalars['String']['input']>
  titleHeld?: InputMaybe<Scalars['String']['input']>
  titleOrdered?: InputMaybe<Scalars['Date']['input']>
  titlePrDate?: InputMaybe<Scalars['Date']['input']>
  titlePrStatus?: InputMaybe<Scalars['String']['input']>
  titleReceived?: InputMaybe<Scalars['Date']['input']>
  titleReportEffectiveDate?: InputMaybe<Scalars['Date']['input']>
  titleReportExpirationDate?: InputMaybe<Scalars['Date']['input']>
  totalPayoffs?: InputMaybe<Scalars['String']['input']>
  unitNumber?: InputMaybe<Scalars['String']['input']>
  unlockPercentage?: InputMaybe<Scalars['String']['input']>
  useOfProceeds?: InputMaybe<Scalars['JSON']['input']>
  uwSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>
  valExpress?: InputMaybe<Scalars['Boolean']['input']>
  valuationReportExpected?: InputMaybe<Scalars['Date']['input']>
  wireToEscrowOn?: InputMaybe<Scalars['Date']['input']>
  yearBuilt?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type WorkQueuesOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type WorkQueuesPreset = {
  __typename?: 'WorkQueuesPreset'
  columnState?: Maybe<Scalars['JSON']['output']>
  companyPreset: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  filterModel?: Maybe<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  pk: Scalars['ID']['output']
  search?: Maybe<Scalars['String']['output']>
  stage?: Maybe<Scalars['String']['output']>
  subscribers?: Maybe<Scalars['String']['output']>
  user?: Maybe<DjangoModelType>
  uuid: Scalars['UUID']['output']
  viewAll?: Maybe<Scalars['Boolean']['output']>
  workQueuesPresets: Array<UserData>
}

export type WorkQueuesPresetWorkQueuesPresetsArgs = {
  filters?: InputMaybe<UserDataFilter>
  order?: InputMaybe<UserDataOrder>
}

export type WorkQueuesPresetFilter = {
  AND?: InputMaybe<WorkQueuesPresetFilter>
  NOT?: InputMaybe<WorkQueuesPresetFilter>
  OR?: InputMaybe<WorkQueuesPresetFilter>
  pk: Scalars['ID']['input']
}

export type WorkQueuesPresetInput = {
  columnState?: InputMaybe<Scalars['JSON']['input']>
  companyPreset?: InputMaybe<Scalars['Boolean']['input']>
  filterModel?: InputMaybe<Scalars['JSON']['input']>
  name: Scalars['String']['input']
  search?: InputMaybe<Scalars['String']['input']>
  stage?: InputMaybe<Scalars['String']['input']>
  subscribers?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<OneToManyInput>
  viewAll?: InputMaybe<Scalars['Boolean']['input']>
}

export type WorkQueuesPresetInputPartial = {
  columnState?: InputMaybe<Scalars['JSON']['input']>
  companyPreset?: InputMaybe<Scalars['Boolean']['input']>
  filterModel?: InputMaybe<Scalars['JSON']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pk: Scalars['ID']['input']
  search?: InputMaybe<Scalars['String']['input']>
  stage?: InputMaybe<Scalars['String']['input']>
  subscribers?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<OneToManyInput>
  viewAll?: InputMaybe<Scalars['Boolean']['input']>
}

export type WorkQueuesPresetOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type WorkQueuesPresetUpdatePayload = OperationInfo | WorkQueuesPreset

export type WorkQueuesUpdatePayload = OperationInfo | WorkQueues

export type ZendeskTicket = {
  __typename?: 'ZendeskTicket'
  application: Application
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  modifiedAt: Scalars['DateTime']['output']
  pk: Scalars['ID']['output']
  servicingTaskGroup: Array<ServicingTaskGroup>
  status: Scalars['String']['output']
  ticketId: Scalars['Int']['output']
  type: Scalars['String']['output']
  uuid: Scalars['UUID']['output']
}

export type ZendeskTicketServicingTaskGroupArgs = {
  filters?: InputMaybe<ServicingTaskGroupFilter>
  order?: InputMaybe<ServicingTaskGroupOrder>
}

export type ZendeskTicketFilter = {
  AND?: InputMaybe<ZendeskTicketFilter>
  NOT?: InputMaybe<ZendeskTicketFilter>
  OR?: InputMaybe<ZendeskTicketFilter>
  pk: Scalars['ID']['input']
}

export type ZendeskTicketInput = {
  application: OneToManyInput
  status?: InputMaybe<Scalars['String']['input']>
  ticketId: Scalars['Int']['input']
  type: Scalars['String']['input']
}

export type ZendeskTicketInputPartial = {
  application?: InputMaybe<OneToManyInput>
  pk: Scalars['ID']['input']
  status?: InputMaybe<Scalars['String']['input']>
  ticketId?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type ZendeskTicketOrder = {
  pk?: InputMaybe<Scalars['ID']['input']>
}

export type ZendeskTicketUpdatePayload = OperationInfo | ZendeskTicket

export type GetApplicationOfferCalcsQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetApplicationOfferCalcsQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    offerCalculations: {
      __typename?: 'OfferCalculationsType'
      maxEstimatedClosingCost?: number | null
      estimatedClosingCost?: number | null
      maxOfferPayoff?: number | null
      selectedOfferPayoff?: number | null
      netCashProceeds?: number | null
      netCashProceedsPrePayoffs?: number | null
      maxNetCashProceeds?: number | null
      offerCostBenefitRatio?: number | null
      maxCostBenefitRatio?: number | null
      exchangeRate?: number | null
      exchangeRateGuideline?: number | null
      annualizedCostLimit?: number | null
      annualizedCostLimitGuideline?: number | null
      maxInvestmentGuideline?: number | null
      aggregateInvestmentPayment?: number | null
      requestedThf?: number | null
      minHomeValue?: number | null
      investmentPropertyPremium?: number | null
      offerGuidelines?: {
        __typename?: 'CalculatedOffer'
        ltv?: number | null
        cltv?: number | null
        exchangeRate?: number | null
        thfLimit?: number | null
        annualizedCostLimit?: number | null
        error?: string | null
        offers?: {
          __typename?: 'Offers'
          offerInvestment?: number | null
          unlockShare?: number | null
          offerInvestmentPercentage?: number | null
          ctv?: number | null
          totalHomeFinance?: number | null
          totalHomeFinanceCap?: number | null
          exchangeRate?: number | null
          baseExchangeRate?: number | null
        } | null
      } | null
      selectedOffer?: {
        __typename?: 'CalculatedOffer'
        ltv?: number | null
        cltv?: number | null
        exchangeRate?: number | null
        thfLimit?: number | null
        annualizedCostLimit?: number | null
        error?: string | null
        minHomeValue?: number | null
        currentMinimumInvestmentSize?: number | null
        aggregateInvestmentPayment?: number | null
        minFico?: number | null
        errorMessage?: string | null
        offers?: {
          __typename?: 'Offers'
          offerInvestment?: number | null
          unlockShare?: number | null
          offerInvestmentPercentage?: number | null
          ctv?: number | null
          totalHomeFinance?: number | null
          totalHomeFinanceCap?: number | null
          exchangeRate?: number | null
          baseExchangeRate?: number | null
        } | null
      } | null
      maxOffer?: {
        __typename?: 'CalculatedOffer'
        ltv?: number | null
        cltv?: number | null
        exchangeRate?: number | null
        thfLimit?: number | null
        annualizedCostLimit?: number | null
        error?: string | null
        offers?: {
          __typename?: 'Offers'
          offerInvestment?: number | null
          unlockShare?: number | null
          offerInvestmentPercentage?: number | null
          ctv?: number | null
          totalHomeFinance?: number | null
          totalHomeFinanceCap?: number | null
          exchangeRate?: number | null
          baseExchangeRate?: number | null
        } | null
      } | null
      requestedOffer?: {
        __typename?: 'CalculatedRequestedOffer'
        ltv?: number | null
        cltv?: number | null
        thfLimit?: number | null
        error?: string | null
      } | null
    }
  }
}

export type GetApplicationCalcsQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetApplicationCalcsQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    applicationCalculations: {
      __typename?: 'ApplicationCalculationsType'
      calcApplicationFico?: number | null
      dti?: number | null
      dtiPrePayoffs?: number | null
      exceptionRequired?: boolean | null
      isDtiOverriden?: boolean | null
      isLockedIe?: boolean | null
      isServicing?: boolean | null
      lastBankruptcy?: any | null
      last90Deliquency?: any | null
      last120Deliquency?: any | null
      lastForeclosure?: any | null
      lastDeedInLieu?: any | null
      lastShortSale?: any | null
      referralPoints?: number | null
      referringAmount?: number | null
      bypass10Percent?: boolean | null
      isRefinance?: boolean | null
    }
  }
}

export type GetApplicationExpensesCalcsQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetApplicationExpensesCalcsQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    expensesCalculations: {
      __typename?: 'ExpensesCalculationsType'
      totalInvestmentCosts?: number | null
      totalInvestmentCostsAtClosing?: number | null
      totalInvestmentCostsBeforeClosing?: number | null
      taxesAndOtherGovernmentFeesTotal?: number | null
      taxesAndOtherGovernmentFeesTotalAtClosing?: number | null
      taxesAndOtherGovernmentFeesTotalBeforeClosing?: number | null
      originationChargeAmount?: number | null
      otherExpensesTotal?: number | null
      totalOtherExpenses?: number | null
      totalOtherExpensesAtClosing?: number | null
      totalOtherExpensesBeforeClosing?: number | null
      creditsTotal?: number | null
      totalFeesExpensesAndCredits?: number | null
      fundingWireAmount?: number | null
    }
  }
}

export type GetApplicationTitleCalcsQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetApplicationTitleCalcsQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    titleCalculations: {
      __typename?: 'TitleCalculationsType'
      titleOrdered?: any | null
      titleReceived?: any | null
    }
  }
}

export type GetApplicationTradelinesCalcsQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetApplicationTradelinesCalcsQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    tradelinesCalculations: {
      __typename?: 'TradelinesCalculationsType'
      maxPayoff?: number | null
      tradelinesTotalAccountBalance?: number | null
      tradelinesMinMonthlyPaymentTotal?: number | null
      tradelinesBalance?: number | null
      existingMortgageDebt?: number | null
      payoffMortgageDebt?: number | null
      postOriginationMortgageDebt?: number | null
      payoffsTotal?: number | null
      payoffsTotalAccountBalance?: number | null
      payingOffMortgageDebt?: number | null
      lienPosition?: string | null
      monthlyIncome?: number | null
      totalMonthlyIncome?: number | null
      monthlyDebt?: number | null
      monthlyDebtPrePayoffs?: number | null
      monthlyDebtReduction?: number | null
      monthlyDebtReductionPrePayoffs?: number | null
      monthlyPaymentAmountTotal?: number | null
    }
  }
}

export type GetApplicationValuationsCalcsQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetApplicationValuationsCalcsQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    valuationsCalculations: {
      __typename?: 'ValuationsCalculationsType'
      estimatedValueWithOverrides?: number | null
      avmVariance?: number | null
      propertyEstimatedValue?: number | null
      estimatedValue?: number | null
      estimatedHomeValue?: number | null
      cov?: number | null
      appraisalReceived?: any | null
      appraisalReviewStatus?: string | null
      appraisalOrdered?: any | null
      appraisalReport?: {
        __typename?: 'Valuation'
        additionalFeatures?: string | null
        adverseSiteConditions?: string | null
        appraisalReviewStatus?: string | null
        appraisalReviewStatusDate?: any | null
        avmVariance?: any | null
        comparableFartherThanMile?: boolean | null
        comparableSalesRecency?: number | null
        conditionOfAppraisalType?: string | null
        confidence?: number | null
        createdAt: any
        currentOccupancyType?: string | null
        deferredMaintenanceItems?: string | null
        deletedAt?: any | null
        effectiveDate?: any | null
        floodZoneHazardIndicator?: boolean | null
        grossAdjustment?: any | null
        inspectionScheduled?: any | null
        isEscalateToUam?: boolean | null
        isPud?: boolean | null
        isHoa?: boolean | null
        listedWithinPreviousYear?: string | null
        maxValue?: any | null
        minValue?: any | null
        modifiedAt: any
        netAdjustment?: any | null
        netGrossAdjustment?: number | null
        orderNumber?: string | null
        ordered?: any | null
        physicalDeficiency?: string | null
        propertyBaths?: any | null
        propertyBeds?: number | null
        propertyCondition?: string | null
        propertyNeighborhoodBuiltUpRangeType?: string | null
        propertyNeighborhoodGrowthPaceType?: string | null
        propertyNeighborhoodLocationType?: string | null
        propertySquareFeet?: any | null
        provider?: string | null
        providerId?: string | null
        received?: any | null
        siteZoningClassificationDescription?: string | null
        siteZoningClassificationIdentifier?: string | null
        siteZoningComplianceDescription?: string | null
        siteZoningComplianceType?: string | null
        startingHomeValue?: number | null
        type: string
        uuid: any
        valuationOn?: any | null
        valuationReportExpected?: any | null
        value?: any | null
      } | null
      primaryAvm?: {
        __typename?: 'Valuation'
        avmVariance?: any | null
        confidence?: number | null
        createdAt: any
        deletedAt?: any | null
        effectiveDate?: any | null
        orderNumber?: string | null
        ordered?: any | null
        type: string
        uuid: any
        valuationOn?: any | null
        valuationReportExpected?: any | null
        value?: any | null
        isPrimaryAvm?: boolean | null
      } | null
      secondaryValuation?: {
        __typename?: 'Valuation'
        avmVariance?: any | null
        confidence?: number | null
        createdAt: any
        deletedAt?: any | null
        effectiveDate?: any | null
        orderNumber?: string | null
        ordered?: any | null
        type: string
        uuid: any
        valuationOn?: any | null
        valuationReportExpected?: any | null
        value?: any | null
        isSecondary?: boolean | null
      } | null
    }
  }
}

export type GetInvestmentClosingDetailsDatesQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetInvestmentClosingDetailsDatesQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    ieIssueDate?: any | null
    icsIssueDate?: any | null
    icsEffectiveDate?: any | null
    wireToCustomerOn?: any | null
    ieInvestmentPayment?: any | null
    ieFeesExpensesAndCredits?: any | null
    ieClosingCostsPaidBeforeClosing?: any | null
    iePayoffAmount?: any | null
  }
}

export type GetApplicationQueryVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type GetApplicationQuery = {
  __typename?: 'Query'
  application: {
    __typename?: 'Application'
    agreementEffectiveOn?: any | null
    annualizedCostLimitCalcVersion?: number | null
    applicationFico?: any | null
    applicationState: string
    applicationStateIndex: number
    applicationStateLabel?: string | null
    applicationStateModifiedAt?: any | null
    atypicalityCheckVersion: number
    avmDecline?: string | null
    buyoutOn?: any | null
    callCompleted?: any | null
    contractVersionClosingInst: string
    contractVersionFsea: string
    contractVersionSecInst: string
    contractVersionUpl: string
    createdAt: any
    cxVersion: number
    declarationsVersion: number
    delayReasons?: string | null
    deletedAt?: any | null
    docusignEnvelopeId: string
    estimatedCloseOn?: any | null
    exchangeRateCalcVersion?: number | null
    expireAt?: any | null
    externalId: string
    fedReferenceNumber?: string | null
    followUp?: any | null
    fundingDate?: any | null
    hasPoaDocument?: boolean | null
    icsEffectiveDate?: any | null
    icsIssueDate?: any | null
    icsPreparedBy?: string | null
    icsSignedOn?: any | null
    id: number
    ieClosingCostsPaidBeforeClosing?: any | null
    ieFeesExpensesAndCredits?: any | null
    ieInvestmentPayment?: any | null
    ieIssueDate?: any | null
    iePayoffAmount?: any | null
    iePreparedBy?: string | null
    lossMeta?: any | null
    lossReason?: string | null
    subLossReasons: Array<string>
    lossType?: string | null
    maxOfferInvestment?: any | null
    modifiedAt: any
    name?: string | null
    noMortgageDebt: boolean
    opsDelayReasons?: string | null
    outreachOpportunityId?: number | null
    pendingRecordingOn?: any | null
    poaFlag?: boolean | null
    pricingVersion?: number | null
    readOnlyRequestedInvestment: boolean
    recordingOn?: any | null
    referralSource?: string | null
    referredDeal?: boolean | null
    requestedInvestment?: any | null
    salesCommentary?: string | null
    semanticCalcVersion?: string | null
    sharepointItemId?: string | null
    signDate?: any | null
    tasksVersion: number
    termYears?: number | null
    useOfProceeds?: string | null
    uuid: any
    uwSubmittedAt?: any | null
    wireToCustomerOn?: any | null
    wireToEscrowOn?: any | null
    manuallyCreated?: boolean | null
    creditReports: Array<{
      __typename?: 'CreditReport'
      fileNumber?: string | null
      isVantage: boolean
      isTriMerge: boolean
      hasFrozenScores: boolean
      inquiryLast90Days?: boolean | null
      reportOrderedAt?: any | null
      createdAt: any
      needsToBeDeclined?: string | null
      aanDenialReason?: Array<string> | null
      externalId: string
      applicants: Array<{
        __typename?: 'CreditReportApplicant'
        uuid: any
        id: string
        applicationProfile: { __typename?: 'ApplicationProfile'; id: string; uuid: any }
      }>
    }>
    atypicalityCheck?: {
      __typename?: 'AtypicalityCheck'
      uuid: any
      isMtgInquires?: boolean | null
    } | null
    profiles: Array<{
      __typename?: 'Profile'
      id: string
      firstName: string
      lastName: string
      photoIdExpire?: any | null
      fullName?: string | null
    }>
    property?: {
      __typename?: 'Property'
      aquiredOn?: any | null
      aquiredPrice?: any | null
      createdAt: any
      deletedAt?: any | null
      dtiEscrowStatus: string
      estimatedDebt: any
      estimatedUnpaidPrinciple?: any | null
      estimatedValue: any
      externalId: string
      id: number
      imageInformation?: any | null
      insuranceOrdered?: any | null
      insuranceReceived?: any | null
      isLeaseAgreementRequired: boolean
      modifiedAt: any
      monthlyCostFlood?: any | null
      monthlyCostHoa?: any | null
      monthlyCostInsuranceHazard?: any | null
      monthlyCostInsuranceMortgage?: any | null
      monthlyCostOther?: any | null
      monthlyCostPrincipleInterest?: any | null
      monthlyCostTaxes?: any | null
      monthlyGrossRent?: any | null
      name?: string | null
      occupancy?: string | null
      offerErrors?: string | null
      ownerVestingType?: string | null
      propertyType?: string | null
      propertyUsage?: string | null
      roofSolarPanel?: boolean | null
      titleHeld?: string | null
      titleVesting?: string | null
      units?: number | null
      uuid: any
      vestingNames?: string | null
      trusteeType?: string | null
      isHoa?: boolean | null
      address: {
        __typename?: 'Address'
        city: string
        county?: string | null
        externalId: string
        fipsCode?: string | null
        id: string
        latitude?: number | null
        longitude?: number | null
        parcelNumber?: string | null
        state?: string | null
        street?: string | null
        unitNumber?: string | null
        uuid: any
        zipCode?: string | null
      }
      profiles: Array<{ __typename?: 'Profile'; id: string }>
      hoas: Array<{
        __typename?: 'Hoa'
        id: string
        uuid: any
        name?: string | null
        paymentFrequency?: string | null
        yearlyAmount?: any | null
        paymentStatus?: string | null
        dueDate?: any | null
        accountNumber?: string | null
        balanceDue?: any | null
      }>
    } | null
    titleReport?: {
      __typename?: 'TitleReport'
      nextTaxDue?: any | null
      createdAt: any
      deletedAt?: any | null
      effectiveDate?: any | null
      fileNumber: string
      id: string
      legalDescription: string
      legalDescriptionAbbreviated?: string | null
      liens: string
      modifiedAt: any
      nooNameOfSpouse: string
      ordered?: any | null
      prReviewDate?: any | null
      prReviewStatus?: string | null
      received?: any | null
      settlementAgent: string
      taxes: string
      uuid: any
      annualTaxesDue?: any | null
      application: { __typename?: 'Application'; id: number }
    } | null
    relatedApplicationsToAddress: Array<{
      __typename?: 'Application'
      applicationState: string
      applicationStateLabel?: string | null
      applicationStateModifiedAt?: any | null
      externalId: string
      lossType?: string | null
      lossReason?: string | null
      subLossReasons: Array<string>
      offerInvestment?: any | null
    }>
    relatedApplicationsToSsn: Array<{
      __typename?: 'Application'
      applicationState: string
      applicationStateLabel?: string | null
      applicationStateModifiedAt?: any | null
      externalId: string
      lossType?: string | null
      lossReason?: string | null
      subLossReasons: Array<string>
      offerInvestment?: any | null
    }>
    valuations: Array<{
      __typename?: 'Valuation'
      id: string
      uuid: any
      type: string
      valExpress?: boolean | null
      valExpressOverride?: boolean | null
    }>
  }
}

export type ApplicationSubscriptionSubscriptionVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type ApplicationSubscriptionSubscription = {
  __typename?: 'Subscription'
  applicationSubscription: {
    __typename?: 'Application'
    agreementEffectiveOn?: any | null
    annualizedCostLimitCalcVersion?: number | null
    applicationFico?: any | null
    applicationState: string
    applicationStateIndex: number
    applicationStateLabel?: string | null
    applicationStateModifiedAt?: any | null
    atypicalityCheckVersion: number
    avmDecline?: string | null
    buyoutOn?: any | null
    callCompleted?: any | null
    contractVersionClosingInst: string
    contractVersionFsea: string
    contractVersionSecInst: string
    contractVersionUpl: string
    createdAt: any
    cxVersion: number
    declarationsVersion: number
    delayReasons?: string | null
    deletedAt?: any | null
    docusignEnvelopeId: string
    estimatedCloseOn?: any | null
    exchangeRateCalcVersion?: number | null
    expireAt?: any | null
    externalId: string
    fedReferenceNumber?: string | null
    followUp?: any | null
    fundingDate?: any | null
    hasPoaDocument?: boolean | null
    icsEffectiveDate?: any | null
    icsIssueDate?: any | null
    icsPreparedBy?: string | null
    icsSignedOn?: any | null
    id: number
    ieClosingCostsPaidBeforeClosing?: any | null
    ieFeesExpensesAndCredits?: any | null
    ieInvestmentPayment?: any | null
    ieIssueDate?: any | null
    iePayoffAmount?: any | null
    iePreparedBy?: string | null
    lossMeta?: any | null
    lossReason?: string | null
    subLossReasons: Array<string>
    lossType?: string | null
    maxOfferInvestment?: any | null
    modifiedAt: any
    name?: string | null
    noMortgageDebt: boolean
    opsDelayReasons?: string | null
    outreachOpportunityId?: number | null
    pendingRecordingOn?: any | null
    poaFlag?: boolean | null
    pricingVersion?: number | null
    readOnlyRequestedInvestment: boolean
    recordingOn?: any | null
    referralSource?: string | null
    referredDeal?: boolean | null
    requestedInvestment?: any | null
    salesCommentary?: string | null
    semanticCalcVersion?: string | null
    sharepointItemId?: string | null
    signDate?: any | null
    tasksVersion: number
    termYears?: number | null
    useOfProceeds?: string | null
    uuid: any
    uwSubmittedAt?: any | null
    wireToCustomerOn?: any | null
    wireToEscrowOn?: any | null
    manuallyCreated?: boolean | null
    creditReports: Array<{
      __typename?: 'CreditReport'
      fileNumber?: string | null
      isVantage: boolean
      isTriMerge: boolean
      hasFrozenScores: boolean
      reportOrderedAt?: any | null
      createdAt: any
      inquiryLast90Days?: boolean | null
      needsToBeDeclined?: string | null
      aanDenialReason?: Array<string> | null
      externalId: string
      applicants: Array<{
        __typename?: 'CreditReportApplicant'
        uuid: any
        id: string
        applicationProfile: { __typename?: 'ApplicationProfile'; id: string; uuid: any }
      }>
    }>
    atypicalityCheck?: {
      __typename?: 'AtypicalityCheck'
      uuid: any
      isMtgInquires?: boolean | null
    } | null
    profiles: Array<{
      __typename?: 'Profile'
      id: string
      firstName: string
      lastName: string
      photoIdExpire?: any | null
      fullName?: string | null
    }>
    property?: {
      __typename?: 'Property'
      aquiredOn?: any | null
      aquiredPrice?: any | null
      createdAt: any
      deletedAt?: any | null
      dtiEscrowStatus: string
      estimatedDebt: any
      estimatedUnpaidPrinciple?: any | null
      estimatedValue: any
      externalId: string
      id: number
      imageInformation?: any | null
      insuranceOrdered?: any | null
      insuranceReceived?: any | null
      isLeaseAgreementRequired: boolean
      modifiedAt: any
      monthlyCostFlood?: any | null
      monthlyCostHoa?: any | null
      monthlyCostInsuranceHazard?: any | null
      monthlyCostInsuranceMortgage?: any | null
      monthlyCostOther?: any | null
      monthlyCostPrincipleInterest?: any | null
      monthlyCostTaxes?: any | null
      monthlyGrossRent?: any | null
      name?: string | null
      occupancy?: string | null
      offerErrors?: string | null
      ownerVestingType?: string | null
      propertyType?: string | null
      propertyUsage?: string | null
      roofSolarPanel?: boolean | null
      titleHeld?: string | null
      titleVesting?: string | null
      units?: number | null
      uuid: any
      vestingNames?: string | null
      trusteeType?: string | null
      isHoa?: boolean | null
      address: {
        __typename?: 'Address'
        city: string
        county?: string | null
        externalId: string
        fipsCode?: string | null
        id: string
        latitude?: number | null
        longitude?: number | null
        parcelNumber?: string | null
        state?: string | null
        street?: string | null
        unitNumber?: string | null
        uuid: any
        zipCode?: string | null
      }
      profiles: Array<{ __typename?: 'Profile'; id: string }>
      hoas: Array<{
        __typename?: 'Hoa'
        id: string
        uuid: any
        name?: string | null
        paymentFrequency?: string | null
        yearlyAmount?: any | null
        paymentStatus?: string | null
        dueDate?: any | null
        accountNumber?: string | null
        balanceDue?: any | null
      }>
    } | null
    titleReport?: {
      __typename?: 'TitleReport'
      nextTaxDue?: any | null
      createdAt: any
      deletedAt?: any | null
      effectiveDate?: any | null
      fileNumber: string
      id: string
      legalDescription: string
      legalDescriptionAbbreviated?: string | null
      liens: string
      modifiedAt: any
      nooNameOfSpouse: string
      ordered?: any | null
      prReviewDate?: any | null
      prReviewStatus?: string | null
      received?: any | null
      settlementAgent: string
      taxes: string
      uuid: any
      annualTaxesDue?: any | null
      application: { __typename?: 'Application'; id: number }
    } | null
    relatedApplicationsToAddress: Array<{
      __typename?: 'Application'
      applicationState: string
      applicationStateLabel?: string | null
      applicationStateModifiedAt?: any | null
      externalId: string
      lossType?: string | null
      lossReason?: string | null
      subLossReasons: Array<string>
    }>
    relatedApplicationsToSsn: Array<{
      __typename?: 'Application'
      applicationState: string
      applicationStateLabel?: string | null
      applicationStateModifiedAt?: any | null
      externalId: string
      lossType?: string | null
      lossReason?: string | null
      subLossReasons: Array<string>
    }>
    valuations: Array<{
      __typename?: 'Valuation'
      id: string
      uuid: any
      type: string
      valExpress?: boolean | null
    }>
  }
}

export type ApplicationCalculationsSubscriptionSubscriptionVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type ApplicationCalculationsSubscriptionSubscription = {
  __typename?: 'Subscription'
  applicationCalculationsSubscription: {
    __typename?: 'ApplicationCalculationsType'
    calcApplicationFico?: number | null
    dti?: number | null
    dtiPrePayoffs?: number | null
    exceptionRequired?: boolean | null
    isDtiOverriden?: boolean | null
    isLockedIe?: boolean | null
    isServicing?: boolean | null
    lastBankruptcy?: any | null
    last90Deliquency?: any | null
    last120Deliquency?: any | null
    lastForeclosure?: any | null
    lastDeedInLieu?: any | null
    lastShortSale?: any | null
    referralPoints?: number | null
    referringAmount?: number | null
    bypass10Percent?: boolean | null
    isRefinance?: boolean | null
  }
}

export type OfferCalculationsSubscriptionSubscriptionVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type OfferCalculationsSubscriptionSubscription = {
  __typename?: 'Subscription'
  offerCalculationsSubscription: {
    __typename?: 'OfferCalculationsType'
    maxEstimatedClosingCost?: number | null
    estimatedClosingCost?: number | null
    maxOfferPayoff?: number | null
    selectedOfferPayoff?: number | null
    netCashProceeds?: number | null
    netCashProceedsPrePayoffs?: number | null
    maxNetCashProceeds?: number | null
    offerCostBenefitRatio?: number | null
    maxCostBenefitRatio?: number | null
    exchangeRate?: number | null
    exchangeRateGuideline?: number | null
    annualizedCostLimit?: number | null
    annualizedCostLimitGuideline?: number | null
    maxInvestmentGuideline?: number | null
    aggregateInvestmentPayment?: number | null
    requestedThf?: number | null
    minHomeValue?: number | null
    investmentPropertyPremium?: number | null
    offerGuidelines?: {
      __typename?: 'CalculatedOffer'
      ltv?: number | null
      cltv?: number | null
      exchangeRate?: number | null
      thfLimit?: number | null
      annualizedCostLimit?: number | null
      error?: string | null
      offers?: {
        __typename?: 'Offers'
        offerInvestment?: number | null
        unlockShare?: number | null
        offerInvestmentPercentage?: number | null
        ctv?: number | null
        totalHomeFinance?: number | null
        totalHomeFinanceCap?: number | null
        exchangeRate?: number | null
        baseExchangeRate?: number | null
      } | null
    } | null
    selectedOffer?: {
      __typename?: 'CalculatedOffer'
      ltv?: number | null
      cltv?: number | null
      exchangeRate?: number | null
      thfLimit?: number | null
      annualizedCostLimit?: number | null
      error?: string | null
      minHomeValue?: number | null
      currentMinimumInvestmentSize?: number | null
      minFico?: number | null
      errorMessage?: string | null
      aggregateInvestmentPayment?: number | null
      offers?: {
        __typename?: 'Offers'
        offerInvestment?: number | null
        unlockShare?: number | null
        offerInvestmentPercentage?: number | null
        ctv?: number | null
        totalHomeFinance?: number | null
        totalHomeFinanceCap?: number | null
        exchangeRate?: number | null
        baseExchangeRate?: number | null
      } | null
    } | null
    maxOffer?: {
      __typename?: 'CalculatedOffer'
      ltv?: number | null
      cltv?: number | null
      exchangeRate?: number | null
      thfLimit?: number | null
      annualizedCostLimit?: number | null
      error?: string | null
      offers?: {
        __typename?: 'Offers'
        offerInvestment?: number | null
        unlockShare?: number | null
        offerInvestmentPercentage?: number | null
        ctv?: number | null
        totalHomeFinance?: number | null
        totalHomeFinanceCap?: number | null
        exchangeRate?: number | null
        baseExchangeRate?: number | null
      } | null
    } | null
    requestedOffer?: {
      __typename?: 'CalculatedRequestedOffer'
      ltv?: number | null
      cltv?: number | null
      thfLimit?: number | null
      error?: string | null
    } | null
  }
}

export type ExpensesCalculationsSubscriptionSubscriptionVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type ExpensesCalculationsSubscriptionSubscription = {
  __typename?: 'Subscription'
  expensesCalculationsSubscription: {
    __typename?: 'ExpensesCalculationsType'
    totalInvestmentCosts?: number | null
    totalInvestmentCostsAtClosing?: number | null
    totalInvestmentCostsBeforeClosing?: number | null
    taxesAndOtherGovernmentFeesTotal?: number | null
    taxesAndOtherGovernmentFeesTotalAtClosing?: number | null
    taxesAndOtherGovernmentFeesTotalBeforeClosing?: number | null
    originationChargeAmount?: number | null
    otherExpensesTotal?: number | null
    totalOtherExpenses?: number | null
    totalOtherExpensesAtClosing?: number | null
    totalOtherExpensesBeforeClosing?: number | null
    creditsTotal?: number | null
    totalFeesExpensesAndCredits?: number | null
    fundingWireAmount?: number | null
  }
}

export type TitleCalculationsSubscriptionSubscriptionVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type TitleCalculationsSubscriptionSubscription = {
  __typename?: 'Subscription'
  titleCalculationsSubscription: {
    __typename?: 'TitleCalculationsType'
    titleOrdered?: any | null
    titleReceived?: any | null
  }
}

export type TradelinesCalculationsSubscriptionSubscriptionVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type TradelinesCalculationsSubscriptionSubscription = {
  __typename?: 'Subscription'
  tradelinesCalculationsSubscription: {
    __typename?: 'TradelinesCalculationsType'
    maxPayoff?: number | null
    tradelinesTotalAccountBalance?: number | null
    tradelinesMinMonthlyPaymentTotal?: number | null
    tradelinesBalance?: number | null
    existingMortgageDebt?: number | null
    payoffMortgageDebt?: number | null
    postOriginationMortgageDebt?: number | null
    payoffsTotal?: number | null
    payoffsTotalAccountBalance?: number | null
    payingOffMortgageDebt?: number | null
    lienPosition?: string | null
    monthlyIncome?: number | null
    totalMonthlyIncome?: number | null
    monthlyDebt?: number | null
    monthlyDebtPrePayoffs?: number | null
    monthlyDebtReduction?: number | null
    monthlyDebtReductionPrePayoffs?: number | null
    monthlyPaymentAmountTotal?: number | null
  }
}

export type ValuationsCalculationsSubscriptionSubscriptionVariables = Exact<{
  externalId: Scalars['String']['input']
}>

export type ValuationsCalculationsSubscriptionSubscription = {
  __typename?: 'Subscription'
  valuationsCalculationsSubscription: {
    __typename?: 'ValuationsCalculationsType'
    estimatedValueWithOverrides?: number | null
    avmVariance?: number | null
    propertyEstimatedValue?: number | null
    estimatedValue?: number | null
    estimatedHomeValue?: number | null
    cov?: number | null
    appraisalReceived?: any | null
    appraisalReviewStatus?: string | null
    appraisalOrdered?: any | null
    appraisalReport?: {
      __typename?: 'Valuation'
      additionalFeatures?: string | null
      adverseSiteConditions?: string | null
      appraisalReviewStatus?: string | null
      appraisalReviewStatusDate?: any | null
      avmVariance?: any | null
      comparableFartherThanMile?: boolean | null
      comparableSalesRecency?: number | null
      conditionOfAppraisalType?: string | null
      confidence?: number | null
      createdAt: any
      currentOccupancyType?: string | null
      deferredMaintenanceItems?: string | null
      deletedAt?: any | null
      effectiveDate?: any | null
      floodZoneHazardIndicator?: boolean | null
      grossAdjustment?: any | null
      inspectionScheduled?: any | null
      isEscalateToUam?: boolean | null
      isPud?: boolean | null
      isHoa?: boolean | null
      listedWithinPreviousYear?: string | null
      maxValue?: any | null
      minValue?: any | null
      modifiedAt: any
      netAdjustment?: any | null
      netGrossAdjustment?: number | null
      orderNumber?: string | null
      ordered?: any | null
      physicalDeficiency?: string | null
      propertyBaths?: any | null
      propertyBeds?: number | null
      propertyCondition?: string | null
      propertyNeighborhoodBuiltUpRangeType?: string | null
      propertyNeighborhoodGrowthPaceType?: string | null
      propertyNeighborhoodLocationType?: string | null
      propertySquareFeet?: any | null
      provider?: string | null
      providerId?: string | null
      received?: any | null
      siteZoningClassificationDescription?: string | null
      siteZoningClassificationIdentifier?: string | null
      siteZoningComplianceDescription?: string | null
      siteZoningComplianceType?: string | null
      startingHomeValue?: number | null
      type: string
      uuid: any
      valuationOn?: any | null
      valuationReportExpected?: any | null
      value?: any | null
    } | null
    primaryAvm?: {
      __typename?: 'Valuation'
      avmVariance?: any | null
      confidence?: number | null
      createdAt: any
      deletedAt?: any | null
      effectiveDate?: any | null
      orderNumber?: string | null
      ordered?: any | null
      type: string
      uuid: any
      valuationOn?: any | null
      valuationReportExpected?: any | null
      value?: any | null
      isPrimaryAvm?: boolean | null
    } | null
    secondaryValuation?: {
      __typename?: 'Valuation'
      avmVariance?: any | null
      confidence?: number | null
      createdAt: any
      deletedAt?: any | null
      effectiveDate?: any | null
      orderNumber?: string | null
      ordered?: any | null
      type: string
      uuid: any
      valuationOn?: any | null
      valuationReportExpected?: any | null
      value?: any | null
      isSecondary?: boolean | null
    } | null
  }
}

export const GetApplicationOfferCalcsDocument = `
    query getApplicationOfferCalcs($externalId: String!) {
  application(externalId: $externalId) {
    offerCalculations {
      offerGuidelines {
        ltv
        cltv
        exchangeRate
        thfLimit
        annualizedCostLimit
        offers {
          offerInvestment
          unlockShare
          offerInvestmentPercentage
          ctv
          totalHomeFinance
          totalHomeFinanceCap
          exchangeRate
          baseExchangeRate
        }
        error
      }
      selectedOffer {
        ltv
        cltv
        exchangeRate
        thfLimit
        annualizedCostLimit
        offers {
          offerInvestment
          unlockShare
          offerInvestmentPercentage
          ctv
          totalHomeFinance
          totalHomeFinanceCap
          exchangeRate
          baseExchangeRate
        }
        error
        minHomeValue
        currentMinimumInvestmentSize
        aggregateInvestmentPayment
        minFico
        errorMessage
      }
      maxOffer {
        ltv
        cltv
        exchangeRate
        thfLimit
        annualizedCostLimit
        offers {
          offerInvestment
          unlockShare
          offerInvestmentPercentage
          ctv
          totalHomeFinance
          totalHomeFinanceCap
          exchangeRate
          baseExchangeRate
        }
        error
      }
      requestedOffer {
        ltv
        cltv
        thfLimit
        error
      }
      maxEstimatedClosingCost
      estimatedClosingCost
      maxOfferPayoff
      selectedOfferPayoff
      netCashProceeds
      netCashProceedsPrePayoffs
      maxNetCashProceeds
      offerCostBenefitRatio
      maxCostBenefitRatio
      exchangeRate
      exchangeRateGuideline
      annualizedCostLimit
      annualizedCostLimitGuideline
      maxInvestmentGuideline
      aggregateInvestmentPayment
      requestedThf
      minHomeValue
      investmentPropertyPremium
    }
  }
}
    `
export const GetApplicationCalcsDocument = `
    query getApplicationCalcs($externalId: String!) {
  application(externalId: $externalId) {
    applicationCalculations {
      calcApplicationFico
      dti
      dtiPrePayoffs
      exceptionRequired
      isDtiOverriden
      isLockedIe
      isServicing
      lastBankruptcy
      last90Deliquency
      last120Deliquency
      lastForeclosure
      lastDeedInLieu
      lastShortSale
      referralPoints
      referringAmount
      bypass10Percent
      isRefinance
    }
  }
}
    `
export const GetApplicationExpensesCalcsDocument = `
    query getApplicationExpensesCalcs($externalId: String!) {
  application(externalId: $externalId) {
    expensesCalculations {
      totalInvestmentCosts
      totalInvestmentCostsAtClosing
      totalInvestmentCostsBeforeClosing
      taxesAndOtherGovernmentFeesTotal
      taxesAndOtherGovernmentFeesTotalAtClosing
      taxesAndOtherGovernmentFeesTotalBeforeClosing
      originationChargeAmount
      otherExpensesTotal
      totalOtherExpenses
      totalOtherExpensesAtClosing
      totalOtherExpensesBeforeClosing
      creditsTotal
      totalFeesExpensesAndCredits
      fundingWireAmount
    }
  }
}
    `
export const GetApplicationTitleCalcsDocument = `
    query getApplicationTitleCalcs($externalId: String!) {
  application(externalId: $externalId) {
    titleCalculations {
      titleOrdered
      titleReceived
    }
  }
}
    `
export const GetApplicationTradelinesCalcsDocument = `
    query getApplicationTradelinesCalcs($externalId: String!) {
  application(externalId: $externalId) {
    tradelinesCalculations {
      maxPayoff
      tradelinesTotalAccountBalance
      tradelinesMinMonthlyPaymentTotal
      tradelinesBalance
      existingMortgageDebt
      payoffMortgageDebt
      postOriginationMortgageDebt
      payoffsTotal
      payoffsTotalAccountBalance
      payingOffMortgageDebt
      lienPosition
      monthlyIncome
      totalMonthlyIncome
      monthlyDebt
      monthlyDebtPrePayoffs
      monthlyDebtReduction
      monthlyDebtReductionPrePayoffs
      monthlyPaymentAmountTotal
    }
  }
}
    `
export const GetApplicationValuationsCalcsDocument = `
    query getApplicationValuationsCalcs($externalId: String!) {
  application(externalId: $externalId) {
    valuationsCalculations {
      estimatedValueWithOverrides
      avmVariance
      propertyEstimatedValue
      estimatedValue
      estimatedHomeValue
      cov
      appraisalReport {
        additionalFeatures
        adverseSiteConditions
        appraisalReviewStatus
        appraisalReviewStatusDate
        avmVariance
        comparableFartherThanMile
        comparableSalesRecency
        conditionOfAppraisalType
        confidence
        createdAt
        currentOccupancyType
        deferredMaintenanceItems
        deletedAt
        effectiveDate
        floodZoneHazardIndicator
        grossAdjustment
        inspectionScheduled
        isEscalateToUam
        isPud
        isHoa
        listedWithinPreviousYear
        maxValue
        minValue
        modifiedAt
        netAdjustment
        netGrossAdjustment
        orderNumber
        ordered
        physicalDeficiency
        propertyBaths
        propertyBeds
        propertyCondition
        propertyNeighborhoodBuiltUpRangeType
        propertyNeighborhoodGrowthPaceType
        propertyNeighborhoodLocationType
        propertySquareFeet
        provider
        providerId
        received
        siteZoningClassificationDescription
        siteZoningClassificationIdentifier
        siteZoningComplianceDescription
        siteZoningComplianceType
        startingHomeValue
        type
        uuid
        valuationOn
        valuationReportExpected
        value
      }
      appraisalReceived
      appraisalReviewStatus
      appraisalOrdered
      primaryAvm {
        avmVariance
        confidence
        createdAt
        deletedAt
        effectiveDate
        orderNumber
        ordered
        type
        uuid
        valuationOn
        valuationReportExpected
        value
        isPrimaryAvm
      }
      secondaryValuation {
        avmVariance
        confidence
        createdAt
        deletedAt
        effectiveDate
        orderNumber
        ordered
        type
        uuid
        valuationOn
        valuationReportExpected
        value
        isSecondary
      }
    }
  }
}
    `
export const GetInvestmentClosingDetailsDatesDocument = `
    query getInvestmentClosingDetailsDates($externalId: String!) {
  application(externalId: $externalId) {
    ieIssueDate
    icsIssueDate
    icsEffectiveDate
    wireToCustomerOn
    ieInvestmentPayment
    ieFeesExpensesAndCredits
    ieClosingCostsPaidBeforeClosing
    iePayoffAmount
  }
}
    `
export const GetApplicationDocument = `
    query getApplication($externalId: String!) {
  application(externalId: $externalId) {
    agreementEffectiveOn
    annualizedCostLimitCalcVersion
    applicationFico
    applicationState
    applicationStateIndex
    applicationStateLabel
    applicationStateModifiedAt
    atypicalityCheckVersion
    avmDecline
    buyoutOn
    callCompleted
    creditReports {
      fileNumber
      isVantage
      isTriMerge
      hasFrozenScores
      inquiryLast90Days
      reportOrderedAt
      createdAt
      needsToBeDeclined
      aanDenialReason
      applicants {
        uuid
        id
        applicationProfile {
          id
          uuid
        }
      }
      externalId
    }
    atypicalityCheck {
      uuid
      isMtgInquires
    }
    contractVersionClosingInst
    contractVersionFsea
    contractVersionSecInst
    contractVersionUpl
    createdAt
    cxVersion
    declarationsVersion
    delayReasons
    deletedAt
    docusignEnvelopeId
    estimatedCloseOn
    exchangeRateCalcVersion
    expireAt
    externalId
    fedReferenceNumber
    followUp
    fundingDate
    hasPoaDocument
    icsEffectiveDate
    icsIssueDate
    icsPreparedBy
    icsSignedOn
    id
    ieClosingCostsPaidBeforeClosing
    ieFeesExpensesAndCredits
    ieInvestmentPayment
    ieIssueDate
    iePayoffAmount
    iePreparedBy
    lossMeta
    lossReason
    subLossReasons
    lossType
    maxOfferInvestment
    modifiedAt
    name
    noMortgageDebt
    opsDelayReasons
    outreachOpportunityId
    pendingRecordingOn
    poaFlag
    pricingVersion
    profiles {
      id
      firstName
      lastName
      photoIdExpire
      fullName
    }
    property {
      address {
        city
        county
        externalId
        fipsCode
        id
        latitude
        longitude
        parcelNumber
        state
        street
        unitNumber
        uuid
        zipCode
      }
      aquiredOn
      aquiredPrice
      createdAt
      deletedAt
      dtiEscrowStatus
      estimatedDebt
      estimatedUnpaidPrinciple
      estimatedValue
      externalId
      id
      imageInformation
      insuranceOrdered
      insuranceReceived
      isLeaseAgreementRequired
      modifiedAt
      monthlyCostFlood
      monthlyCostHoa
      monthlyCostInsuranceHazard
      monthlyCostInsuranceMortgage
      monthlyCostOther
      monthlyCostPrincipleInterest
      monthlyCostTaxes
      monthlyGrossRent
      name
      occupancy
      offerErrors
      ownerVestingType
      profiles {
        id
      }
      propertyType
      propertyUsage
      roofSolarPanel
      titleHeld
      titleVesting
      units
      uuid
      vestingNames
      trusteeType
      hoas {
        id
        uuid
        name
        paymentFrequency
        yearlyAmount
        paymentStatus
        dueDate
        accountNumber
        balanceDue
      }
      isHoa
    }
    readOnlyRequestedInvestment
    recordingOn
    referralSource
    referredDeal
    requestedInvestment
    salesCommentary
    semanticCalcVersion
    sharepointItemId
    signDate
    tasksVersion
    termYears
    titleReport {
      application {
        id
      }
      nextTaxDue
      createdAt
      deletedAt
      effectiveDate
      fileNumber
      id
      legalDescription
      legalDescriptionAbbreviated
      liens
      modifiedAt
      nooNameOfSpouse
      ordered
      prReviewDate
      prReviewStatus
      received
      settlementAgent
      taxes
      uuid
      annualTaxesDue
    }
    useOfProceeds
    uuid
    uwSubmittedAt
    wireToCustomerOn
    wireToEscrowOn
    relatedApplicationsToAddress {
      applicationState
      applicationStateLabel
      applicationStateModifiedAt
      externalId
      lossType
      lossReason
      subLossReasons
      offerInvestment
    }
    relatedApplicationsToSsn {
      applicationState
      applicationStateLabel
      applicationStateModifiedAt
      externalId
      lossType
      lossReason
      subLossReasons
      offerInvestment
    }
    manuallyCreated
    valuations {
      id
      uuid
      type
      valExpress
      valExpressOverride
    }
  }
}
    `
export const ApplicationSubscriptionDocument = `
    subscription applicationSubscription($externalId: String!) {
  applicationSubscription(externalId: $externalId) {
    agreementEffectiveOn
    annualizedCostLimitCalcVersion
    applicationFico
    applicationState
    applicationStateIndex
    applicationStateLabel
    applicationStateModifiedAt
    atypicalityCheckVersion
    avmDecline
    buyoutOn
    callCompleted
    creditReports {
      fileNumber
      isVantage
      isTriMerge
      hasFrozenScores
      reportOrderedAt
      createdAt
      inquiryLast90Days
      needsToBeDeclined
      aanDenialReason
      applicants {
        uuid
        id
        applicationProfile {
          id
          uuid
        }
      }
      externalId
    }
    atypicalityCheck {
      uuid
      isMtgInquires
    }
    contractVersionClosingInst
    contractVersionFsea
    contractVersionSecInst
    contractVersionUpl
    createdAt
    cxVersion
    declarationsVersion
    delayReasons
    deletedAt
    docusignEnvelopeId
    estimatedCloseOn
    exchangeRateCalcVersion
    expireAt
    externalId
    fedReferenceNumber
    followUp
    fundingDate
    hasPoaDocument
    icsEffectiveDate
    icsIssueDate
    icsPreparedBy
    icsSignedOn
    id
    ieClosingCostsPaidBeforeClosing
    ieFeesExpensesAndCredits
    ieInvestmentPayment
    ieIssueDate
    iePayoffAmount
    iePreparedBy
    lossMeta
    lossReason
    subLossReasons
    lossType
    maxOfferInvestment
    modifiedAt
    name
    noMortgageDebt
    opsDelayReasons
    outreachOpportunityId
    pendingRecordingOn
    poaFlag
    pricingVersion
    profiles {
      id
      firstName
      lastName
      photoIdExpire
      fullName
    }
    property {
      address {
        city
        county
        externalId
        fipsCode
        id
        latitude
        longitude
        parcelNumber
        state
        street
        unitNumber
        uuid
        zipCode
      }
      aquiredOn
      aquiredPrice
      createdAt
      deletedAt
      dtiEscrowStatus
      estimatedDebt
      estimatedUnpaidPrinciple
      estimatedValue
      externalId
      id
      imageInformation
      insuranceOrdered
      insuranceReceived
      isLeaseAgreementRequired
      modifiedAt
      monthlyCostFlood
      monthlyCostHoa
      monthlyCostInsuranceHazard
      monthlyCostInsuranceMortgage
      monthlyCostOther
      monthlyCostPrincipleInterest
      monthlyCostTaxes
      monthlyGrossRent
      name
      occupancy
      offerErrors
      ownerVestingType
      profiles {
        id
      }
      propertyType
      propertyUsage
      roofSolarPanel
      titleHeld
      titleVesting
      units
      uuid
      vestingNames
      trusteeType
      hoas {
        id
        uuid
        name
        paymentFrequency
        yearlyAmount
        paymentStatus
        dueDate
        accountNumber
        balanceDue
      }
      isHoa
    }
    readOnlyRequestedInvestment
    recordingOn
    referralSource
    referredDeal
    requestedInvestment
    salesCommentary
    semanticCalcVersion
    sharepointItemId
    signDate
    tasksVersion
    termYears
    titleReport {
      application {
        id
      }
      nextTaxDue
      createdAt
      deletedAt
      effectiveDate
      fileNumber
      id
      legalDescription
      legalDescriptionAbbreviated
      liens
      modifiedAt
      nooNameOfSpouse
      ordered
      prReviewDate
      prReviewStatus
      received
      settlementAgent
      taxes
      uuid
      annualTaxesDue
    }
    useOfProceeds
    uuid
    uwSubmittedAt
    wireToCustomerOn
    wireToEscrowOn
    relatedApplicationsToAddress {
      applicationState
      applicationStateLabel
      applicationStateModifiedAt
      externalId
      lossType
      lossReason
      subLossReasons
    }
    relatedApplicationsToSsn {
      applicationState
      applicationStateLabel
      applicationStateModifiedAt
      externalId
      lossType
      lossReason
      subLossReasons
    }
    manuallyCreated
    valuations {
      id
      uuid
      type
      valExpress
    }
  }
}
    `
export const ApplicationCalculationsSubscriptionDocument = `
    subscription applicationCalculationsSubscription($externalId: String!) {
  applicationCalculationsSubscription(externalId: $externalId) {
    calcApplicationFico
    dti
    dtiPrePayoffs
    exceptionRequired
    isDtiOverriden
    isLockedIe
    isServicing
    lastBankruptcy
    last90Deliquency
    last120Deliquency
    lastForeclosure
    lastDeedInLieu
    lastShortSale
    referralPoints
    referringAmount
    bypass10Percent
    isRefinance
  }
}
    `
export const OfferCalculationsSubscriptionDocument = `
    subscription offerCalculationsSubscription($externalId: String!) {
  offerCalculationsSubscription(externalId: $externalId) {
    offerGuidelines {
      ltv
      cltv
      exchangeRate
      thfLimit
      annualizedCostLimit
      offers {
        offerInvestment
        unlockShare
        offerInvestmentPercentage
        ctv
        totalHomeFinance
        totalHomeFinanceCap
        exchangeRate
        baseExchangeRate
      }
      error
    }
    selectedOffer {
      ltv
      cltv
      exchangeRate
      thfLimit
      annualizedCostLimit
      offers {
        offerInvestment
        unlockShare
        offerInvestmentPercentage
        ctv
        totalHomeFinance
        totalHomeFinanceCap
        exchangeRate
        baseExchangeRate
      }
      error
      minHomeValue
      currentMinimumInvestmentSize
      minFico
      errorMessage
      aggregateInvestmentPayment
    }
    maxOffer {
      ltv
      cltv
      exchangeRate
      thfLimit
      annualizedCostLimit
      offers {
        offerInvestment
        unlockShare
        offerInvestmentPercentage
        ctv
        totalHomeFinance
        totalHomeFinanceCap
        exchangeRate
        baseExchangeRate
      }
      error
    }
    requestedOffer {
      ltv
      cltv
      thfLimit
      error
    }
    maxEstimatedClosingCost
    estimatedClosingCost
    maxOfferPayoff
    selectedOfferPayoff
    netCashProceeds
    netCashProceedsPrePayoffs
    maxNetCashProceeds
    offerCostBenefitRatio
    maxCostBenefitRatio
    exchangeRate
    exchangeRateGuideline
    annualizedCostLimit
    annualizedCostLimitGuideline
    maxInvestmentGuideline
    aggregateInvestmentPayment
    requestedThf
    minHomeValue
    investmentPropertyPremium
  }
}
    `
export const ExpensesCalculationsSubscriptionDocument = `
    subscription expensesCalculationsSubscription($externalId: String!) {
  expensesCalculationsSubscription(externalId: $externalId) {
    totalInvestmentCosts
    totalInvestmentCostsAtClosing
    totalInvestmentCostsBeforeClosing
    taxesAndOtherGovernmentFeesTotal
    taxesAndOtherGovernmentFeesTotalAtClosing
    taxesAndOtherGovernmentFeesTotalBeforeClosing
    originationChargeAmount
    otherExpensesTotal
    totalOtherExpenses
    totalOtherExpensesAtClosing
    totalOtherExpensesBeforeClosing
    creditsTotal
    totalFeesExpensesAndCredits
    fundingWireAmount
  }
}
    `
export const TitleCalculationsSubscriptionDocument = `
    subscription titleCalculationsSubscription($externalId: String!) {
  titleCalculationsSubscription(externalId: $externalId) {
    titleOrdered
    titleReceived
  }
}
    `
export const TradelinesCalculationsSubscriptionDocument = `
    subscription tradelinesCalculationsSubscription($externalId: String!) {
  tradelinesCalculationsSubscription(externalId: $externalId) {
    maxPayoff
    tradelinesTotalAccountBalance
    tradelinesMinMonthlyPaymentTotal
    tradelinesBalance
    existingMortgageDebt
    payoffMortgageDebt
    postOriginationMortgageDebt
    payoffsTotal
    payoffsTotalAccountBalance
    payingOffMortgageDebt
    lienPosition
    monthlyIncome
    totalMonthlyIncome
    monthlyDebt
    monthlyDebtPrePayoffs
    monthlyDebtReduction
    monthlyDebtReductionPrePayoffs
    monthlyPaymentAmountTotal
  }
}
    `
export const ValuationsCalculationsSubscriptionDocument = `
    subscription valuationsCalculationsSubscription($externalId: String!) {
  valuationsCalculationsSubscription(externalId: $externalId) {
    estimatedValueWithOverrides
    avmVariance
    propertyEstimatedValue
    estimatedValue
    estimatedHomeValue
    cov
    appraisalReport {
      additionalFeatures
      adverseSiteConditions
      appraisalReviewStatus
      appraisalReviewStatusDate
      avmVariance
      comparableFartherThanMile
      comparableSalesRecency
      conditionOfAppraisalType
      confidence
      createdAt
      currentOccupancyType
      deferredMaintenanceItems
      deletedAt
      effectiveDate
      floodZoneHazardIndicator
      grossAdjustment
      inspectionScheduled
      isEscalateToUam
      isPud
      isHoa
      listedWithinPreviousYear
      maxValue
      minValue
      modifiedAt
      netAdjustment
      netGrossAdjustment
      orderNumber
      ordered
      physicalDeficiency
      propertyBaths
      propertyBeds
      propertyCondition
      propertyNeighborhoodBuiltUpRangeType
      propertyNeighborhoodGrowthPaceType
      propertyNeighborhoodLocationType
      propertySquareFeet
      provider
      providerId
      received
      siteZoningClassificationDescription
      siteZoningClassificationIdentifier
      siteZoningComplianceDescription
      siteZoningComplianceType
      startingHomeValue
      type
      uuid
      valuationOn
      valuationReportExpected
      value
    }
    appraisalReceived
    appraisalReviewStatus
    appraisalOrdered
    primaryAvm {
      avmVariance
      confidence
      createdAt
      deletedAt
      effectiveDate
      orderNumber
      ordered
      type
      uuid
      valuationOn
      valuationReportExpected
      value
      isPrimaryAvm
    }
    secondaryValuation {
      avmVariance
      confidence
      createdAt
      deletedAt
      effectiveDate
      orderNumber
      ordered
      type
      uuid
      valuationOn
      valuationReportExpected
      value
      isSecondary
    }
  }
}
    `

const injectedRtkApi = graphqlApi.injectEndpoints({
  endpoints: (build) => ({
    getApplicationOfferCalcs: build.query<
      GetApplicationOfferCalcsQuery,
      GetApplicationOfferCalcsQueryVariables
    >({
      query: (variables) => ({ document: GetApplicationOfferCalcsDocument, variables }),
    }),
    getApplicationCalcs: build.query<GetApplicationCalcsQuery, GetApplicationCalcsQueryVariables>({
      query: (variables) => ({ document: GetApplicationCalcsDocument, variables }),
    }),
    getApplicationExpensesCalcs: build.query<
      GetApplicationExpensesCalcsQuery,
      GetApplicationExpensesCalcsQueryVariables
    >({
      query: (variables) => ({ document: GetApplicationExpensesCalcsDocument, variables }),
    }),
    getApplicationTitleCalcs: build.query<
      GetApplicationTitleCalcsQuery,
      GetApplicationTitleCalcsQueryVariables
    >({
      query: (variables) => ({ document: GetApplicationTitleCalcsDocument, variables }),
    }),
    getApplicationTradelinesCalcs: build.query<
      GetApplicationTradelinesCalcsQuery,
      GetApplicationTradelinesCalcsQueryVariables
    >({
      query: (variables) => ({ document: GetApplicationTradelinesCalcsDocument, variables }),
    }),
    getApplicationValuationsCalcs: build.query<
      GetApplicationValuationsCalcsQuery,
      GetApplicationValuationsCalcsQueryVariables
    >({
      query: (variables) => ({ document: GetApplicationValuationsCalcsDocument, variables }),
    }),
    getInvestmentClosingDetailsDates: build.query<
      GetInvestmentClosingDetailsDatesQuery,
      GetInvestmentClosingDetailsDatesQueryVariables
    >({
      query: (variables) => ({ document: GetInvestmentClosingDetailsDatesDocument, variables }),
    }),
    getApplication: build.query<GetApplicationQuery, GetApplicationQueryVariables>({
      query: (variables) => ({ document: GetApplicationDocument, variables }),
    }),
  }),
})

export { injectedRtkApi as api }
export const {
  useGetApplicationOfferCalcsQuery,
  useLazyGetApplicationOfferCalcsQuery,
  useGetApplicationCalcsQuery,
  useLazyGetApplicationCalcsQuery,
  useGetApplicationExpensesCalcsQuery,
  useLazyGetApplicationExpensesCalcsQuery,
  useGetApplicationTitleCalcsQuery,
  useLazyGetApplicationTitleCalcsQuery,
  useGetApplicationTradelinesCalcsQuery,
  useLazyGetApplicationTradelinesCalcsQuery,
  useGetApplicationValuationsCalcsQuery,
  useLazyGetApplicationValuationsCalcsQuery,
  useGetInvestmentClosingDetailsDatesQuery,
  useLazyGetInvestmentClosingDetailsDatesQuery,
  useGetApplicationQuery,
  useLazyGetApplicationQuery,
} = injectedRtkApi
